<template>
  <div class="website">
    <div id="gatsby-focus-wrapper" style="outline:none" tabindex="-1">
      <div class="style__StyledPageWrapper-sc-h9o74u-0 dKTwmI">
        <div class="sc-hHEiqL iyDqRv">
          <div class="sc-dlMDgC hVERnw">
            <div class="sc-kfYoZR cAqmaJ sc-fKgJPI cxbltl">
              <div class="sc-cxNHIi fHUQtx">
                <div class="sc-iwajpm hmxyOL">
                  <div class="sc-iemWCZ bzdhQC">
                    <img :src="logo|cdnurl"
                         alt=""
                         style="max-width:100%;display:block;position:static">
                  </div>
                </div>
              </div>
              <nav class="sc-kfYoZR rQVrw sc-bCwfaz sc-lmgQwP iXQYYt hpRDUw">
                <div class="sc-kfYoZR gwFRLa sc-bYwzuL hPERJB">
                  <div class="sc-kLojOw ijRzoh">
                    <a class="sc-kEqXSa chWJcF sc-iklJeh hbusih" color="default"
                       @click="showLoginDialog=true">
                      <span class="sc-pNWdM XJxhY">For businesses</span>
                    </a>
                  </div>
                  <div class="sc-kLojOw faTBaw">
                    <div class="style__SeparatorMobile-sc-1ceufpk-0 zLqvh"></div>
                  </div>
                  <div class="sc-kLojOw ijRzoh">
                    <nav aria-labelledby="button-menu-uid-4817247294-5">
                      <ul class="style__DisclosureMenuContent-sc-19d5cj-1 iUOrPP">
                        <li>
                          <button id="button-menu-uid-4817247294-5"
                                  aria-controls="uid-4817247294-5"
                                  aria-expanded="false"
                                  class="sc-bqGGPW sc-ksluID style__ButtonMenu-sc-19d5cj-0 iPexDg jZVOKR fQBbke"
                                  color="ghost"
                                  type="button">
                                                        <span class="style__Label-sc-1dh24tn-0 gUojGE">
                                                            <span class="sc-jJMGnK laKGqb">Display language:</span>
                                                            <svg aria-hidden="true"
                                                                 class="sc-bdnxRM dRIyKz style__StyledIcon-sc-1dh24tn-1 hNsYGX"
                                                                 fill="#151515"
                                                                 focusable="false"
                                                                 viewBox="0 0 32 32">
                                                                <path
                                                                    d="M16 3C13.4288 3 10.9154 3.76244 8.77759 5.1909C6.63975 6.61935 4.97351 8.64968 3.98957 11.0251C3.00563 13.4006 2.74819 16.0144 3.2498 18.5362C3.75141 21.0579 4.98953 23.3743 6.80762 25.1924C8.6257 27.0105 10.9421 28.2486 13.4638 28.7502C15.9856 29.2518 18.5995 28.9944 20.9749 28.0104C23.3503 27.0265 25.3807 25.3603 26.8091 23.2224C28.2376 21.0846 29 18.5712 29 16C28.9964 12.5533 27.6256 9.24882 25.1884 6.81163C22.7512 4.37445 19.4467 3.00364 16 3ZM12.7038 21H19.2963C18.625 23.2925 17.5 25.3587 16 26.9862C14.5 25.3587 13.375 23.2925 12.7038 21ZM12.25 19C11.9183 17.0138 11.9183 14.9862 12.25 13H19.75C20.0817 14.9862 20.0817 17.0138 19.75 19H12.25ZM5.00001 16C4.99914 14.9855 5.13923 13.9759 5.41626 13H10.2238C9.92542 14.9889 9.92542 17.0111 10.2238 19H5.41626C5.13923 18.0241 4.99914 17.0145 5.00001 16ZM19.2963 11H12.7038C13.375 8.7075 14.5 6.64125 16 5.01375C17.5 6.64125 18.625 8.7075 19.2963 11ZM21.7763 13H26.5838C27.1388 14.9615 27.1388 17.0385 26.5838 19H21.7763C22.0746 17.0111 22.0746 14.9889 21.7763 13ZM25.7963 11H21.3675C20.8572 8.99189 20.0001 7.0883 18.835 5.375C20.3236 5.77503 21.7119 6.48215 22.9108 7.45091C24.1097 8.41967 25.0926 9.62861 25.7963 11ZM13.165 5.375C11.9999 7.0883 11.1428 8.99189 10.6325 11H6.20376C6.90741 9.62861 7.89029 8.41967 9.08918 7.45091C10.2881 6.48215 11.6764 5.77503 13.165 5.375ZM6.20376 21H10.6325C11.1428 23.0081 11.9999 24.9117 13.165 26.625C11.6764 26.225 10.2881 25.5178 9.08918 24.5491C7.89029 23.5803 6.90741 22.3714 6.20376 21ZM18.835 26.625C20.0001 24.9117 20.8572 23.0081 21.3675 21H25.7963C25.0926 22.3714 24.1097 23.5803 22.9108 24.5491C21.7119 25.5178 20.3236 26.225 18.835 26.625Z">
                                                                </path>
                                                            </svg>
                                                            <span
                                                                class="style__LabelTextMobile-sc-1dh24tn-2 cnhmTn">American
                                                                English
                                                            </span>
                                                            <span aria-label="American English"
                                                                  class="style__LabelTextDesktop-sc-1dh24tn-3 elbCac">En</span>
                                                        </span>
                            <svg aria-hidden="true" class="sc-bdnxRM fMErFn" fill="#151515"
                                 focusable="false" viewBox="0 0 32 32">
                              <path
                                  d="M27.0613 13.0613L17.0613 23.0613C16.9219 23.2011 16.7563 23.312 16.574 23.3878C16.3917 23.4635 16.1962 23.5024 15.9988 23.5024C15.8013 23.5024 15.6059 23.4635 15.4235 23.3878C15.2412 23.312 15.0756 23.2011 14.9363 23.0613L4.93626 13.0613C4.65446 12.7795 4.49615 12.3973 4.49615 11.9988C4.49615 11.6002 4.65446 11.218 4.93626 10.9363C5.21805 10.6545 5.60024 10.4962 5.99876 10.4962C6.39727 10.4962 6.77946 10.6545 7.06126 10.9363L16 19.875L24.9388 10.935C25.2205 10.6532 25.6027 10.4949 26.0013 10.4949C26.3998 10.4949 26.782 10.6532 27.0638 10.935C27.3455 11.2168 27.5039 11.599 27.5039 11.9975C27.5039 12.396 27.3455 12.7782 27.0638 13.06L27.0613 13.0613Z">
                              </path>
                            </svg>
                          </button>
                        </li>
                      </ul>
                    </nav>
                  </div>
                  <div class="sc-kLojOw giIhGp">
                    <span class="style__SeparatorDesktop-sc-1ceufpk-1 idRyFS"></span>
                  </div>
                  <div class="sc-kLojOw faTBaw">
                    <a class="sc-hBMUJo cCkJIK style__RegisterButton-sc-1ceufpk-3 jKQNoI"
                       color="primary-emphasis"
                       @click="showLoginDialog=true">
                      <span class="sc-iCoGMd goTNSB" color="currentColor">Sign up</span>
                    </a>
                  </div>
                  <div class="sc-kLojOw faTBaw">
                    <a class="sc-hBMUJo eYQjJA style__LoginButton-sc-1ceufpk-2 hgXHcj"
                       color="secondary-default"
                       @click="showLoginDialog=true">
                      <span class="sc-iCoGMd goTNSB" color="currentColor">Log in</span>
                    </a>
                  </div>
                  <div class="sc-kLojOw giIhGp">
                    <a class="sc-kEqXSa chWJcF sc-iklJeh hbusih" color="default"
                       @click="showLoginDialog=true">
                      <span class="sc-pNWdM XJxhY">Log in</span>
                    </a>
                  </div>
                  <div class="sc-kLojOw giIhGp">
                    <a class="sc-hBMUJo fkiDuQ style__RegisterButton-sc-1ceufpk-3 jKQNoI"
                       color="primary-emphasis"
                       @click="showLoginDialog=true">
                      <span class="sc-iCoGMd goTNSB" color="currentColor">Sign up</span>
                    </a>
                  </div>
                </div>
              </nav>

              <a class="sc-hBMUJo caTDpS fkiDuQ style__RegisterButton-sc-1ceufpk-3"
                 color="primary-emphasis" data-v-10add3d4=""
                 @click="showLoginDialog=true"><span
                  class="sc-iCoGMd goTNSB" color="currentColor" data-v-10add3d4="">Log in</span></a>
              <nav class="sc-kfYoZR AMXKy sc-bCwfaz sc-ezzafa icfOOg">
                <div class="sc-kfYoZR gwFRLa sc-bYwzuL hPERJB">
                  <div class="sc-kLojOw ijRzoh">
                    <a class="sc-kEqXSa chWJcF sc-iklJeh hbusih" color="default"
                       @click="showLoginDialog=true">
                      <span class="sc-pNWdM XJxhY">For businesses</span>
                    </a>
                  </div>
                  <div class="sc-kLojOw faTBaw">
                    <div class="style__SeparatorMobile-sc-1ceufpk-0 zLqvh"></div>
                  </div>
                  <div class="sc-kLojOw ijRzoh">
                    <nav aria-labelledby="button-menu-uid-4817247294-6">
                      <ul class="style__DisclosureMenuContent-sc-19d5cj-1 iUOrPP">
                        <li>
                          <button id="button-menu-uid-4817247294-6"
                                  aria-controls="uid-4817247294-6"
                                  aria-expanded="false"
                                  class="sc-bqGGPW sc-ksluID style__ButtonMenu-sc-19d5cj-0 iPexDg jZVOKR fQBbke"
                                  color="ghost"
                                  type="button"><span
                              class="style__Label-sc-1dh24tn-0 gUojGE"><span
                              class="sc-jJMGnK laKGqb">Display language:</span><svg
                              aria-hidden="true"
                              class="sc-bdnxRM dRIyKz style__StyledIcon-sc-1dh24tn-1 hNsYGX"
                              fill="#151515"
                              focusable="false"
                              viewBox="0 0 32 32">
                                                                <path
                                                                    d="M16 3C13.4288 3 10.9154 3.76244 8.77759 5.1909C6.63975 6.61935 4.97351 8.64968 3.98957 11.0251C3.00563 13.4006 2.74819 16.0144 3.2498 18.5362C3.75141 21.0579 4.98953 23.3743 6.80762 25.1924C8.6257 27.0105 10.9421 28.2486 13.4638 28.7502C15.9856 29.2518 18.5995 28.9944 20.9749 28.0104C23.3503 27.0265 25.3807 25.3603 26.8091 23.2224C28.2376 21.0846 29 18.5712 29 16C28.9964 12.5533 27.6256 9.24882 25.1884 6.81163C22.7512 4.37445 19.4467 3.00364 16 3ZM12.7038 21H19.2963C18.625 23.2925 17.5 25.3587 16 26.9862C14.5 25.3587 13.375 23.2925 12.7038 21ZM12.25 19C11.9183 17.0138 11.9183 14.9862 12.25 13H19.75C20.0817 14.9862 20.0817 17.0138 19.75 19H12.25ZM5.00001 16C4.99914 14.9855 5.13923 13.9759 5.41626 13H10.2238C9.92542 14.9889 9.92542 17.0111 10.2238 19H5.41626C5.13923 18.0241 4.99914 17.0145 5.00001 16ZM19.2963 11H12.7038C13.375 8.7075 14.5 6.64125 16 5.01375C17.5 6.64125 18.625 8.7075 19.2963 11ZM21.7763 13H26.5838C27.1388 14.9615 27.1388 17.0385 26.5838 19H21.7763C22.0746 17.0111 22.0746 14.9889 21.7763 13ZM25.7963 11H21.3675C20.8572 8.99189 20.0001 7.0883 18.835 5.375C20.3236 5.77503 21.7119 6.48215 22.9108 7.45091C24.1097 8.41967 25.0926 9.62861 25.7963 11ZM13.165 5.375C11.9999 7.0883 11.1428 8.99189 10.6325 11H6.20376C6.90741 9.62861 7.89029 8.41967 9.08918 7.45091C10.2881 6.48215 11.6764 5.77503 13.165 5.375ZM6.20376 21H10.6325C11.1428 23.0081 11.9999 24.9117 13.165 26.625C11.6764 26.225 10.2881 25.5178 9.08918 24.5491C7.89029 23.5803 6.90741 22.3714 6.20376 21ZM18.835 26.625C20.0001 24.9117 20.8572 23.0081 21.3675 21H25.7963C25.0926 22.3714 24.1097 23.5803 22.9108 24.5491C21.7119 25.5178 20.3236 26.225 18.835 26.625Z">
                                                                </path>
                                                            </svg><span
                              class="style__LabelTextMobile-sc-1dh24tn-2 cnhmTn">American
                                                                English</span><span aria-label="American English"
                                                                                    class="style__LabelTextDesktop-sc-1dh24tn-3 elbCac">En</span></span>
                            <svg aria-hidden="true" class="sc-bdnxRM fMErFn" fill="#151515"
                                 focusable="false" viewBox="0 0 32 32">
                              <path
                                  d="M27.0613 13.0613L17.0613 23.0613C16.9219 23.2011 16.7563 23.312 16.574 23.3878C16.3917 23.4635 16.1962 23.5024 15.9988 23.5024C15.8013 23.5024 15.6059 23.4635 15.4235 23.3878C15.2412 23.312 15.0756 23.2011 14.9363 23.0613L4.93626 13.0613C4.65446 12.7795 4.49615 12.3973 4.49615 11.9988C4.49615 11.6002 4.65446 11.218 4.93626 10.9363C5.21805 10.6545 5.60024 10.4962 5.99876 10.4962C6.39727 10.4962 6.77946 10.6545 7.06126 10.9363L16 19.875L24.9388 10.935C25.2205 10.6532 25.6027 10.4949 26.0013 10.4949C26.3998 10.4949 26.782 10.6532 27.0638 10.935C27.3455 11.2168 27.5039 11.599 27.5039 11.9975C27.5039 12.396 27.3455 12.7782 27.0638 13.06L27.0613 13.0613Z">
                              </path>
                            </svg>
                          </button>
                        </li>
                      </ul>
                    </nav>
                  </div>
                  <div class="sc-kLojOw giIhGp">
                    <span class="style__SeparatorDesktop-sc-1ceufpk-1 idRyFS"></span>
                  </div>
                  <div class="sc-kLojOw faTBaw">
                    <a class="sc-hBMUJo cCkJIK style__RegisterButton-sc-1ceufpk-3 jKQNoI"
                       color="primary-emphasis"
                       @click="showLoginDialog=true">
                      <span class="sc-iCoGMd goTNSB" color="currentColor">Sign up</span>
                    </a>
                  </div>
                  <div class="sc-kLojOw faTBaw">
                    <a class="sc-hBMUJo eYQjJA style__LoginButton-sc-1ceufpk-2 hgXHcj"
                       color="secondary-default"
                       @click="showLoginDialog=true">
                      <span class="sc-iCoGMd goTNSB" color="currentColor">Log in</span>
                    </a>
                  </div>
                  <div class="sc-kLojOw giIhGp">
                    <a class="sc-kEqXSa chWJcF sc-iklJeh hbusih" color="default"
                       @click="showLoginDialog=true">
                      <span class="sc-pNWdM XJxhY">Log in</span>
                    </a>
                  </div>
                  <div class="sc-kLojOw giIhGp">
                    <a class="sc-hBMUJo fkiDuQ style__RegisterButton-sc-1ceufpk-3 jKQNoI"
                       color="primary-emphasis"
                       @click="showLoginDialog=true">
                      <span class="sc-iCoGMd goTNSB" color="currentColor">Sign up</span>
                    </a>
                  </div>
                </div>
              </nav>
            </div>
          </div>
        </div>
        <main v-if="!showLang">
          <header
              class="style__Container-sc-ttg9pt-0 kkpxKb style__StyledBackgroundImage-sc-11winof-0 dpQAxa">
            <div id="3f73fd8b-abf3-56cc-af06-1371e61640da" class="style__Container-sc-11winof-1 hfoHHA"
                 tabindex="-1">
              <div class="sc-kfYoZR eySVyK style__ContentWrap-sc-1cerv0a-0 csCCsR">
                <div class="sc-kfYoZR fidEIY style__ContentStack-sc-1cerv0a-1 jraLUj">
                  <h1 class="sc-gXfVKN kvQnlj style__StyledTitle-sc-1cerv0a-2 ckdlSz" color="#151515">
                    Which <em class="style__StyledItalic-sc-eykdt1-4 fVwJBM">language</em> do you
                    want to speak?</h1>
                  <div class="style__CtaGroup-sc-1cerv0a-4 cVqDFM">
                    <div class="style__FlagsCtaWrap-sc-1mm9dyl-2 foYaKp">
                      <div class="sc-kfYoZR eNJToF">
                        <a class="style__StyledLink-sc-1xmwttv-0 cqQAFN"
                           @click="changLang('Chinese')">
                          <div
                              class="sc-ciSkZP kcSChc style__LanguageItem-sc-1xmwttv-1 hfChhU">

                            <span class="sc-iCoGMd eEHQUm" color="#151515">Chinese</span>
                          </div>
                        </a>
                        <a class="style__StyledLink-sc-1xmwttv-0 cqQAFN"
                           @click="changLang('Thai')">
                          <div
                              class="sc-ciSkZP kcSChc style__LanguageItem-sc-1xmwttv-1 hfChhU">

                                                        <span class="sc-iCoGMd eEHQUm"
                                                              color="#151515">Thai</span>
                          </div>
                        </a>
                        <a class="style__StyledLink-sc-1xmwttv-0 cqQAFN"
                           @click="changLang('Japanese')">
                          <div
                              class="sc-ciSkZP kcSChc style__LanguageItem-sc-1xmwttv-1 hfChhU">

                                                        <span class="sc-iCoGMd eEHQUm"
                                                              color="#151515">Japanese</span>
                          </div>
                        </a>
                        <a class="style__StyledLink-sc-1xmwttv-0 cqQAFN"
                           @click="changLang('Vietnamese')">
                          <div
                              class="sc-ciSkZP kcSChc style__LanguageItem-sc-1xmwttv-1 hfChhU">

                                                        <span class="sc-iCoGMd eEHQUm"
                                                              color="#151515">Vietnamese</span>
                          </div>
                        </a>
                        <a class="style__StyledLink-sc-1xmwttv-0 cqQAFN"
                           @click="showLoginDialog=true">
                          <div
                              class="sc-ciSkZP kcSChc style__LanguageItem-sc-1xmwttv-1 hfChhU">
                            <svg fill="none" height="24" viewBox="0 0 24 24" width="24"
                                 xmlns="http://www.w3.org/2000/svg">
                              <g id="Group 2085662354">
                                <circle id="Ellipse 248" cx="12" cy="12" fill="#F6F4EF"
                                        r="12"></circle>
                                <path id="Vector 447" d="M12 7V17" stroke="#151515"
                                      stroke-linecap="round" stroke-width="1.5"></path>
                                <path id="Vector 448" d="M17 12L7 12" stroke="#151515"
                                      stroke-linecap="round" stroke-width="1.5"></path>
                              </g>
                            </svg>
                            <span class="sc-iCoGMd eEHQUm" color="#151515">More</span>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="sc-kfYoZR fuPtPe style__LeftRightImageWrap-sc-11winof-2 cCcLUY">
                <div class="gatsby-image-wrapper gatsby-image-wrapper-constrained"
                     data-gatsby-image-wrapper="">
                  <div style="max-width:2304px;display:block">
                    <img alt="" aria-hidden="true" role="presentation"
                         src="data:image/svg+xml;charset=utf-8,%3Csvg%20height='1693'%20width='2304'%20xmlns='http://www.w3.org/2000/svg'%20version='1.1'%3E%3C/svg%3E"
                         style="max-width:100%;display:block;position:static">
                  </div>
                  <div aria-hidden="true" data-placeholder-image=""
                       style="opacity: 0; transition: opacity 500ms linear 0s;">
                  </div>
                  <picture>
                    <source sizes="(min-width: 900px) 736px, 100vw"
                            srcset="https://images.ctfassets.net/zuzqvf4m2o58/3DWc31d5tAEfqbUYYLoxW5/d2ec91a7375c1b2bdd55df74baca9ac6/Hero_image_ENG_Desktop__2_.png?w=360&amp;h=265&amp;q=50&amp;fm=avif 360w,https://images.ctfassets.net/zuzqvf4m2o58/3DWc31d5tAEfqbUYYLoxW5/d2ec91a7375c1b2bdd55df74baca9ac6/Hero_image_ENG_Desktop__2_.png?w=600&amp;h=441&amp;q=50&amp;fm=avif 600w,https://images.ctfassets.net/zuzqvf4m2o58/3DWc31d5tAEfqbUYYLoxW5/d2ec91a7375c1b2bdd55df74baca9ac6/Hero_image_ENG_Desktop__2_.png?w=900&amp;h=661&amp;q=50&amp;fm=avif 900w,https://images.ctfassets.net/zuzqvf4m2o58/3DWc31d5tAEfqbUYYLoxW5/d2ec91a7375c1b2bdd55df74baca9ac6/Hero_image_ENG_Desktop__2_.png?w=1200&amp;h=882&amp;q=50&amp;fm=avif 1200w,https://images.ctfassets.net/zuzqvf4m2o58/3DWc31d5tAEfqbUYYLoxW5/d2ec91a7375c1b2bdd55df74baca9ac6/Hero_image_ENG_Desktop__2_.png?w=1600&amp;h=1176&amp;q=50&amp;fm=avif 1600w,https://images.ctfassets.net/zuzqvf4m2o58/3DWc31d5tAEfqbUYYLoxW5/d2ec91a7375c1b2bdd55df74baca9ac6/Hero_image_ENG_Desktop__2_.png?w=1920&amp;h=1411&amp;q=50&amp;fm=avif 1920w,https://images.ctfassets.net/zuzqvf4m2o58/3DWc31d5tAEfqbUYYLoxW5/d2ec91a7375c1b2bdd55df74baca9ac6/Hero_image_ENG_Desktop__2_.png?w=2304&amp;h=1693&amp;q=50&amp;fm=avif 2304w"
                            type="image/avif">
                    <source sizes="(min-width: 900px) 736px, 100vw"
                            srcset="https://images.ctfassets.net/zuzqvf4m2o58/3DWc31d5tAEfqbUYYLoxW5/d2ec91a7375c1b2bdd55df74baca9ac6/Hero_image_ENG_Desktop__2_.png?w=360&amp;h=265&amp;q=50&amp;fm=webp 360w,https://images.ctfassets.net/zuzqvf4m2o58/3DWc31d5tAEfqbUYYLoxW5/d2ec91a7375c1b2bdd55df74baca9ac6/Hero_image_ENG_Desktop__2_.png?w=600&amp;h=441&amp;q=50&amp;fm=webp 600w,https://images.ctfassets.net/zuzqvf4m2o58/3DWc31d5tAEfqbUYYLoxW5/d2ec91a7375c1b2bdd55df74baca9ac6/Hero_image_ENG_Desktop__2_.png?w=900&amp;h=661&amp;q=50&amp;fm=webp 900w,https://images.ctfassets.net/zuzqvf4m2o58/3DWc31d5tAEfqbUYYLoxW5/d2ec91a7375c1b2bdd55df74baca9ac6/Hero_image_ENG_Desktop__2_.png?w=1200&amp;h=882&amp;q=50&amp;fm=webp 1200w,https://images.ctfassets.net/zuzqvf4m2o58/3DWc31d5tAEfqbUYYLoxW5/d2ec91a7375c1b2bdd55df74baca9ac6/Hero_image_ENG_Desktop__2_.png?w=1600&amp;h=1176&amp;q=50&amp;fm=webp 1600w,https://images.ctfassets.net/zuzqvf4m2o58/3DWc31d5tAEfqbUYYLoxW5/d2ec91a7375c1b2bdd55df74baca9ac6/Hero_image_ENG_Desktop__2_.png?w=1920&amp;h=1411&amp;q=50&amp;fm=webp 1920w,https://images.ctfassets.net/zuzqvf4m2o58/3DWc31d5tAEfqbUYYLoxW5/d2ec91a7375c1b2bdd55df74baca9ac6/Hero_image_ENG_Desktop__2_.png?w=2304&amp;h=1693&amp;q=50&amp;fm=webp 2304w"
                            type="image/webp">
                    <img alt=""
                         decoding="async" loading="eager" sizes="(min-width: 900px) 736px, 100vw"
                         src="https://images.ctfassets.net/zuzqvf4m2o58/3DWc31d5tAEfqbUYYLoxW5/d2ec91a7375c1b2bdd55df74baca9ac6/Hero_image_ENG_Desktop__2_.png?w=2304&amp;h=1693&amp;q=50&amp;fm=png"
                         srcset="https://images.ctfassets.net/zuzqvf4m2o58/3DWc31d5tAEfqbUYYLoxW5/d2ec91a7375c1b2bdd55df74baca9ac6/Hero_image_ENG_Desktop__2_.png?w=360&amp;h=265&amp;q=50&amp;fm=png 360w,https://images.ctfassets.net/zuzqvf4m2o58/3DWc31d5tAEfqbUYYLoxW5/d2ec91a7375c1b2bdd55df74baca9ac6/Hero_image_ENG_Desktop__2_.png?w=600&amp;h=441&amp;q=50&amp;fm=png 600w,https://images.ctfassets.net/zuzqvf4m2o58/3DWc31d5tAEfqbUYYLoxW5/d2ec91a7375c1b2bdd55df74baca9ac6/Hero_image_ENG_Desktop__2_.png?w=900&amp;h=661&amp;q=50&amp;fm=png 900w,https://images.ctfassets.net/zuzqvf4m2o58/3DWc31d5tAEfqbUYYLoxW5/d2ec91a7375c1b2bdd55df74baca9ac6/Hero_image_ENG_Desktop__2_.png?w=1200&amp;h=882&amp;q=50&amp;fm=png 1200w,https://images.ctfassets.net/zuzqvf4m2o58/3DWc31d5tAEfqbUYYLoxW5/d2ec91a7375c1b2bdd55df74baca9ac6/Hero_image_ENG_Desktop__2_.png?w=1600&amp;h=1176&amp;q=50&amp;fm=png 1600w,https://images.ctfassets.net/zuzqvf4m2o58/3DWc31d5tAEfqbUYYLoxW5/d2ec91a7375c1b2bdd55df74baca9ac6/Hero_image_ENG_Desktop__2_.png?w=1920&amp;h=1411&amp;q=50&amp;fm=png 1920w,https://images.ctfassets.net/zuzqvf4m2o58/3DWc31d5tAEfqbUYYLoxW5/d2ec91a7375c1b2bdd55df74baca9ac6/Hero_image_ENG_Desktop__2_.png?w=2304&amp;h=1693&amp;q=50&amp;fm=png 2304w"
                         style="transition: none 0s ease 0s; opacity: 1;">
                  </picture>
                  <noscript>
                    <picture>
                      <source sizes="(min-width: 900px) 736px, 100vw"
                              srcSet="https://images.ctfassets.net/zuzqvf4m2o58/3DWc31d5tAEfqbUYYLoxW5/d2ec91a7375c1b2bdd55df74baca9ac6/Hero_image_ENG_Desktop__2_.png?w=360&amp;h=265&amp;q=50&amp;fm=avif 360w,https://images.ctfassets.net/zuzqvf4m2o58/3DWc31d5tAEfqbUYYLoxW5/d2ec91a7375c1b2bdd55df74baca9ac6/Hero_image_ENG_Desktop__2_.png?w=600&amp;h=441&amp;q=50&amp;fm=avif 600w,https://images.ctfassets.net/zuzqvf4m2o58/3DWc31d5tAEfqbUYYLoxW5/d2ec91a7375c1b2bdd55df74baca9ac6/Hero_image_ENG_Desktop__2_.png?w=900&amp;h=661&amp;q=50&amp;fm=avif 900w,https://images.ctfassets.net/zuzqvf4m2o58/3DWc31d5tAEfqbUYYLoxW5/d2ec91a7375c1b2bdd55df74baca9ac6/Hero_image_ENG_Desktop__2_.png?w=1200&amp;h=882&amp;q=50&amp;fm=avif 1200w,https://images.ctfassets.net/zuzqvf4m2o58/3DWc31d5tAEfqbUYYLoxW5/d2ec91a7375c1b2bdd55df74baca9ac6/Hero_image_ENG_Desktop__2_.png?w=1600&amp;h=1176&amp;q=50&amp;fm=avif 1600w,https://images.ctfassets.net/zuzqvf4m2o58/3DWc31d5tAEfqbUYYLoxW5/d2ec91a7375c1b2bdd55df74baca9ac6/Hero_image_ENG_Desktop__2_.png?w=1920&amp;h=1411&amp;q=50&amp;fm=avif 1920w,https://images.ctfassets.net/zuzqvf4m2o58/3DWc31d5tAEfqbUYYLoxW5/d2ec91a7375c1b2bdd55df74baca9ac6/Hero_image_ENG_Desktop__2_.png?w=2304&amp;h=1693&amp;q=50&amp;fm=avif 2304w"
                              type="image/avif"/>
                      <source sizes="(min-width: 900px) 736px, 100vw"
                              srcSet="https://images.ctfassets.net/zuzqvf4m2o58/3DWc31d5tAEfqbUYYLoxW5/d2ec91a7375c1b2bdd55df74baca9ac6/Hero_image_ENG_Desktop__2_.png?w=360&amp;h=265&amp;q=50&amp;fm=webp 360w,https://images.ctfassets.net/zuzqvf4m2o58/3DWc31d5tAEfqbUYYLoxW5/d2ec91a7375c1b2bdd55df74baca9ac6/Hero_image_ENG_Desktop__2_.png?w=600&amp;h=441&amp;q=50&amp;fm=webp 600w,https://images.ctfassets.net/zuzqvf4m2o58/3DWc31d5tAEfqbUYYLoxW5/d2ec91a7375c1b2bdd55df74baca9ac6/Hero_image_ENG_Desktop__2_.png?w=900&amp;h=661&amp;q=50&amp;fm=webp 900w,https://images.ctfassets.net/zuzqvf4m2o58/3DWc31d5tAEfqbUYYLoxW5/d2ec91a7375c1b2bdd55df74baca9ac6/Hero_image_ENG_Desktop__2_.png?w=1200&amp;h=882&amp;q=50&amp;fm=webp 1200w,https://images.ctfassets.net/zuzqvf4m2o58/3DWc31d5tAEfqbUYYLoxW5/d2ec91a7375c1b2bdd55df74baca9ac6/Hero_image_ENG_Desktop__2_.png?w=1600&amp;h=1176&amp;q=50&amp;fm=webp 1600w,https://images.ctfassets.net/zuzqvf4m2o58/3DWc31d5tAEfqbUYYLoxW5/d2ec91a7375c1b2bdd55df74baca9ac6/Hero_image_ENG_Desktop__2_.png?w=1920&amp;h=1411&amp;q=50&amp;fm=webp 1920w,https://images.ctfassets.net/zuzqvf4m2o58/3DWc31d5tAEfqbUYYLoxW5/d2ec91a7375c1b2bdd55df74baca9ac6/Hero_image_ENG_Desktop__2_.png?w=2304&amp;h=1693&amp;q=50&amp;fm=webp 2304w"
                              type="image/webp"/>
                      <img alt=""
                           data-gatsby-image-ssr=""
                           decoding="async" loading="eager"
                           sizes="(min-width: 900px) 736px, 100vw"
                           src="https://images.ctfassets.net/zuzqvf4m2o58/3DWc31d5tAEfqbUYYLoxW5/d2ec91a7375c1b2bdd55df74baca9ac6/Hero_image_ENG_Desktop__2_.png?w=2304&amp;h=1693&amp;q=50&amp;fm=png"
                           srcSet="https://images.ctfassets.net/zuzqvf4m2o58/3DWc31d5tAEfqbUYYLoxW5/d2ec91a7375c1b2bdd55df74baca9ac6/Hero_image_ENG_Desktop__2_.png?w=360&amp;h=265&amp;q=50&amp;fm=png 360w,https://images.ctfassets.net/zuzqvf4m2o58/3DWc31d5tAEfqbUYYLoxW5/d2ec91a7375c1b2bdd55df74baca9ac6/Hero_image_ENG_Desktop__2_.png?w=600&amp;h=441&amp;q=50&amp;fm=png 600w,https://images.ctfassets.net/zuzqvf4m2o58/3DWc31d5tAEfqbUYYLoxW5/d2ec91a7375c1b2bdd55df74baca9ac6/Hero_image_ENG_Desktop__2_.png?w=900&amp;h=661&amp;q=50&amp;fm=png 900w,https://images.ctfassets.net/zuzqvf4m2o58/3DWc31d5tAEfqbUYYLoxW5/d2ec91a7375c1b2bdd55df74baca9ac6/Hero_image_ENG_Desktop__2_.png?w=1200&amp;h=882&amp;q=50&amp;fm=png 1200w,https://images.ctfassets.net/zuzqvf4m2o58/3DWc31d5tAEfqbUYYLoxW5/d2ec91a7375c1b2bdd55df74baca9ac6/Hero_image_ENG_Desktop__2_.png?w=1600&amp;h=1176&amp;q=50&amp;fm=png 1600w,https://images.ctfassets.net/zuzqvf4m2o58/3DWc31d5tAEfqbUYYLoxW5/d2ec91a7375c1b2bdd55df74baca9ac6/Hero_image_ENG_Desktop__2_.png?w=1920&amp;h=1411&amp;q=50&amp;fm=png 1920w,https://images.ctfassets.net/zuzqvf4m2o58/3DWc31d5tAEfqbUYYLoxW5/d2ec91a7375c1b2bdd55df74baca9ac6/Hero_image_ENG_Desktop__2_.png?w=2304&amp;h=1693&amp;q=50&amp;fm=png 2304w"
                           style="transition:none;opacity:0"/>
                    </picture>
                  </noscript>
                  <script
                      type="module">const t = "undefined" != typeof HTMLImageElement && "loading" in HTMLImageElement.prototype;
                  if (t) {
                    const t = document.querySelectorAll("img[data-main-image]");
                    for (let e of t) {
                      e.dataset.src && (e.setAttribute("src", e.dataset.src), e.removeAttribute("data-src")), e.dataset.srcset && (e.setAttribute("srcset", e.dataset.srcset), e.removeAttribute("data-srcset"));
                      const t = e.parentNode.querySelectorAll("source[data-srcset]");
                      for (let e of t) e.setAttribute("srcset", e.dataset.srcset), e.removeAttribute("data-srcset");
                      e.complete && (e.style.opacity = 1, e.parentNode.parentNode.querySelector("[data-placeholder-image]").style.opacity = 0)
                    }
                  }</script>
                </div>
              </div>
            </div>
          </header>
          <div class="style__StyledBanner-sc-ewimuq-0 hOTwLl remove-in-percy">
            <div class="style__StyledWrapper-sc-ewimuq-1 dfmKUc">
              <div class="sc-kfYoZR llREnb style__StyledContentContainer-sc-ewimuq-2 krXIeu">
                <div class="sc-kfYoZR fuPtPe style__StyledContentGroup-sc-ewimuq-3 etpjCD">
                  <div class="sc-kfYoZR fuPtPe style__StyledContentItem-sc-ewimuq-4 dRVrLC">
                    <div class="sc-ciSkZP cXOOJw"><span class="sc-iCoGMd cgIVRG"
                                                        color="#ffffff">Over 15 million subscriptions sold!</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <section id="39bbc5aa-76e7-5852-a850-fe358583ff23" class="sc-ciSkZP yQObT" tabindex="-1">
            <div class="sc-kfYoZR cNabcs style__RootContentWrapper-sc-ivk0j3-0 jIMvGy">
              <h2 class="sc-gXfVKN caSaty style__StyledTitle-sc-ivk0j3-1 jXuDmg" color="#151515">Learn the
                way <em class="style__StyledItalic-sc-eykdt1-4 fVwJBM">you</em> want</h2>
            </div>
            <div class="style__SliderItemsContainer-sc-ivk0j3-2 cAwmgW">
              <div class="style__StyledSliderItem-sc-ivk0j3-4 krsGCC">
                <div class="style__StyledSliderItemInner-sc-ivk0j3-3 fDpTMZ">
                  <article class="sc-jgPyTC eWOCqZ style__StyledInfoCard-sc-7xtyb1-0 hYLqAP"
                           color="lightened">
                    <div class="sc-kfYoZR fQlzpe style__ContentContainer-sc-7xtyb1-1 euyJux">
                      <div class="style__Tag-sc-7xtyb1-2 eJOqZF"><span class="sc-iCoGMd jsBGdm"
                                                                       color="default">{{
                          siteName
                        }} App</span>
                      </div>
                      <div class="sc-kfYoZR jmUfzQ">
                        <h3 class="sc-gXfVKN hVFdAj" color="default">Award-winning courses to
                          explore at your own pace</h3>
                      </div>
                      <div class="sc-kfYoZR kOAlcr style__StyledStack-sc-7xtyb1-3 eXFwRQ">
                        <div
                            class="sc-hiKfDv fKEYFE style__StyledText-sc-eykdt1-0 ewlJBf style__StyledRichText-sc-7xtyb1-5 kNYlsR"
                            color="default">
                          <ul class="style__StyledUl-sc-eykdt1-7 XRDym">
                            <li>
                              <svg class="icon-checkmark" fill="none" height="24"
                                   viewBox="0 0 16 16" width="24"
                                   xmlns="http://www.w3.org/2000/svg">
                                <circle cx="8.069" cy="7.718" fill="#ffd6c4" r="7.59">
                                </circle>
                                <path
                                    d="M6.538 6.942a.69.69 0 0 0-1.078.862l1.078-.862Zm.841 2.156-.539.43.482.603.545-.545-.488-.488Zm3.248-2.272a.69.69 0 0 0-.976-.976l.976.976Zm-5.167.978 1.38 1.725 1.078-.862-1.38-1.725-1.078.862Zm2.407 1.782 2.76-2.76-.976-.976-2.76 2.76.976.976Z"
                                    fill="#151515"></path>
                              </svg>
                              <p class="style__StyledParagraph-sc-eykdt1-1 fUyLx">Access
                                expert-crafted lessons, games, and podcasts that spark
                                real conversations</p>
                            </li>
                            <li>
                              <svg class="icon-checkmark" fill="none" height="24"
                                   viewBox="0 0 16 16" width="24"
                                   xmlns="http://www.w3.org/2000/svg">
                                <circle cx="8.069" cy="7.718" fill="#ffd6c4" r="7.59">
                                </circle>
                                <path
                                    d="M6.538 6.942a.69.69 0 0 0-1.078.862l1.078-.862Zm.841 2.156-.539.43.482.603.545-.545-.488-.488Zm3.248-2.272a.69.69 0 0 0-.976-.976l.976.976Zm-5.167.978 1.38 1.725 1.078-.862-1.38-1.725-1.078.862Zm2.407 1.782 2.76-2.76-.976-.976-2.76 2.76.976.976Z"
                                    fill="#151515"></path>
                              </svg>
                              <p class="style__StyledParagraph-sc-eykdt1-1 fUyLx">Create
                                an effective routine that fits your schedule</p>
                            </li>
                            <li>
                              <svg class="icon-checkmark" fill="none" height="24"
                                   viewBox="0 0 16 16" width="24"
                                   xmlns="http://www.w3.org/2000/svg">
                                <circle cx="8.069" cy="7.718" fill="#ffd6c4" r="7.59">
                                </circle>
                                <path
                                    d="M6.538 6.942a.69.69 0 0 0-1.078.862l1.078-.862Zm.841 2.156-.539.43.482.603.545-.545-.488-.488Zm3.248-2.272a.69.69 0 0 0-.976-.976l.976.976Zm-5.167.978 1.38 1.725 1.078-.862-1.38-1.725-1.078.862Zm2.407 1.782 2.76-2.76-.976-.976-2.76 2.76.976.976Z"
                                    fill="#151515"></path>
                              </svg>
                              <p class="style__StyledParagraph-sc-eykdt1-1 fUyLx">Learn at
                                your own pace and level</p>
                            </li>
                          </ul>
                        </div>
                        <a class="sc-hBMUJo dzZuYr" color="primary-default"
                           @click="showLoginDialog=true"><span class="sc-iCoGMd goTNSB"
                                                               color="currentColor">Explore subscriptions</span></a>
                      </div>
                    </div>
                    <div class="gatsby-image-wrapper gatsby-image-wrapper-constrained"
                         data-gatsby-image-wrapper="">
                      <div style="max-width:480px;display:block"><img alt="" aria-hidden="true"
                                                                      role="presentation"
                                                                      src="data:image/svg+xml;charset=utf-8,%3Csvg%20height='238'%20width='480'%20xmlns='http://www.w3.org/2000/svg'%20version='1.1'%3E%3C/svg%3E"
                                                                      style="max-width:100%;display:block;position:static">
                      </div>
                      <div aria-hidden="true" data-placeholder-image=""
                           style="opacity: 0; transition: opacity 500ms linear 0s;"></div>
                      <picture>
                        <source sizes="(min-width: 480px) 480px, 100vw"
                                srcset="https://images.ctfassets.net/zuzqvf4m2o58/42PxGrzRrsJijJ6WLIou0o/567b79cf14efd8a5f5e4b521f561f135/Frame_2085662309.png?w=360&amp;h=179&amp;q=50&amp;fm=avif 360w,https://images.ctfassets.net/zuzqvf4m2o58/42PxGrzRrsJijJ6WLIou0o/567b79cf14efd8a5f5e4b521f561f135/Frame_2085662309.png?w=480&amp;h=238&amp;q=50&amp;fm=avif 480w,https://images.ctfassets.net/zuzqvf4m2o58/42PxGrzRrsJijJ6WLIou0o/567b79cf14efd8a5f5e4b521f561f135/Frame_2085662309.png?w=600&amp;h=298&amp;q=50&amp;fm=avif 600w,https://images.ctfassets.net/zuzqvf4m2o58/42PxGrzRrsJijJ6WLIou0o/567b79cf14efd8a5f5e4b521f561f135/Frame_2085662309.png?w=900&amp;h=446&amp;q=50&amp;fm=avif 900w,https://images.ctfassets.net/zuzqvf4m2o58/42PxGrzRrsJijJ6WLIou0o/567b79cf14efd8a5f5e4b521f561f135/Frame_2085662309.png?w=1200&amp;h=595&amp;q=50&amp;fm=avif 1200w,https://images.ctfassets.net/zuzqvf4m2o58/42PxGrzRrsJijJ6WLIou0o/567b79cf14efd8a5f5e4b521f561f135/Frame_2085662309.png?w=1527&amp;h=757&amp;q=50&amp;fm=avif 1527w"
                                type="image/avif">
                        <source sizes="(min-width: 480px) 480px, 100vw"
                                srcset="https://images.ctfassets.net/zuzqvf4m2o58/42PxGrzRrsJijJ6WLIou0o/567b79cf14efd8a5f5e4b521f561f135/Frame_2085662309.png?w=360&amp;h=179&amp;q=50&amp;fm=webp 360w,https://images.ctfassets.net/zuzqvf4m2o58/42PxGrzRrsJijJ6WLIou0o/567b79cf14efd8a5f5e4b521f561f135/Frame_2085662309.png?w=480&amp;h=238&amp;q=50&amp;fm=webp 480w,https://images.ctfassets.net/zuzqvf4m2o58/42PxGrzRrsJijJ6WLIou0o/567b79cf14efd8a5f5e4b521f561f135/Frame_2085662309.png?w=600&amp;h=298&amp;q=50&amp;fm=webp 600w,https://images.ctfassets.net/zuzqvf4m2o58/42PxGrzRrsJijJ6WLIou0o/567b79cf14efd8a5f5e4b521f561f135/Frame_2085662309.png?w=900&amp;h=446&amp;q=50&amp;fm=webp 900w,https://images.ctfassets.net/zuzqvf4m2o58/42PxGrzRrsJijJ6WLIou0o/567b79cf14efd8a5f5e4b521f561f135/Frame_2085662309.png?w=1200&amp;h=595&amp;q=50&amp;fm=webp 1200w,https://images.ctfassets.net/zuzqvf4m2o58/42PxGrzRrsJijJ6WLIou0o/567b79cf14efd8a5f5e4b521f561f135/Frame_2085662309.png?w=1527&amp;h=757&amp;q=50&amp;fm=webp 1527w"
                                type="image/webp">
                        <img alt="" decoding="async"
                             loading="lazy" sizes="(min-width: 480px) 480px, 100vw"
                             src="https://images.ctfassets.net/zuzqvf4m2o58/42PxGrzRrsJijJ6WLIou0o/567b79cf14efd8a5f5e4b521f561f135/Frame_2085662309.png?w=480&amp;h=238&amp;q=50&amp;fm=png"
                             srcset="https://images.ctfassets.net/zuzqvf4m2o58/42PxGrzRrsJijJ6WLIou0o/567b79cf14efd8a5f5e4b521f561f135/Frame_2085662309.png?w=360&amp;h=179&amp;q=50&amp;fm=png 360w,https://images.ctfassets.net/zuzqvf4m2o58/42PxGrzRrsJijJ6WLIou0o/567b79cf14efd8a5f5e4b521f561f135/Frame_2085662309.png?w=480&amp;h=238&amp;q=50&amp;fm=png 480w,https://images.ctfassets.net/zuzqvf4m2o58/42PxGrzRrsJijJ6WLIou0o/567b79cf14efd8a5f5e4b521f561f135/Frame_2085662309.png?w=600&amp;h=298&amp;q=50&amp;fm=png 600w,https://images.ctfassets.net/zuzqvf4m2o58/42PxGrzRrsJijJ6WLIou0o/567b79cf14efd8a5f5e4b521f561f135/Frame_2085662309.png?w=900&amp;h=446&amp;q=50&amp;fm=png 900w,https://images.ctfassets.net/zuzqvf4m2o58/42PxGrzRrsJijJ6WLIou0o/567b79cf14efd8a5f5e4b521f561f135/Frame_2085662309.png?w=1200&amp;h=595&amp;q=50&amp;fm=png 1200w,https://images.ctfassets.net/zuzqvf4m2o58/42PxGrzRrsJijJ6WLIou0o/567b79cf14efd8a5f5e4b521f561f135/Frame_2085662309.png?w=1527&amp;h=757&amp;q=50&amp;fm=png 1527w"
                             style="opacity: 1;">
                      </picture>
                      <noscript>
                        <picture>
                          <source sizes="(min-width: 480px) 480px, 100vw"
                                  srcSet="https://images.ctfassets.net/zuzqvf4m2o58/42PxGrzRrsJijJ6WLIou0o/567b79cf14efd8a5f5e4b521f561f135/Frame_2085662309.png?w=360&amp;h=179&amp;q=50&amp;fm=avif 360w,https://images.ctfassets.net/zuzqvf4m2o58/42PxGrzRrsJijJ6WLIou0o/567b79cf14efd8a5f5e4b521f561f135/Frame_2085662309.png?w=480&amp;h=238&amp;q=50&amp;fm=avif 480w,https://images.ctfassets.net/zuzqvf4m2o58/42PxGrzRrsJijJ6WLIou0o/567b79cf14efd8a5f5e4b521f561f135/Frame_2085662309.png?w=600&amp;h=298&amp;q=50&amp;fm=avif 600w,https://images.ctfassets.net/zuzqvf4m2o58/42PxGrzRrsJijJ6WLIou0o/567b79cf14efd8a5f5e4b521f561f135/Frame_2085662309.png?w=900&amp;h=446&amp;q=50&amp;fm=avif 900w,https://images.ctfassets.net/zuzqvf4m2o58/42PxGrzRrsJijJ6WLIou0o/567b79cf14efd8a5f5e4b521f561f135/Frame_2085662309.png?w=1200&amp;h=595&amp;q=50&amp;fm=avif 1200w,https://images.ctfassets.net/zuzqvf4m2o58/42PxGrzRrsJijJ6WLIou0o/567b79cf14efd8a5f5e4b521f561f135/Frame_2085662309.png?w=1527&amp;h=757&amp;q=50&amp;fm=avif 1527w"
                                  type="image/avif"/>
                          <source sizes="(min-width: 480px) 480px, 100vw"
                                  srcSet="https://images.ctfassets.net/zuzqvf4m2o58/42PxGrzRrsJijJ6WLIou0o/567b79cf14efd8a5f5e4b521f561f135/Frame_2085662309.png?w=360&amp;h=179&amp;q=50&amp;fm=webp 360w,https://images.ctfassets.net/zuzqvf4m2o58/42PxGrzRrsJijJ6WLIou0o/567b79cf14efd8a5f5e4b521f561f135/Frame_2085662309.png?w=480&amp;h=238&amp;q=50&amp;fm=webp 480w,https://images.ctfassets.net/zuzqvf4m2o58/42PxGrzRrsJijJ6WLIou0o/567b79cf14efd8a5f5e4b521f561f135/Frame_2085662309.png?w=600&amp;h=298&amp;q=50&amp;fm=webp 600w,https://images.ctfassets.net/zuzqvf4m2o58/42PxGrzRrsJijJ6WLIou0o/567b79cf14efd8a5f5e4b521f561f135/Frame_2085662309.png?w=900&amp;h=446&amp;q=50&amp;fm=webp 900w,https://images.ctfassets.net/zuzqvf4m2o58/42PxGrzRrsJijJ6WLIou0o/567b79cf14efd8a5f5e4b521f561f135/Frame_2085662309.png?w=1200&amp;h=595&amp;q=50&amp;fm=webp 1200w,https://images.ctfassets.net/zuzqvf4m2o58/42PxGrzRrsJijJ6WLIou0o/567b79cf14efd8a5f5e4b521f561f135/Frame_2085662309.png?w=1527&amp;h=757&amp;q=50&amp;fm=webp 1527w"
                                  type="image/webp"/>
                          <img
                              alt="" data-gatsby-image-ssr=""
                              decoding="async" loading="lazy"
                              sizes="(min-width: 480px) 480px, 100vw"
                              src="https://images.ctfassets.net/zuzqvf4m2o58/42PxGrzRrsJijJ6WLIou0o/567b79cf14efd8a5f5e4b521f561f135/Frame_2085662309.png?w=480&amp;h=238&amp;q=50&amp;fm=png"
                              srcSet="https://images.ctfassets.net/zuzqvf4m2o58/42PxGrzRrsJijJ6WLIou0o/567b79cf14efd8a5f5e4b521f561f135/Frame_2085662309.png?w=360&amp;h=179&amp;q=50&amp;fm=png 360w,https://images.ctfassets.net/zuzqvf4m2o58/42PxGrzRrsJijJ6WLIou0o/567b79cf14efd8a5f5e4b521f561f135/Frame_2085662309.png?w=480&amp;h=238&amp;q=50&amp;fm=png 480w,https://images.ctfassets.net/zuzqvf4m2o58/42PxGrzRrsJijJ6WLIou0o/567b79cf14efd8a5f5e4b521f561f135/Frame_2085662309.png?w=600&amp;h=298&amp;q=50&amp;fm=png 600w,https://images.ctfassets.net/zuzqvf4m2o58/42PxGrzRrsJijJ6WLIou0o/567b79cf14efd8a5f5e4b521f561f135/Frame_2085662309.png?w=900&amp;h=446&amp;q=50&amp;fm=png 900w,https://images.ctfassets.net/zuzqvf4m2o58/42PxGrzRrsJijJ6WLIou0o/567b79cf14efd8a5f5e4b521f561f135/Frame_2085662309.png?w=1200&amp;h=595&amp;q=50&amp;fm=png 1200w,https://images.ctfassets.net/zuzqvf4m2o58/42PxGrzRrsJijJ6WLIou0o/567b79cf14efd8a5f5e4b521f561f135/Frame_2085662309.png?w=1527&amp;h=757&amp;q=50&amp;fm=png 1527w"
                              style="opacity:0"/>
                        </picture>
                      </noscript>
                      <script
                          type="module">const t = "undefined" != typeof HTMLImageElement && "loading" in HTMLImageElement.prototype;
                      if (t) {
                        const t = document.querySelectorAll("img[data-main-image]");
                        for (let e of t) {
                          e.dataset.src && (e.setAttribute("src", e.dataset.src), e.removeAttribute("data-src")), e.dataset.srcset && (e.setAttribute("srcset", e.dataset.srcset), e.removeAttribute("data-srcset"));
                          const t = e.parentNode.querySelectorAll("source[data-srcset]");
                          for (let e of t) e.setAttribute("srcset", e.dataset.srcset), e.removeAttribute("data-srcset");
                          e.complete && (e.style.opacity = 1, e.parentNode.parentNode.querySelector("[data-placeholder-image]").style.opacity = 0)
                        }
                      }</script>
                    </div>
                  </article>
                </div>
              </div>
              <div class="style__StyledSliderItem-sc-ivk0j3-4 krsGCC">
                <div class="style__StyledSliderItemInner-sc-ivk0j3-3 fDpTMZ">
                  <article class="sc-jgPyTC eWOCqZ style__StyledInfoCard-sc-7xtyb1-0 hYLqAP"
                           color="lightened">
                    <div class="sc-kfYoZR fQlzpe style__ContentContainer-sc-7xtyb1-1 euyJux">
                      <div class="style__Tag-sc-7xtyb1-2 bUqnIH"><span class="sc-iCoGMd jsBGdm"
                                                                       color="default">{{
                          siteName
                        }} Live</span>
                      </div>
                      <div class="sc-kfYoZR jmUfzQ">
                        <h3 class="sc-gXfVKN hVFdAj" color="default">Live online language
                          classes with expert teachers</h3>
                      </div>
                      <div class="sc-kfYoZR kOAlcr style__StyledStack-sc-7xtyb1-3 eXFwRQ">
                        <div
                            class="sc-hiKfDv fKEYFE style__StyledText-sc-eykdt1-0 ewlJBf style__StyledRichText-sc-7xtyb1-5 kNYlsR"
                            color="default">
                          <ul class="style__StyledUl-sc-eykdt1-7 XRDym">
                            <li>
                              <svg class="icon-checkmark" fill="none" height="24"
                                   viewBox="0 0 16 16" width="24"
                                   xmlns="http://www.w3.org/2000/svg">
                                <circle cx="8.069" cy="7.718" fill="#f6f4ef" r="7.59">
                                </circle>
                                <path
                                    d="M6.538 6.942a.69.69 0 0 0-1.078.862l1.078-.862Zm.841 2.156-.539.43.482.603.545-.545-.488-.488Zm3.248-2.272a.69.69 0 0 0-.976-.976l.976.976Zm-5.167.978 1.38 1.725 1.078-.862-1.38-1.725-1.078.862Zm2.407 1.782 2.76-2.76-.976-.976-2.76 2.76.976.976Z"
                                    fill="#151515"></path>
                              </svg>
                              <p class="style__StyledParagraph-sc-eykdt1-1 fUyLx">Both 1:1
                                Private Classes and Group Classes with max. 6 students
                                are available</p>
                            </li>
                            <li>
                              <svg class="icon-checkmark" fill="none" height="24"
                                   viewBox="0 0 16 16" width="24"
                                   xmlns="http://www.w3.org/2000/svg">
                                <circle cx="8.069" cy="7.718" fill="#f6f4ef" r="7.59">
                                </circle>
                                <path
                                    d="M6.538 6.942a.69.69 0 0 0-1.078.862l1.078-.862Zm.841 2.156-.539.43.482.603.545-.545-.488-.488Zm3.248-2.272a.69.69 0 0 0-.976-.976l.976.976Zm-5.167.978 1.38 1.725 1.078-.862-1.38-1.725-1.078.862Zm2.407 1.782 2.76-2.76-.976-.976-2.76 2.76.976.976Z"
                                    fill="#151515"></path>
                              </svg>
                              <p class="style__StyledParagraph-sc-eykdt1-1 fUyLx">Choose
                                from hundreds of classes that fit your schedule</p>
                            </li>
                            <li>
                              <svg class="icon-checkmark" fill="none" height="24"
                                   viewBox="0 0 16 16" width="24"
                                   xmlns="http://www.w3.org/2000/svg">
                                <circle cx="8.069" cy="7.718" fill="#f6f4ef" r="7.59">
                                </circle>
                                <path
                                    d="M6.538 6.942a.69.69 0 0 0-1.078.862l1.078-.862Zm.841 2.156-.539.43.482.603.545-.545-.488-.488Zm3.248-2.272a.69.69 0 0 0-.976-.976l.976.976Zm-5.167.978 1.38 1.725 1.078-.862-1.38-1.725-1.078.862Zm2.407 1.782 2.76-2.76-.976-.976-2.76 2.76.976.976Z"
                                    fill="#151515"></path>
                              </svg>

                              <p class="style__StyledParagraph-sc-eykdt1-1 fUyLx">Take as
                                many classes as you like — it’s unlimited!</p>
                            </li>
                          </ul>
                        </div>
                        <a class="sc-hBMUJo dzZuYr" color="primary-default"
                           @click="showLoginDialog=true"><span class="sc-iCoGMd goTNSB"
                                                               color="currentColor">Explore classes</span></a>
                      </div>
                    </div>
                    <div class="gatsby-image-wrapper gatsby-image-wrapper-constrained"
                         data-gatsby-image-wrapper="">
                      <div style="max-width:480px;display:block"><img alt="" aria-hidden="true"
                                                                      role="presentation"
                                                                      src="data:image/svg+xml;charset=utf-8,%3Csvg%20height='238'%20width='480'%20xmlns='http://www.w3.org/2000/svg'%20version='1.1'%3E%3C/svg%3E"
                                                                      style="max-width:100%;display:block;position:static">
                      </div>
                      <div aria-hidden="true" data-placeholder-image=""
                           style="opacity: 0; transition: opacity 500ms linear 0s;"></div>
                      <picture>

                        <source sizes="(min-width: 480px) 480px, 100vw"
                                srcset="../assets/akzp3-8qnmt.jpg"
                                type="image/avif">
                        <source sizes="(min-width: 480px) 480px, 100vw"
                                srcset="../assets/akzp3-8qnmt.jpg"
                                type="image/webp">
                        <img alt="" decoding="async"
                             loading="lazy" sizes="(min-width: 480px) 480px, 100vw"
                             src="../assets/akzp3-8qnmt.jpg"
                             srcset="../assets/akzp3-8qnmt.jpg"
                             style="opacity: 1;">
                      </picture>
                      <noscript>
                        <picture>
                          <source sizes="(min-width: 480px) 480px, 100vw"
                                  srcSet="https://images.ctfassets.net/zuzqvf4m2o58/4UxzK9ndoSbG72EU8LRYJk/07791fb6403f17db50912e701b6381ff/Frame_2085662310_2.png?w=360&amp;h=179&amp;q=50&amp;fm=avif 360w,https://images.ctfassets.net/zuzqvf4m2o58/4UxzK9ndoSbG72EU8LRYJk/07791fb6403f17db50912e701b6381ff/Frame_2085662310_2.png?w=480&amp;h=238&amp;q=50&amp;fm=avif 480w,https://images.ctfassets.net/zuzqvf4m2o58/4UxzK9ndoSbG72EU8LRYJk/07791fb6403f17db50912e701b6381ff/Frame_2085662310_2.png?w=600&amp;h=298&amp;q=50&amp;fm=avif 600w,https://images.ctfassets.net/zuzqvf4m2o58/4UxzK9ndoSbG72EU8LRYJk/07791fb6403f17db50912e701b6381ff/Frame_2085662310_2.png?w=900&amp;h=446&amp;q=50&amp;fm=avif 900w,https://images.ctfassets.net/zuzqvf4m2o58/4UxzK9ndoSbG72EU8LRYJk/07791fb6403f17db50912e701b6381ff/Frame_2085662310_2.png?w=1200&amp;h=595&amp;q=50&amp;fm=avif 1200w,https://images.ctfassets.net/zuzqvf4m2o58/4UxzK9ndoSbG72EU8LRYJk/07791fb6403f17db50912e701b6381ff/Frame_2085662310_2.png?w=1527&amp;h=757&amp;q=50&amp;fm=avif 1527w"
                                  type="image/avif"/>
                          <source sizes="(min-width: 480px) 480px, 100vw"
                                  srcSet="https://images.ctfassets.net/zuzqvf4m2o58/4UxzK9ndoSbG72EU8LRYJk/07791fb6403f17db50912e701b6381ff/Frame_2085662310_2.png?w=360&amp;h=179&amp;q=50&amp;fm=webp 360w,https://images.ctfassets.net/zuzqvf4m2o58/4UxzK9ndoSbG72EU8LRYJk/07791fb6403f17db50912e701b6381ff/Frame_2085662310_2.png?w=480&amp;h=238&amp;q=50&amp;fm=webp 480w,https://images.ctfassets.net/zuzqvf4m2o58/4UxzK9ndoSbG72EU8LRYJk/07791fb6403f17db50912e701b6381ff/Frame_2085662310_2.png?w=600&amp;h=298&amp;q=50&amp;fm=webp 600w,https://images.ctfassets.net/zuzqvf4m2o58/4UxzK9ndoSbG72EU8LRYJk/07791fb6403f17db50912e701b6381ff/Frame_2085662310_2.png?w=900&amp;h=446&amp;q=50&amp;fm=webp 900w,https://images.ctfassets.net/zuzqvf4m2o58/4UxzK9ndoSbG72EU8LRYJk/07791fb6403f17db50912e701b6381ff/Frame_2085662310_2.png?w=1200&amp;h=595&amp;q=50&amp;fm=webp 1200w,https://images.ctfassets.net/zuzqvf4m2o58/4UxzK9ndoSbG72EU8LRYJk/07791fb6403f17db50912e701b6381ff/Frame_2085662310_2.png?w=1527&amp;h=757&amp;q=50&amp;fm=webp 1527w"
                                  type="image/webp"/>
                          <img
                              alt="" data-gatsby-image-ssr=""
                              decoding="async" loading="lazy"
                              sizes="(min-width: 480px) 480px, 100vw"
                              src="https://images.ctfassets.net/zuzqvf4m2o58/4UxzK9ndoSbG72EU8LRYJk/07791fb6403f17db50912e701b6381ff/Frame_2085662310_2.png?w=480&amp;h=238&amp;q=50&amp;fm=png"
                              srcSet="https://images.ctfassets.net/zuzqvf4m2o58/4UxzK9ndoSbG72EU8LRYJk/07791fb6403f17db50912e701b6381ff/Frame_2085662310_2.png?w=360&amp;h=179&amp;q=50&amp;fm=png 360w,https://images.ctfassets.net/zuzqvf4m2o58/4UxzK9ndoSbG72EU8LRYJk/07791fb6403f17db50912e701b6381ff/Frame_2085662310_2.png?w=480&amp;h=238&amp;q=50&amp;fm=png 480w,https://images.ctfassets.net/zuzqvf4m2o58/4UxzK9ndoSbG72EU8LRYJk/07791fb6403f17db50912e701b6381ff/Frame_2085662310_2.png?w=600&amp;h=298&amp;q=50&amp;fm=png 600w,https://images.ctfassets.net/zuzqvf4m2o58/4UxzK9ndoSbG72EU8LRYJk/07791fb6403f17db50912e701b6381ff/Frame_2085662310_2.png?w=900&amp;h=446&amp;q=50&amp;fm=png 900w,https://images.ctfassets.net/zuzqvf4m2o58/4UxzK9ndoSbG72EU8LRYJk/07791fb6403f17db50912e701b6381ff/Frame_2085662310_2.png?w=1200&amp;h=595&amp;q=50&amp;fm=png 1200w,https://images.ctfassets.net/zuzqvf4m2o58/4UxzK9ndoSbG72EU8LRYJk/07791fb6403f17db50912e701b6381ff/Frame_2085662310_2.png?w=1527&amp;h=757&amp;q=50&amp;fm=png 1527w"
                              style="opacity:0"/>
                        </picture>
                      </noscript>
                      <script
                          type="module">const t = "undefined" != typeof HTMLImageElement && "loading" in HTMLImageElement.prototype;
                      if (t) {
                        const t = document.querySelectorAll("img[data-main-image]");
                        for (let e of t) {
                          e.dataset.src && (e.setAttribute("src", e.dataset.src), e.removeAttribute("data-src")), e.dataset.srcset && (e.setAttribute("srcset", e.dataset.srcset), e.removeAttribute("data-srcset"));
                          const t = e.parentNode.querySelectorAll("source[data-srcset]");
                          for (let e of t) e.setAttribute("srcset", e.dataset.srcset), e.removeAttribute("data-srcset");
                          e.complete && (e.style.opacity = 1, e.parentNode.parentNode.querySelector("[data-placeholder-image]").style.opacity = 0)
                        }
                      }</script>
                    </div>
                  </article>
                </div>
              </div>
            </div>
          </section>
          <section id="0547df02-22db-5259-bb4d-1eaf4dc3006c" class="style__StyledSection-sc-qlia4f-4 dnFXqV"
                   tabindex="-1">
            <div class="sc-kfYoZR cNabcs style__HeadingWrapper-sc-qlia4f-0 iiTVnb">
              <h2 class="sc-gXfVKN hWAWcS style__StyledTitle-sc-qlia4f-1 kGzbrM" color="#151515">The
                Proven {{ siteName }} Method</h2>
              <p class="sc-hiKfDv eCtBEf" color="#151515">Have real conversations faster. Whether you’re
                learning with the award-winning app or accessing live online classes taught by
                world-class teachers, the {{ siteName }} Method is designed to get you speaking within
                just
                three weeks.</p>
            </div>
            <div class="sc-kfYoZR iNqYiX style__RoundedColoredContainer-sc-qlia4f-2 laSVXZ">
              <div class="sc-kfYoZR jLufbg style__ItemsContainer-sc-qlia4f-3 jHFrmi">
                <div class="sc-kfYoZR hrDoZu">
                  <div class="gatsby-image-wrapper gatsby-image-wrapper-constrained"
                       data-gatsby-image-wrapper="">
                    <div style="max-width:48px;display:block"><img alt="" aria-hidden="true"
                                                                   role="presentation"
                                                                   src="data:image/svg+xml;charset=utf-8,%3Csvg%20height='49'%20width='48'%20xmlns='http://www.w3.org/2000/svg'%20version='1.1'%3E%3C/svg%3E"
                                                                   style="max-width:100%;display:block;position:static">
                    </div>
                    <div aria-hidden="true" data-placeholder-image=""
                         style="opacity: 0; transition: opacity 500ms linear 0s;"></div>
                    <picture>
                      <source
                          srcset="//images.ctfassets.net/zuzqvf4m2o58/6lXpdQtU0VNkgSOzwMsdXn/b67be6acdc012a8e460fb2190d3c8c7c/Medal.svg"
                          type="image/svg+xml">
                      <img alt="" decoding="async" loading="lazy"
                           src="//images.ctfassets.net/zuzqvf4m2o58/6lXpdQtU0VNkgSOzwMsdXn/b67be6acdc012a8e460fb2190d3c8c7c/Medal.svg"
                           style="opacity: 1;">
                    </picture>
                    <noscript>
                      <picture>
                        <source
                            srcSet="//images.ctfassets.net/zuzqvf4m2o58/6lXpdQtU0VNkgSOzwMsdXn/b67be6acdc012a8e460fb2190d3c8c7c/Medal.svg"
                            type="image/svg+xml"/>
                        <img alt="" data-gatsby-image-ssr="" decoding="async"
                             loading="lazy"
                             src="//images.ctfassets.net/zuzqvf4m2o58/6lXpdQtU0VNkgSOzwMsdXn/b67be6acdc012a8e460fb2190d3c8c7c/Medal.svg"
                             style="opacity:0"/>
                      </picture>
                    </noscript>
                    <script
                        type="module">const t = "undefined" != typeof HTMLImageElement && "loading" in HTMLImageElement.prototype;
                    if (t) {
                      const t = document.querySelectorAll("img[data-main-image]");
                      for (let e of t) {
                        e.dataset.src && (e.setAttribute("src", e.dataset.src), e.removeAttribute("data-src")), e.dataset.srcset && (e.setAttribute("srcset", e.dataset.srcset), e.removeAttribute("data-srcset"));
                        const t = e.parentNode.querySelectorAll("source[data-srcset]");
                        for (let e of t) e.setAttribute("srcset", e.dataset.srcset), e.removeAttribute("data-srcset");
                        e.complete && (e.style.opacity = 1, e.parentNode.parentNode.querySelector("[data-placeholder-image]").style.opacity = 0)
                      }
                    }</script>
                  </div>
                  <div class="sc-kfYoZR gkQoUp style__ContentStack-sc-16uiq8m-0 dHKQVL">
                    <h3 class="sc-gXfVKN itVhGI" color="#151515">15M</h3>
                    <p class="sc-hiKfDv eCtBEf" color="#151515"> Subscriptions Sold</p>
                  </div>
                </div>
                <div class="sc-kfYoZR hrDoZu">
                  <div class="gatsby-image-wrapper gatsby-image-wrapper-constrained"
                       data-gatsby-image-wrapper="">
                    <div style="max-width:48px;display:block"><img alt="" aria-hidden="true"
                                                                   role="presentation"
                                                                   src="data:image/svg+xml;charset=utf-8,%3Csvg%20height='49'%20width='48'%20xmlns='http://www.w3.org/2000/svg'%20version='1.1'%3E%3C/svg%3E"
                                                                   style="max-width:100%;display:block;position:static">
                    </div>
                    <div aria-hidden="true" data-placeholder-image=""
                         style="opacity: 0; transition: opacity 500ms linear 0s;"></div>
                    <picture>
                      <source
                          srcset="//images.ctfassets.net/zuzqvf4m2o58/5WDMVtbMBLtu0UiMtl4Ox2/5ecebd5f91462ab23b0ed81d96b4d6bc/Lightbulb.svg"
                          type="image/svg+xml">
                      <img alt="" decoding="async" loading="lazy"
                           src="//images.ctfassets.net/zuzqvf4m2o58/5WDMVtbMBLtu0UiMtl4Ox2/5ecebd5f91462ab23b0ed81d96b4d6bc/Lightbulb.svg"
                           style="opacity: 1;">
                    </picture>
                    <noscript>
                      <picture>
                        <source
                            srcSet="//images.ctfassets.net/zuzqvf4m2o58/5WDMVtbMBLtu0UiMtl4Ox2/5ecebd5f91462ab23b0ed81d96b4d6bc/Lightbulb.svg"
                            type="image/svg+xml"/>
                        <img alt="" data-gatsby-image-ssr="" decoding="async"
                             loading="lazy"
                             src="//images.ctfassets.net/zuzqvf4m2o58/5WDMVtbMBLtu0UiMtl4Ox2/5ecebd5f91462ab23b0ed81d96b4d6bc/Lightbulb.svg"
                             style="opacity:0"/>
                      </picture>
                    </noscript>
                    <script
                        type="module">const t = "undefined" != typeof HTMLImageElement && "loading" in HTMLImageElement.prototype;
                    if (t) {
                      const t = document.querySelectorAll("img[data-main-image]");
                      for (let e of t) {
                        e.dataset.src && (e.setAttribute("src", e.dataset.src), e.removeAttribute("data-src")), e.dataset.srcset && (e.setAttribute("srcset", e.dataset.srcset), e.removeAttribute("data-srcset"));
                        const t = e.parentNode.querySelectorAll("source[data-srcset]");
                        for (let e of t) e.setAttribute("srcset", e.dataset.srcset), e.removeAttribute("data-srcset");
                        e.complete && (e.style.opacity = 1, e.parentNode.parentNode.querySelector("[data-placeholder-image]").style.opacity = 0)
                      }
                    }</script>
                  </div>
                  <div class="sc-kfYoZR gkQoUp style__ContentStack-sc-16uiq8m-0 dHKQVL">
                    <h3 class="sc-gXfVKN itVhGI" color="#151515">92%</h3>
                    <p class="sc-hiKfDv eCtBEf" color="#151515"> of users improved their proficiency
                      in just 2 months*</p>
                  </div>
                </div>
                <div class="sc-kfYoZR hrDoZu">
                  <div class="gatsby-image-wrapper gatsby-image-wrapper-constrained"
                       data-gatsby-image-wrapper="">
                    <div style="max-width:48px;display:block"><img alt="" aria-hidden="true"
                                                                   role="presentation"
                                                                   src="data:image/svg+xml;charset=utf-8,%3Csvg%20height='49'%20width='48'%20xmlns='http://www.w3.org/2000/svg'%20version='1.1'%3E%3C/svg%3E"
                                                                   style="max-width:100%;display:block;position:static">
                    </div>
                    <div aria-hidden="true" data-placeholder-image=""
                         style="opacity: 0; transition: opacity 500ms linear 0s;"></div>
                    <picture>
                      <source
                          srcset="//images.ctfassets.net/zuzqvf4m2o58/3xzICoLIm8vwzOR6f1Zooy/ffc0079502d76d9e3241415879f3ff23/Users.svg"
                          type="image/svg+xml">
                      <img alt="" decoding="async" loading="lazy"
                           src="//images.ctfassets.net/zuzqvf4m2o58/3xzICoLIm8vwzOR6f1Zooy/ffc0079502d76d9e3241415879f3ff23/Users.svg"
                           style="opacity: 1;">
                    </picture>
                    <noscript>
                      <picture>
                        <source
                            srcSet="//images.ctfassets.net/zuzqvf4m2o58/3xzICoLIm8vwzOR6f1Zooy/ffc0079502d76d9e3241415879f3ff23/Users.svg"
                            type="image/svg+xml"/>
                        <img alt="" data-gatsby-image-ssr="" decoding="async"
                             loading="lazy"
                             src="//images.ctfassets.net/zuzqvf4m2o58/3xzICoLIm8vwzOR6f1Zooy/ffc0079502d76d9e3241415879f3ff23/Users.svg"
                             style="opacity:0"/>
                      </picture>
                    </noscript>
                    <script
                        type="module">const t = "undefined" != typeof HTMLImageElement && "loading" in HTMLImageElement.prototype;
                    if (t) {
                      const t = document.querySelectorAll("img[data-main-image]");
                      for (let e of t) {
                        e.dataset.src && (e.setAttribute("src", e.dataset.src), e.removeAttribute("data-src")), e.dataset.srcset && (e.setAttribute("srcset", e.dataset.srcset), e.removeAttribute("data-srcset"));
                        const t = e.parentNode.querySelectorAll("source[data-srcset]");
                        for (let e of t) e.setAttribute("srcset", e.dataset.srcset), e.removeAttribute("data-srcset");
                        e.complete && (e.style.opacity = 1, e.parentNode.parentNode.querySelector("[data-placeholder-image]").style.opacity = 0)
                      }
                    }</script>
                  </div>
                  <div class="sc-kfYoZR gkQoUp style__ContentStack-sc-16uiq8m-0 dHKQVL">
                    <h3 class="sc-gXfVKN itVhGI" color="#151515">200+</h3>
                    <p class="sc-hiKfDv eCtBEf" color="#151515"> team of language experts</p>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section id="78ed68db-2a9a-5416-8a36-2892f9e66609" class="sc-ciSkZP hVfNzt" tabindex="-1">
            <div class="sc-kfYoZR bFRrHW style__RootContentWrapper-sc-nk2gyy-0 iHKGjX">
              <h2 class="sc-gXfVKN eNgEXm style__StyledTitle-sc-nk2gyy-1 kuOEDh" color="#151515">Your
                guaranteed path towards <em class="style__StyledItalic-sc-eykdt1-4 fVwJBM">speaking</em>
                a new language</h2>
            </div>
            <div class="sc-ciSkZP kcSChc">
              <div>
                <article>
                  <div class="sc-kfYoZR dCKHNs style__StyledLayout-sc-1qtvo0c-0 crjqVb">
                    <div
                        class="gatsby-image-wrapper gatsby-image-wrapper-constrained style__InfoBlockImage-sc-1qtvo0c-1 dszIqw"
                        data-gatsby-image-wrapper="">
                      <div style="max-width:1722px;display:block"><img alt="" aria-hidden="true"
                                                                       role="presentation"
                                                                       src="data:image/svg+xml;charset=utf-8,%3Csvg%20height='2038'%20width='1722'%20xmlns='http://www.w3.org/2000/svg'%20version='1.1'%3E%3C/svg%3E"
                                                                       style="max-width:100%;display:block;position:static">
                      </div>
                      <div aria-hidden="true" data-placeholder-image=""
                           style="opacity: 0; transition: opacity 500ms linear 0s;"></div>
                      <picture>
                        <source
                            sizes="(min-width: 1600px) 610px, (min-width: 1200px) 450px, (min-width: 900px) 404px, 100vw"
                            srcset="https://images.ctfassets.net/zuzqvf4m2o58/6hUHNrLE3NGCxUQCHKMTM6/410b50aef3c40e91dbc89116ea7e0a61/Frame_2085662311.png?w=360&amp;h=426&amp;q=50&amp;fm=avif 360w,https://images.ctfassets.net/zuzqvf4m2o58/6hUHNrLE3NGCxUQCHKMTM6/410b50aef3c40e91dbc89116ea7e0a61/Frame_2085662311.png?w=600&amp;h=710&amp;q=50&amp;fm=avif 600w,https://images.ctfassets.net/zuzqvf4m2o58/6hUHNrLE3NGCxUQCHKMTM6/410b50aef3c40e91dbc89116ea7e0a61/Frame_2085662311.png?w=900&amp;h=1065&amp;q=50&amp;fm=avif 900w,https://images.ctfassets.net/zuzqvf4m2o58/6hUHNrLE3NGCxUQCHKMTM6/410b50aef3c40e91dbc89116ea7e0a61/Frame_2085662311.png?w=1200&amp;h=1420&amp;q=50&amp;fm=avif 1200w,https://images.ctfassets.net/zuzqvf4m2o58/6hUHNrLE3NGCxUQCHKMTM6/410b50aef3c40e91dbc89116ea7e0a61/Frame_2085662311.png?w=1600&amp;h=1894&amp;q=50&amp;fm=avif 1600w,https://images.ctfassets.net/zuzqvf4m2o58/6hUHNrLE3NGCxUQCHKMTM6/410b50aef3c40e91dbc89116ea7e0a61/Frame_2085662311.png?w=1722&amp;h=2038&amp;q=50&amp;fm=avif 1722w"
                            type="image/avif">
                        <source
                            sizes="(min-width: 1600px) 610px, (min-width: 1200px) 450px, (min-width: 900px) 404px, 100vw"
                            srcset="https://images.ctfassets.net/zuzqvf4m2o58/6hUHNrLE3NGCxUQCHKMTM6/410b50aef3c40e91dbc89116ea7e0a61/Frame_2085662311.png?w=360&amp;h=426&amp;q=50&amp;fm=webp 360w,https://images.ctfassets.net/zuzqvf4m2o58/6hUHNrLE3NGCxUQCHKMTM6/410b50aef3c40e91dbc89116ea7e0a61/Frame_2085662311.png?w=600&amp;h=710&amp;q=50&amp;fm=webp 600w,https://images.ctfassets.net/zuzqvf4m2o58/6hUHNrLE3NGCxUQCHKMTM6/410b50aef3c40e91dbc89116ea7e0a61/Frame_2085662311.png?w=900&amp;h=1065&amp;q=50&amp;fm=webp 900w,https://images.ctfassets.net/zuzqvf4m2o58/6hUHNrLE3NGCxUQCHKMTM6/410b50aef3c40e91dbc89116ea7e0a61/Frame_2085662311.png?w=1200&amp;h=1420&amp;q=50&amp;fm=webp 1200w,https://images.ctfassets.net/zuzqvf4m2o58/6hUHNrLE3NGCxUQCHKMTM6/410b50aef3c40e91dbc89116ea7e0a61/Frame_2085662311.png?w=1600&amp;h=1894&amp;q=50&amp;fm=webp 1600w,https://images.ctfassets.net/zuzqvf4m2o58/6hUHNrLE3NGCxUQCHKMTM6/410b50aef3c40e91dbc89116ea7e0a61/Frame_2085662311.png?w=1722&amp;h=2038&amp;q=50&amp;fm=webp 1722w"
                            type="image/webp">
                        <img alt=""
                             decoding="async"
                             loading="lazy"
                             sizes="(min-width: 1600px) 610px, (min-width: 1200px) 450px, (min-width: 900px) 404px, 100vw"
                             src="https://images.ctfassets.net/zuzqvf4m2o58/6hUHNrLE3NGCxUQCHKMTM6/410b50aef3c40e91dbc89116ea7e0a61/Frame_2085662311.png?w=1722&amp;h=2038&amp;q=50&amp;fm=png"
                             srcset="https://images.ctfassets.net/zuzqvf4m2o58/6hUHNrLE3NGCxUQCHKMTM6/410b50aef3c40e91dbc89116ea7e0a61/Frame_2085662311.png?w=360&amp;h=426&amp;q=50&amp;fm=png 360w,https://images.ctfassets.net/zuzqvf4m2o58/6hUHNrLE3NGCxUQCHKMTM6/410b50aef3c40e91dbc89116ea7e0a61/Frame_2085662311.png?w=600&amp;h=710&amp;q=50&amp;fm=png 600w,https://images.ctfassets.net/zuzqvf4m2o58/6hUHNrLE3NGCxUQCHKMTM6/410b50aef3c40e91dbc89116ea7e0a61/Frame_2085662311.png?w=900&amp;h=1065&amp;q=50&amp;fm=png 900w,https://images.ctfassets.net/zuzqvf4m2o58/6hUHNrLE3NGCxUQCHKMTM6/410b50aef3c40e91dbc89116ea7e0a61/Frame_2085662311.png?w=1200&amp;h=1420&amp;q=50&amp;fm=png 1200w,https://images.ctfassets.net/zuzqvf4m2o58/6hUHNrLE3NGCxUQCHKMTM6/410b50aef3c40e91dbc89116ea7e0a61/Frame_2085662311.png?w=1600&amp;h=1894&amp;q=50&amp;fm=png 1600w,https://images.ctfassets.net/zuzqvf4m2o58/6hUHNrLE3NGCxUQCHKMTM6/410b50aef3c40e91dbc89116ea7e0a61/Frame_2085662311.png?w=1722&amp;h=2038&amp;q=50&amp;fm=png 1722w"
                             style="opacity: 1;">
                      </picture>
                      <noscript>
                        <picture>
                          <source
                              sizes="(min-width: 1600px) 610px, (min-width: 1200px) 450px, (min-width: 900px) 404px, 100vw"
                              srcSet="https://images.ctfassets.net/zuzqvf4m2o58/6hUHNrLE3NGCxUQCHKMTM6/410b50aef3c40e91dbc89116ea7e0a61/Frame_2085662311.png?w=360&amp;h=426&amp;q=50&amp;fm=avif 360w,https://images.ctfassets.net/zuzqvf4m2o58/6hUHNrLE3NGCxUQCHKMTM6/410b50aef3c40e91dbc89116ea7e0a61/Frame_2085662311.png?w=600&amp;h=710&amp;q=50&amp;fm=avif 600w,https://images.ctfassets.net/zuzqvf4m2o58/6hUHNrLE3NGCxUQCHKMTM6/410b50aef3c40e91dbc89116ea7e0a61/Frame_2085662311.png?w=900&amp;h=1065&amp;q=50&amp;fm=avif 900w,https://images.ctfassets.net/zuzqvf4m2o58/6hUHNrLE3NGCxUQCHKMTM6/410b50aef3c40e91dbc89116ea7e0a61/Frame_2085662311.png?w=1200&amp;h=1420&amp;q=50&amp;fm=avif 1200w,https://images.ctfassets.net/zuzqvf4m2o58/6hUHNrLE3NGCxUQCHKMTM6/410b50aef3c40e91dbc89116ea7e0a61/Frame_2085662311.png?w=1600&amp;h=1894&amp;q=50&amp;fm=avif 1600w,https://images.ctfassets.net/zuzqvf4m2o58/6hUHNrLE3NGCxUQCHKMTM6/410b50aef3c40e91dbc89116ea7e0a61/Frame_2085662311.png?w=1722&amp;h=2038&amp;q=50&amp;fm=avif 1722w"
                              type="image/avif"/>
                          <source
                              sizes="(min-width: 1600px) 610px, (min-width: 1200px) 450px, (min-width: 900px) 404px, 100vw"
                              srcSet="https://images.ctfassets.net/zuzqvf4m2o58/6hUHNrLE3NGCxUQCHKMTM6/410b50aef3c40e91dbc89116ea7e0a61/Frame_2085662311.png?w=360&amp;h=426&amp;q=50&amp;fm=webp 360w,https://images.ctfassets.net/zuzqvf4m2o58/6hUHNrLE3NGCxUQCHKMTM6/410b50aef3c40e91dbc89116ea7e0a61/Frame_2085662311.png?w=600&amp;h=710&amp;q=50&amp;fm=webp 600w,https://images.ctfassets.net/zuzqvf4m2o58/6hUHNrLE3NGCxUQCHKMTM6/410b50aef3c40e91dbc89116ea7e0a61/Frame_2085662311.png?w=900&amp;h=1065&amp;q=50&amp;fm=webp 900w,https://images.ctfassets.net/zuzqvf4m2o58/6hUHNrLE3NGCxUQCHKMTM6/410b50aef3c40e91dbc89116ea7e0a61/Frame_2085662311.png?w=1200&amp;h=1420&amp;q=50&amp;fm=webp 1200w,https://images.ctfassets.net/zuzqvf4m2o58/6hUHNrLE3NGCxUQCHKMTM6/410b50aef3c40e91dbc89116ea7e0a61/Frame_2085662311.png?w=1600&amp;h=1894&amp;q=50&amp;fm=webp 1600w,https://images.ctfassets.net/zuzqvf4m2o58/6hUHNrLE3NGCxUQCHKMTM6/410b50aef3c40e91dbc89116ea7e0a61/Frame_2085662311.png?w=1722&amp;h=2038&amp;q=50&amp;fm=webp 1722w"
                              type="image/webp"/>
                          <img alt="" data-gatsby-image-ssr=""
                               decoding="async"
                               loading="lazy"
                               sizes="(min-width: 1600px) 610px, (min-width: 1200px) 450px, (min-width: 900px) 404px, 100vw"
                               src="https://images.ctfassets.net/zuzqvf4m2o58/6hUHNrLE3NGCxUQCHKMTM6/410b50aef3c40e91dbc89116ea7e0a61/Frame_2085662311.png?w=1722&amp;h=2038&amp;q=50&amp;fm=png"
                               srcSet="https://images.ctfassets.net/zuzqvf4m2o58/6hUHNrLE3NGCxUQCHKMTM6/410b50aef3c40e91dbc89116ea7e0a61/Frame_2085662311.png?w=360&amp;h=426&amp;q=50&amp;fm=png 360w,https://images.ctfassets.net/zuzqvf4m2o58/6hUHNrLE3NGCxUQCHKMTM6/410b50aef3c40e91dbc89116ea7e0a61/Frame_2085662311.png?w=600&amp;h=710&amp;q=50&amp;fm=png 600w,https://images.ctfassets.net/zuzqvf4m2o58/6hUHNrLE3NGCxUQCHKMTM6/410b50aef3c40e91dbc89116ea7e0a61/Frame_2085662311.png?w=900&amp;h=1065&amp;q=50&amp;fm=png 900w,https://images.ctfassets.net/zuzqvf4m2o58/6hUHNrLE3NGCxUQCHKMTM6/410b50aef3c40e91dbc89116ea7e0a61/Frame_2085662311.png?w=1200&amp;h=1420&amp;q=50&amp;fm=png 1200w,https://images.ctfassets.net/zuzqvf4m2o58/6hUHNrLE3NGCxUQCHKMTM6/410b50aef3c40e91dbc89116ea7e0a61/Frame_2085662311.png?w=1600&amp;h=1894&amp;q=50&amp;fm=png 1600w,https://images.ctfassets.net/zuzqvf4m2o58/6hUHNrLE3NGCxUQCHKMTM6/410b50aef3c40e91dbc89116ea7e0a61/Frame_2085662311.png?w=1722&amp;h=2038&amp;q=50&amp;fm=png 1722w"
                               style="opacity:0"/>
                        </picture>
                      </noscript>
                      <script
                          type="module">const t = "undefined" != typeof HTMLImageElement && "loading" in HTMLImageElement.prototype;
                      if (t) {
                        const t = document.querySelectorAll("img[data-main-image]");
                        for (let e of t) {
                          e.dataset.src && (e.setAttribute("src", e.dataset.src), e.removeAttribute("data-src")), e.dataset.srcset && (e.setAttribute("srcset", e.dataset.srcset), e.removeAttribute("data-srcset"));
                          const t = e.parentNode.querySelectorAll("source[data-srcset]");
                          for (let e of t) e.setAttribute("srcset", e.dataset.srcset), e.removeAttribute("data-srcset");
                          e.complete && (e.style.opacity = 1, e.parentNode.parentNode.querySelector("[data-placeholder-image]").style.opacity = 0)
                        }
                      }</script>
                    </div>
                    <div class="sc-kfYoZR dnBnCe style__ContentLayout-sc-1qtvo0c-3 iUTHsV">
                      <div class="sc-kfYoZR eyeIOI">
                        <h3 class="sc-gXfVKN jtKwaN" color="default">The key to meaningful
                          conversations</h3>
                        <div class="sc-hiKfDv eCtBEf style__StyledText-sc-eykdt1-0 ewlJBf"
                             color="default">
                          <p class="style__StyledParagraph-sc-eykdt1-1 fUyLx">With
                            {{ siteName }},
                            you’ll learn practical and useful skills that you can apply
                            right away — so you can reach your goal of having real-life
                            conversations faster.</p>
                        </div>
                      </div>
                      <div class="sc-kfYoZR kJKzWc"><a class="sc-hBMUJo dzZuYr"
                                                       color="primary-default"
                                                       @click="showLoginDialog=true"><span
                          class="sc-iCoGMd goTNSB"
                          color="currentColor">Get started now</span></a></div>
                    </div>
                  </div>
                </article>
              </div>
              <div>
                <article>
                  <div class="sc-kfYoZR dCKHNs style__StyledLayout-sc-1qtvo0c-0 cJEUxi">
                    <div
                        class="gatsby-image-wrapper gatsby-image-wrapper-constrained style__InfoBlockImage-sc-1qtvo0c-1 dszIqw"
                        data-gatsby-image-wrapper="">
                      <div style="max-width:1725px;display:block"><img alt="" aria-hidden="true"
                                                                       role="presentation"
                                                                       src="data:image/svg+xml;charset=utf-8,%3Csvg%20height='2038.0000000000002'%20width='1725'%20xmlns='http://www.w3.org/2000/svg'%20version='1.1'%3E%3C/svg%3E"
                                                                       style="max-width:100%;display:block;position:static">
                      </div>
                      <div aria-hidden="true" data-placeholder-image=""
                           style="opacity: 0; transition: opacity 500ms linear 0s;"></div>
                      <picture>
                        <source
                            sizes="(min-width: 1600px) 610px, (min-width: 1200px) 450px, (min-width: 900px) 404px, 100vw"
                            srcset="https://images.ctfassets.net/zuzqvf4m2o58/5pKEciNveao1Ui5BesdYCk/4f77c2356bc987d9b3f732a987c87764/Frame_2085662312.png?w=360&amp;h=425&amp;q=50&amp;fm=avif 360w,https://images.ctfassets.net/zuzqvf4m2o58/5pKEciNveao1Ui5BesdYCk/4f77c2356bc987d9b3f732a987c87764/Frame_2085662312.png?w=600&amp;h=709&amp;q=50&amp;fm=avif 600w,https://images.ctfassets.net/zuzqvf4m2o58/5pKEciNveao1Ui5BesdYCk/4f77c2356bc987d9b3f732a987c87764/Frame_2085662312.png?w=900&amp;h=1063&amp;q=50&amp;fm=avif 900w,https://images.ctfassets.net/zuzqvf4m2o58/5pKEciNveao1Ui5BesdYCk/4f77c2356bc987d9b3f732a987c87764/Frame_2085662312.png?w=1200&amp;h=1418&amp;q=50&amp;fm=avif 1200w,https://images.ctfassets.net/zuzqvf4m2o58/5pKEciNveao1Ui5BesdYCk/4f77c2356bc987d9b3f732a987c87764/Frame_2085662312.png?w=1600&amp;h=1890&amp;q=50&amp;fm=avif 1600w,https://images.ctfassets.net/zuzqvf4m2o58/5pKEciNveao1Ui5BesdYCk/4f77c2356bc987d9b3f732a987c87764/Frame_2085662312.png?w=1725&amp;h=2038&amp;q=50&amp;fm=avif 1725w"
                            type="image/avif">
                        <source
                            sizes="(min-width: 1600px) 610px, (min-width: 1200px) 450px, (min-width: 900px) 404px, 100vw"
                            srcset="https://images.ctfassets.net/zuzqvf4m2o58/5pKEciNveao1Ui5BesdYCk/4f77c2356bc987d9b3f732a987c87764/Frame_2085662312.png?w=360&amp;h=425&amp;q=50&amp;fm=webp 360w,https://images.ctfassets.net/zuzqvf4m2o58/5pKEciNveao1Ui5BesdYCk/4f77c2356bc987d9b3f732a987c87764/Frame_2085662312.png?w=600&amp;h=709&amp;q=50&amp;fm=webp 600w,https://images.ctfassets.net/zuzqvf4m2o58/5pKEciNveao1Ui5BesdYCk/4f77c2356bc987d9b3f732a987c87764/Frame_2085662312.png?w=900&amp;h=1063&amp;q=50&amp;fm=webp 900w,https://images.ctfassets.net/zuzqvf4m2o58/5pKEciNveao1Ui5BesdYCk/4f77c2356bc987d9b3f732a987c87764/Frame_2085662312.png?w=1200&amp;h=1418&amp;q=50&amp;fm=webp 1200w,https://images.ctfassets.net/zuzqvf4m2o58/5pKEciNveao1Ui5BesdYCk/4f77c2356bc987d9b3f732a987c87764/Frame_2085662312.png?w=1600&amp;h=1890&amp;q=50&amp;fm=webp 1600w,https://images.ctfassets.net/zuzqvf4m2o58/5pKEciNveao1Ui5BesdYCk/4f77c2356bc987d9b3f732a987c87764/Frame_2085662312.png?w=1725&amp;h=2038&amp;q=50&amp;fm=webp 1725w"
                            type="image/webp">
                        <img alt=""
                             decoding="async"
                             loading="lazy"
                             sizes="(min-width: 1600px) 610px, (min-width: 1200px) 450px, (min-width: 900px) 404px, 100vw"
                             src="https://images.ctfassets.net/zuzqvf4m2o58/5pKEciNveao1Ui5BesdYCk/4f77c2356bc987d9b3f732a987c87764/Frame_2085662312.png?w=1725&amp;h=2038&amp;q=50&amp;fm=png"
                             srcset="https://images.ctfassets.net/zuzqvf4m2o58/5pKEciNveao1Ui5BesdYCk/4f77c2356bc987d9b3f732a987c87764/Frame_2085662312.png?w=360&amp;h=425&amp;q=50&amp;fm=png 360w,https://images.ctfassets.net/zuzqvf4m2o58/5pKEciNveao1Ui5BesdYCk/4f77c2356bc987d9b3f732a987c87764/Frame_2085662312.png?w=600&amp;h=709&amp;q=50&amp;fm=png 600w,https://images.ctfassets.net/zuzqvf4m2o58/5pKEciNveao1Ui5BesdYCk/4f77c2356bc987d9b3f732a987c87764/Frame_2085662312.png?w=900&amp;h=1063&amp;q=50&amp;fm=png 900w,https://images.ctfassets.net/zuzqvf4m2o58/5pKEciNveao1Ui5BesdYCk/4f77c2356bc987d9b3f732a987c87764/Frame_2085662312.png?w=1200&amp;h=1418&amp;q=50&amp;fm=png 1200w,https://images.ctfassets.net/zuzqvf4m2o58/5pKEciNveao1Ui5BesdYCk/4f77c2356bc987d9b3f732a987c87764/Frame_2085662312.png?w=1600&amp;h=1890&amp;q=50&amp;fm=png 1600w,https://images.ctfassets.net/zuzqvf4m2o58/5pKEciNveao1Ui5BesdYCk/4f77c2356bc987d9b3f732a987c87764/Frame_2085662312.png?w=1725&amp;h=2038&amp;q=50&amp;fm=png 1725w"
                             style="opacity: 1;">
                      </picture>
                      <noscript>
                        <picture>
                          <source
                              sizes="(min-width: 1600px) 610px, (min-width: 1200px) 450px, (min-width: 900px) 404px, 100vw"
                              srcSet="https://images.ctfassets.net/zuzqvf4m2o58/5pKEciNveao1Ui5BesdYCk/4f77c2356bc987d9b3f732a987c87764/Frame_2085662312.png?w=360&amp;h=425&amp;q=50&amp;fm=avif 360w,https://images.ctfassets.net/zuzqvf4m2o58/5pKEciNveao1Ui5BesdYCk/4f77c2356bc987d9b3f732a987c87764/Frame_2085662312.png?w=600&amp;h=709&amp;q=50&amp;fm=avif 600w,https://images.ctfassets.net/zuzqvf4m2o58/5pKEciNveao1Ui5BesdYCk/4f77c2356bc987d9b3f732a987c87764/Frame_2085662312.png?w=900&amp;h=1063&amp;q=50&amp;fm=avif 900w,https://images.ctfassets.net/zuzqvf4m2o58/5pKEciNveao1Ui5BesdYCk/4f77c2356bc987d9b3f732a987c87764/Frame_2085662312.png?w=1200&amp;h=1418&amp;q=50&amp;fm=avif 1200w,https://images.ctfassets.net/zuzqvf4m2o58/5pKEciNveao1Ui5BesdYCk/4f77c2356bc987d9b3f732a987c87764/Frame_2085662312.png?w=1600&amp;h=1890&amp;q=50&amp;fm=avif 1600w,https://images.ctfassets.net/zuzqvf4m2o58/5pKEciNveao1Ui5BesdYCk/4f77c2356bc987d9b3f732a987c87764/Frame_2085662312.png?w=1725&amp;h=2038&amp;q=50&amp;fm=avif 1725w"
                              type="image/avif"/>
                          <source
                              sizes="(min-width: 1600px) 610px, (min-width: 1200px) 450px, (min-width: 900px) 404px, 100vw"
                              srcSet="https://images.ctfassets.net/zuzqvf4m2o58/5pKEciNveao1Ui5BesdYCk/4f77c2356bc987d9b3f732a987c87764/Frame_2085662312.png?w=360&amp;h=425&amp;q=50&amp;fm=webp 360w,https://images.ctfassets.net/zuzqvf4m2o58/5pKEciNveao1Ui5BesdYCk/4f77c2356bc987d9b3f732a987c87764/Frame_2085662312.png?w=600&amp;h=709&amp;q=50&amp;fm=webp 600w,https://images.ctfassets.net/zuzqvf4m2o58/5pKEciNveao1Ui5BesdYCk/4f77c2356bc987d9b3f732a987c87764/Frame_2085662312.png?w=900&amp;h=1063&amp;q=50&amp;fm=webp 900w,https://images.ctfassets.net/zuzqvf4m2o58/5pKEciNveao1Ui5BesdYCk/4f77c2356bc987d9b3f732a987c87764/Frame_2085662312.png?w=1200&amp;h=1418&amp;q=50&amp;fm=webp 1200w,https://images.ctfassets.net/zuzqvf4m2o58/5pKEciNveao1Ui5BesdYCk/4f77c2356bc987d9b3f732a987c87764/Frame_2085662312.png?w=1600&amp;h=1890&amp;q=50&amp;fm=webp 1600w,https://images.ctfassets.net/zuzqvf4m2o58/5pKEciNveao1Ui5BesdYCk/4f77c2356bc987d9b3f732a987c87764/Frame_2085662312.png?w=1725&amp;h=2038&amp;q=50&amp;fm=webp 1725w"
                              type="image/webp"/>
                          <img alt="" data-gatsby-image-ssr=""
                               decoding="async"
                               loading="lazy"
                               sizes="(min-width: 1600px) 610px, (min-width: 1200px) 450px, (min-width: 900px) 404px, 100vw"
                               src="https://images.ctfassets.net/zuzqvf4m2o58/5pKEciNveao1Ui5BesdYCk/4f77c2356bc987d9b3f732a987c87764/Frame_2085662312.png?w=1725&amp;h=2038&amp;q=50&amp;fm=png"
                               srcSet="https://images.ctfassets.net/zuzqvf4m2o58/5pKEciNveao1Ui5BesdYCk/4f77c2356bc987d9b3f732a987c87764/Frame_2085662312.png?w=360&amp;h=425&amp;q=50&amp;fm=png 360w,https://images.ctfassets.net/zuzqvf4m2o58/5pKEciNveao1Ui5BesdYCk/4f77c2356bc987d9b3f732a987c87764/Frame_2085662312.png?w=600&amp;h=709&amp;q=50&amp;fm=png 600w,https://images.ctfassets.net/zuzqvf4m2o58/5pKEciNveao1Ui5BesdYCk/4f77c2356bc987d9b3f732a987c87764/Frame_2085662312.png?w=900&amp;h=1063&amp;q=50&amp;fm=png 900w,https://images.ctfassets.net/zuzqvf4m2o58/5pKEciNveao1Ui5BesdYCk/4f77c2356bc987d9b3f732a987c87764/Frame_2085662312.png?w=1200&amp;h=1418&amp;q=50&amp;fm=png 1200w,https://images.ctfassets.net/zuzqvf4m2o58/5pKEciNveao1Ui5BesdYCk/4f77c2356bc987d9b3f732a987c87764/Frame_2085662312.png?w=1600&amp;h=1890&amp;q=50&amp;fm=png 1600w,https://images.ctfassets.net/zuzqvf4m2o58/5pKEciNveao1Ui5BesdYCk/4f77c2356bc987d9b3f732a987c87764/Frame_2085662312.png?w=1725&amp;h=2038&amp;q=50&amp;fm=png 1725w"
                               style="opacity:0"/>
                        </picture>
                      </noscript>
                      <script
                          type="module">const t = "undefined" != typeof HTMLImageElement && "loading" in HTMLImageElement.prototype;
                      if (t) {
                        const t = document.querySelectorAll("img[data-main-image]");
                        for (let e of t) {
                          e.dataset.src && (e.setAttribute("src", e.dataset.src), e.removeAttribute("data-src")), e.dataset.srcset && (e.setAttribute("srcset", e.dataset.srcset), e.removeAttribute("data-srcset"));
                          const t = e.parentNode.querySelectorAll("source[data-srcset]");
                          for (let e of t) e.setAttribute("srcset", e.dataset.srcset), e.removeAttribute("data-srcset");
                          e.complete && (e.style.opacity = 1, e.parentNode.parentNode.querySelector("[data-placeholder-image]").style.opacity = 0)
                        }
                      }</script>
                    </div>
                    <div class="sc-kfYoZR dnBnCe style__ContentLayout-sc-1qtvo0c-3 iUTHsV">
                      <div class="sc-kfYoZR eyeIOI">
                        <h3 class="sc-gXfVKN jtKwaN" color="default">A learning experience
                          personalized</h3>
                        <div class="sc-hiKfDv eCtBEf style__StyledText-sc-eykdt1-0 ewlJBf"
                             color="default">
                          <p class="style__StyledParagraph-sc-eykdt1-1 fUyLx">Achieve your
                            goals with course material that’s tailored to your proficiency
                            level, interests, and time commitment. Stay motivated with
                            real-time feedback, progress trackers, and handy
                            visualizations.&nbsp;</p>
                          <p class="style__StyledParagraph-sc-eykdt1-1 fUyLx">It’s like having
                            a private tutor in your pocket.</p>
                        </div>
                      </div>
                      <div class="sc-kfYoZR kJKzWc"><a class="sc-hBMUJo dzZuYr"
                                                       color="primary-default"
                                                       @click="showLoginDialog=true"><span
                          class="sc-iCoGMd goTNSB"
                          color="currentColor">Get started now</span></a></div>
                    </div>
                  </div>
                </article>
              </div>
              <div>
                <article>
                  <div class="sc-kfYoZR dCKHNs style__StyledLayout-sc-1qtvo0c-0 crjqVb">
                    <div
                        class="gatsby-image-wrapper gatsby-image-wrapper-constrained style__InfoBlockImage-sc-1qtvo0c-1 dszIqw"
                        data-gatsby-image-wrapper="">
                      <div style="max-width:1722px;display:block"><img alt="" aria-hidden="true"
                                                                       role="presentation"
                                                                       src="data:image/svg+xml;charset=utf-8,%3Csvg%20height='2038'%20width='1722'%20xmlns='http://www.w3.org/2000/svg'%20version='1.1'%3E%3C/svg%3E"
                                                                       style="max-width:100%;display:block;position:static">
                      </div>
                      <div aria-hidden="true" data-placeholder-image=""
                           style="opacity: 0; transition: opacity 500ms linear 0s;"></div>
                      <picture>
                        <source
                            sizes="(min-width: 1600px) 610px, (min-width: 1200px) 450px, (min-width: 900px) 404px, 100vw"
                            srcset="https://images.ctfassets.net/zuzqvf4m2o58/2cY8AFxd6I0y6FpT4LoSlV/ac960cbc8154afedc7bef87ae12b27a2/Frame_2085662313.png?w=360&amp;h=426&amp;q=50&amp;fm=avif 360w,https://images.ctfassets.net/zuzqvf4m2o58/2cY8AFxd6I0y6FpT4LoSlV/ac960cbc8154afedc7bef87ae12b27a2/Frame_2085662313.png?w=600&amp;h=710&amp;q=50&amp;fm=avif 600w,https://images.ctfassets.net/zuzqvf4m2o58/2cY8AFxd6I0y6FpT4LoSlV/ac960cbc8154afedc7bef87ae12b27a2/Frame_2085662313.png?w=900&amp;h=1065&amp;q=50&amp;fm=avif 900w,https://images.ctfassets.net/zuzqvf4m2o58/2cY8AFxd6I0y6FpT4LoSlV/ac960cbc8154afedc7bef87ae12b27a2/Frame_2085662313.png?w=1200&amp;h=1420&amp;q=50&amp;fm=avif 1200w,https://images.ctfassets.net/zuzqvf4m2o58/2cY8AFxd6I0y6FpT4LoSlV/ac960cbc8154afedc7bef87ae12b27a2/Frame_2085662313.png?w=1600&amp;h=1894&amp;q=50&amp;fm=avif 1600w,https://images.ctfassets.net/zuzqvf4m2o58/2cY8AFxd6I0y6FpT4LoSlV/ac960cbc8154afedc7bef87ae12b27a2/Frame_2085662313.png?w=1722&amp;h=2038&amp;q=50&amp;fm=avif 1722w"
                            type="image/avif">
                        <source
                            sizes="(min-width: 1600px) 610px, (min-width: 1200px) 450px, (min-width: 900px) 404px, 100vw"
                            srcset="https://images.ctfassets.net/zuzqvf4m2o58/2cY8AFxd6I0y6FpT4LoSlV/ac960cbc8154afedc7bef87ae12b27a2/Frame_2085662313.png?w=360&amp;h=426&amp;q=50&amp;fm=webp 360w,https://images.ctfassets.net/zuzqvf4m2o58/2cY8AFxd6I0y6FpT4LoSlV/ac960cbc8154afedc7bef87ae12b27a2/Frame_2085662313.png?w=600&amp;h=710&amp;q=50&amp;fm=webp 600w,https://images.ctfassets.net/zuzqvf4m2o58/2cY8AFxd6I0y6FpT4LoSlV/ac960cbc8154afedc7bef87ae12b27a2/Frame_2085662313.png?w=900&amp;h=1065&amp;q=50&amp;fm=webp 900w,https://images.ctfassets.net/zuzqvf4m2o58/2cY8AFxd6I0y6FpT4LoSlV/ac960cbc8154afedc7bef87ae12b27a2/Frame_2085662313.png?w=1200&amp;h=1420&amp;q=50&amp;fm=webp 1200w,https://images.ctfassets.net/zuzqvf4m2o58/2cY8AFxd6I0y6FpT4LoSlV/ac960cbc8154afedc7bef87ae12b27a2/Frame_2085662313.png?w=1600&amp;h=1894&amp;q=50&amp;fm=webp 1600w,https://images.ctfassets.net/zuzqvf4m2o58/2cY8AFxd6I0y6FpT4LoSlV/ac960cbc8154afedc7bef87ae12b27a2/Frame_2085662313.png?w=1722&amp;h=2038&amp;q=50&amp;fm=webp 1722w"
                            type="image/webp">
                        <img alt=""
                             decoding="async"
                             loading="lazy"
                             sizes="(min-width: 1600px) 610px, (min-width: 1200px) 450px, (min-width: 900px) 404px, 100vw"
                             src="https://images.ctfassets.net/zuzqvf4m2o58/2cY8AFxd6I0y6FpT4LoSlV/ac960cbc8154afedc7bef87ae12b27a2/Frame_2085662313.png?w=1722&amp;h=2038&amp;q=50&amp;fm=png"
                             srcset="https://images.ctfassets.net/zuzqvf4m2o58/2cY8AFxd6I0y6FpT4LoSlV/ac960cbc8154afedc7bef87ae12b27a2/Frame_2085662313.png?w=360&amp;h=426&amp;q=50&amp;fm=png 360w,https://images.ctfassets.net/zuzqvf4m2o58/2cY8AFxd6I0y6FpT4LoSlV/ac960cbc8154afedc7bef87ae12b27a2/Frame_2085662313.png?w=600&amp;h=710&amp;q=50&amp;fm=png 600w,https://images.ctfassets.net/zuzqvf4m2o58/2cY8AFxd6I0y6FpT4LoSlV/ac960cbc8154afedc7bef87ae12b27a2/Frame_2085662313.png?w=900&amp;h=1065&amp;q=50&amp;fm=png 900w,https://images.ctfassets.net/zuzqvf4m2o58/2cY8AFxd6I0y6FpT4LoSlV/ac960cbc8154afedc7bef87ae12b27a2/Frame_2085662313.png?w=1200&amp;h=1420&amp;q=50&amp;fm=png 1200w,https://images.ctfassets.net/zuzqvf4m2o58/2cY8AFxd6I0y6FpT4LoSlV/ac960cbc8154afedc7bef87ae12b27a2/Frame_2085662313.png?w=1600&amp;h=1894&amp;q=50&amp;fm=png 1600w,https://images.ctfassets.net/zuzqvf4m2o58/2cY8AFxd6I0y6FpT4LoSlV/ac960cbc8154afedc7bef87ae12b27a2/Frame_2085662313.png?w=1722&amp;h=2038&amp;q=50&amp;fm=png 1722w"
                             style="opacity: 1;">
                      </picture>
                      <noscript>
                        <picture>
                          <source
                              sizes="(min-width: 1600px) 610px, (min-width: 1200px) 450px, (min-width: 900px) 404px, 100vw"
                              srcSet="https://images.ctfassets.net/zuzqvf4m2o58/2cY8AFxd6I0y6FpT4LoSlV/ac960cbc8154afedc7bef87ae12b27a2/Frame_2085662313.png?w=360&amp;h=426&amp;q=50&amp;fm=avif 360w,https://images.ctfassets.net/zuzqvf4m2o58/2cY8AFxd6I0y6FpT4LoSlV/ac960cbc8154afedc7bef87ae12b27a2/Frame_2085662313.png?w=600&amp;h=710&amp;q=50&amp;fm=avif 600w,https://images.ctfassets.net/zuzqvf4m2o58/2cY8AFxd6I0y6FpT4LoSlV/ac960cbc8154afedc7bef87ae12b27a2/Frame_2085662313.png?w=900&amp;h=1065&amp;q=50&amp;fm=avif 900w,https://images.ctfassets.net/zuzqvf4m2o58/2cY8AFxd6I0y6FpT4LoSlV/ac960cbc8154afedc7bef87ae12b27a2/Frame_2085662313.png?w=1200&amp;h=1420&amp;q=50&amp;fm=avif 1200w,https://images.ctfassets.net/zuzqvf4m2o58/2cY8AFxd6I0y6FpT4LoSlV/ac960cbc8154afedc7bef87ae12b27a2/Frame_2085662313.png?w=1600&amp;h=1894&amp;q=50&amp;fm=avif 1600w,https://images.ctfassets.net/zuzqvf4m2o58/2cY8AFxd6I0y6FpT4LoSlV/ac960cbc8154afedc7bef87ae12b27a2/Frame_2085662313.png?w=1722&amp;h=2038&amp;q=50&amp;fm=avif 1722w"
                              type="image/avif"/>
                          <source
                              sizes="(min-width: 1600px) 610px, (min-width: 1200px) 450px, (min-width: 900px) 404px, 100vw"
                              srcSet="https://images.ctfassets.net/zuzqvf4m2o58/2cY8AFxd6I0y6FpT4LoSlV/ac960cbc8154afedc7bef87ae12b27a2/Frame_2085662313.png?w=360&amp;h=426&amp;q=50&amp;fm=webp 360w,https://images.ctfassets.net/zuzqvf4m2o58/2cY8AFxd6I0y6FpT4LoSlV/ac960cbc8154afedc7bef87ae12b27a2/Frame_2085662313.png?w=600&amp;h=710&amp;q=50&amp;fm=webp 600w,https://images.ctfassets.net/zuzqvf4m2o58/2cY8AFxd6I0y6FpT4LoSlV/ac960cbc8154afedc7bef87ae12b27a2/Frame_2085662313.png?w=900&amp;h=1065&amp;q=50&amp;fm=webp 900w,https://images.ctfassets.net/zuzqvf4m2o58/2cY8AFxd6I0y6FpT4LoSlV/ac960cbc8154afedc7bef87ae12b27a2/Frame_2085662313.png?w=1200&amp;h=1420&amp;q=50&amp;fm=webp 1200w,https://images.ctfassets.net/zuzqvf4m2o58/2cY8AFxd6I0y6FpT4LoSlV/ac960cbc8154afedc7bef87ae12b27a2/Frame_2085662313.png?w=1600&amp;h=1894&amp;q=50&amp;fm=webp 1600w,https://images.ctfassets.net/zuzqvf4m2o58/2cY8AFxd6I0y6FpT4LoSlV/ac960cbc8154afedc7bef87ae12b27a2/Frame_2085662313.png?w=1722&amp;h=2038&amp;q=50&amp;fm=webp 1722w"
                              type="image/webp"/>
                          <img alt="" data-gatsby-image-ssr=""
                               decoding="async"
                               loading="lazy"
                               sizes="(min-width: 1600px) 610px, (min-width: 1200px) 450px, (min-width: 900px) 404px, 100vw"
                               src="https://images.ctfassets.net/zuzqvf4m2o58/2cY8AFxd6I0y6FpT4LoSlV/ac960cbc8154afedc7bef87ae12b27a2/Frame_2085662313.png?w=1722&amp;h=2038&amp;q=50&amp;fm=png"
                               srcSet="https://images.ctfassets.net/zuzqvf4m2o58/2cY8AFxd6I0y6FpT4LoSlV/ac960cbc8154afedc7bef87ae12b27a2/Frame_2085662313.png?w=360&amp;h=426&amp;q=50&amp;fm=png 360w,https://images.ctfassets.net/zuzqvf4m2o58/2cY8AFxd6I0y6FpT4LoSlV/ac960cbc8154afedc7bef87ae12b27a2/Frame_2085662313.png?w=600&amp;h=710&amp;q=50&amp;fm=png 600w,https://images.ctfassets.net/zuzqvf4m2o58/2cY8AFxd6I0y6FpT4LoSlV/ac960cbc8154afedc7bef87ae12b27a2/Frame_2085662313.png?w=900&amp;h=1065&amp;q=50&amp;fm=png 900w,https://images.ctfassets.net/zuzqvf4m2o58/2cY8AFxd6I0y6FpT4LoSlV/ac960cbc8154afedc7bef87ae12b27a2/Frame_2085662313.png?w=1200&amp;h=1420&amp;q=50&amp;fm=png 1200w,https://images.ctfassets.net/zuzqvf4m2o58/2cY8AFxd6I0y6FpT4LoSlV/ac960cbc8154afedc7bef87ae12b27a2/Frame_2085662313.png?w=1600&amp;h=1894&amp;q=50&amp;fm=png 1600w,https://images.ctfassets.net/zuzqvf4m2o58/2cY8AFxd6I0y6FpT4LoSlV/ac960cbc8154afedc7bef87ae12b27a2/Frame_2085662313.png?w=1722&amp;h=2038&amp;q=50&amp;fm=png 1722w"
                               style="opacity:0"/>
                        </picture>
                      </noscript>
                      <script
                          type="module">const t = "undefined" != typeof HTMLImageElement && "loading" in HTMLImageElement.prototype;
                      if (t) {
                        const t = document.querySelectorAll("img[data-main-image]");
                        for (let e of t) {
                          e.dataset.src && (e.setAttribute("src", e.dataset.src), e.removeAttribute("data-src")), e.dataset.srcset && (e.setAttribute("srcset", e.dataset.srcset), e.removeAttribute("data-srcset"));
                          const t = e.parentNode.querySelectorAll("source[data-srcset]");
                          for (let e of t) e.setAttribute("srcset", e.dataset.srcset), e.removeAttribute("data-srcset");
                          e.complete && (e.style.opacity = 1, e.parentNode.parentNode.querySelector("[data-placeholder-image]").style.opacity = 0)
                        }
                      }</script>
                    </div>
                    <div class="sc-kfYoZR dnBnCe style__ContentLayout-sc-1qtvo0c-3 iUTHsV">
                      <div class="sc-kfYoZR eyeIOI">
                        <h3 class="sc-gXfVKN jtKwaN" color="default">A complete approach</h3>
                        <div class="sc-hiKfDv eCtBEf style__StyledText-sc-eykdt1-0 ewlJBf"
                             color="default">
                          <p class="style__StyledParagraph-sc-eykdt1-1 fUyLx">Sharpen your
                            pronunciation using speech recognition. Build your conversation
                            skills with engaging, interactive dialogues. Get helpful grammar
                            tips while reading, writing, listening, and exploring culture
                            bites.</p>
                        </div>
                      </div>
                      <div class="sc-kfYoZR kJKzWc"><a class="sc-hBMUJo dzZuYr"
                                                       color="primary-default"
                                                       @click="showLoginDialog=true"><span
                          class="sc-iCoGMd goTNSB"
                          color="currentColor">Get started now</span></a></div>
                    </div>
                  </div>
                </article>
              </div>
            </div>
          </section>
          <section id="5ea86a04-cfc5-5c49-962a-ab3cb9acd846"
                   class="sc-kfYoZR AMXKy style__Section-sc-174o5v9-0 fxfLkq"
                   tabindex="-1">
            <div class="sc-kfYoZR isFalJ style__Container-sc-174o5v9-1 kA-dppG">
              <div class="sc-kfYoZR eySVyK style__StyledHeadingsAndControls-sc-174o5v9-2 eSdPCh">
                <div class="sc-kfYoZR jvUiWp">
                  <h2 class="sc-gXfVKN caSaty" color="default">People love {{ siteName }}</h2>
                  <p class="sc-hiKfDv PuhuC" color="subdued1">MIllions of 5-star reviews.**</p>
                </div>
                <div class="sc-kfYoZR cvOsxe">
                  <button aria-label="Previous"
                          class="sc-bqGGPW sc-ksluID sc-fnVZcZ iPexDg jZVOKR cOzvaY"
                          color="primary-default" disabled="" tabindex="-1" title="Previous"
                          type="button"><span
                      class="sc-fFSPTT eEJWPz"><svg aria-hidden="true" class="sc-bdnxRM flLGmz"
                                                    fill="currentColor" focusable="false"
                                                    viewBox="0 0 32 32">
                                                <path
                                                    d="M28.5 16C28.5 16.3978 28.342 16.7794 28.0607 17.0607C27.7793 17.342 27.3978 17.5 27 17.5H8.62499L15.065 23.9388C15.3468 24.2206 15.5051 24.6027 15.5051 25.0013C15.5051 25.3998 15.3468 25.782 15.065 26.0638C14.7832 26.3456 14.401 26.5039 14.0025 26.5039C13.604 26.5039 13.2218 26.3456 12.94 26.0638L3.93999 17.0638C3.80015 16.9244 3.6892 16.7588 3.61349 16.5765C3.53778 16.3942 3.49881 16.1987 3.49881 16.0013C3.49881 15.8038 3.53778 15.6084 3.61349 15.426C3.6892 15.2437 3.80015 15.0781 3.93999 14.9388L12.94 5.93876C13.0795 5.79923 13.2452 5.68855 13.4275 5.61304C13.6098 5.53752 13.8052 5.49866 14.0025 5.49866C14.1998 5.49866 14.3952 5.53752 14.5775 5.61304C14.7598 5.68855 14.9255 5.79923 15.065 5.93876C15.2045 6.07829 15.3152 6.24393 15.3907 6.42624C15.4662 6.60854 15.5051 6.80393 15.5051 7.00126C15.5051 7.19858 15.4662 7.39398 15.3907 7.57628C15.3152 7.75858 15.2045 7.92423 15.065 8.06376L8.62499 14.5H27C27.3978 14.5 27.7793 14.658 28.0607 14.9393C28.342 15.2207 28.5 15.6022 28.5 16Z">
                                                </path>
                                            </svg></span></button>
                  <button aria-label="Next" class="sc-bqGGPW sc-ksluID sc-fnVZcZ iPexDg jZVOKR cdFCro"
                          color="primary-default" title="Next"
                          type="button"><span
                      class="sc-fFSPTT eEJWPz"><svg aria-hidden="true" class="sc-bdnxRM flLGmz"
                                                    fill="currentColor" focusable="false"
                                                    viewBox="0 0 32 32">
                                                <path
                                                    d="M28.0613 17.0613L19.0613 26.0613C18.7795 26.343 18.3973 26.5014 17.9988 26.5014C17.6002 26.5014 17.218 26.343 16.9363 26.0613C16.6545 25.7795 16.4961 25.3973 16.4961 24.9988C16.4961 24.6002 16.6545 24.218 16.9363 23.9363L23.375 17.5H5C4.60218 17.5 4.22064 17.342 3.93934 17.0607C3.65804 16.7794 3.5 16.3978 3.5 16C3.5 15.6022 3.65804 15.2206 3.93934 14.9393C4.22064 14.658 4.60218 14.5 5 14.5H23.375L16.9387 8.06001C16.657 7.77821 16.4986 7.39602 16.4986 6.99751C16.4986 6.59899 16.657 6.2168 16.9387 5.93501C17.2205 5.65321 17.6027 5.4949 18.0012 5.4949C18.3998 5.4949 18.782 5.65321 19.0637 5.93501L28.0637 14.935C28.2036 15.0745 28.3145 15.2403 28.3901 15.4229C28.4657 15.6054 28.5045 15.8011 28.5043 15.9986C28.5041 16.1962 28.4648 16.3918 28.3888 16.5742C28.3127 16.7565 28.2014 16.922 28.0613 17.0613Z">
                                                </path>
                                            </svg></span></button>
                </div>
              </div>
              <div class="style__SlidesWrap-sc-174o5v9-4 dtiOOA"
                   tabindex="0">
                <div class="sc-kfYoZR fuPtPe style__Slides-sc-174o5v9-5 kHVnUE">
                  <div class="style__StyledSlide-sc-174o5v9-6 ePHhhW" data-slideindex="0">
                    <div class="sc-kfYoZR fRGFoW style__SlideInner-sc-174o5v9-7 fIfHTS">
                      <blockquote class="style__Blockquote-sc-174o5v9-8 lnWiVb">
                        <header><span class="sc-iCoGMd jsBGdm" color="default">Celeste<!-- --> |
                          <!-- -->Excellent </span></header>
                        <p class="sc-hiKfDv eCtBEf style__Quote-sc-174o5v9-9 jIBvNH"
                           color="default">{{ siteName }} is
                          excellent - short and sweet and effective lessons and great quick
                          review which is key to remembering. I love it! I’m learning Dutch!!
                        </p>
                      </blockquote>
                      <blockquote class="style__Blockquote-sc-174o5v9-8 lnWiVb">
                        <header><span class="sc-iCoGMd jsBGdm" color="default">Roslyn<!-- --> |
                          <!-- -->Excellent</span></header>
                        <p class="sc-hiKfDv eCtBEf style__Quote-sc-174o5v9-9 jIBvNH"
                           color="default">{{ siteName }} has
                          helped me to get a good grasp of the language in a fun and
                          challenging way. I enjoy the dialogues and scenarios, which include
                          helpful phrases that can be used in various situations.</p>
                      </blockquote>
                    </div>
                  </div>
                  <div class="style__StyledSlide-sc-174o5v9-6 ePHhhW" data-slideindex="1">
                    <div class="sc-kfYoZR fRGFoW style__SlideInner-sc-174o5v9-7 fIfHTS">
                      <blockquote class="style__Blockquote-sc-174o5v9-8 lnWiVb">
                        <header><span class="sc-iCoGMd jsBGdm" color="default">Andrew<!-- --> |
                          <!-- -->Excellent</span></header>
                        <p class="sc-hiKfDv eCtBEf style__Quote-sc-174o5v9-9 jIBvNH"
                           color="default">Almost
                          like real immersion. Practical dialogues that will be useful when
                          I’ll have conversations in Italian.</p>
                      </blockquote>
                      <blockquote class="style__Blockquote-sc-174o5v9-8 lnWiVb">
                        <header><span class="sc-iCoGMd jsBGdm" color="default">Pat<!-- --> |
                          <!-- -->Excellent</span></header>
                        <p class="sc-hiKfDv eCtBEf style__Quote-sc-174o5v9-9 jIBvNH"
                           color="default">Great way
                          to learn a language. Fun, interactive, and engaging. I am enjoying
                          the course immensely and would recommend it to anyone who wishes to
                          learn a second language</p>
                      </blockquote>
                    </div>
                  </div>
                  <div class="style__StyledSlide-sc-174o5v9-6 ePHhhW" data-slideindex="2">
                    <div class="sc-kfYoZR fRGFoW style__SlideInner-sc-174o5v9-7 fIfHTS">
                      <blockquote class="style__Blockquote-sc-174o5v9-8 lnWiVb">
                        <header><span class="sc-iCoGMd jsBGdm" color="default">Helen<!-- --> |
                          <!-- -->Excellent</span></header>
                        <p class="sc-hiKfDv eCtBEf style__Quote-sc-174o5v9-9 jIBvNH"
                           color="default">I love
                          this bite-sized, very clever language learning design. Genius!</p>
                      </blockquote>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section id="45d162e6-d8e0-593b-81b7-4454347dedc2" class="style__StyledSection-sc-qlia4f-4 kNstvp"
                   tabindex="-1">
            <div class="sc-kfYoZR cNabcs style__HeadingWrapper-sc-qlia4f-0 iiTVnb">
              <h2 class="sc-gXfVKN hWAWcS style__StyledTitle-sc-qlia4f-1 bcQXMu" color="#151515">
                {{ siteName }}
                and <em class="style__StyledItalic-sc-eykdt1-4 fVwJBM">beyond</em></h2>
              <p class="sc-hiKfDv eCtBEf" color="#151515">Want to immerse yourself in your new language?
                Dive into a world of language learning content.</p>
            </div>
            <div class="sc-kfYoZR iNqYiX style__RoundedColoredContainer-sc-qlia4f-2 hmrTel">
              <div class="sc-kfYoZR jLufbg style__ItemsContainer-sc-qlia4f-3 jHFrmi">
                <div class="sc-kfYoZR hrDoZu">
                  <div class="gatsby-image-wrapper gatsby-image-wrapper-constrained"
                       data-gatsby-image-wrapper="">
                    <div style="max-width:942px;display:block"><img alt="" aria-hidden="true"
                                                                    role="presentation"
                                                                    src="data:image/svg+xml;charset=utf-8,%3Csvg%20height='550'%20width='942'%20xmlns='http://www.w3.org/2000/svg'%20version='1.1'%3E%3C/svg%3E"
                                                                    style="max-width:100%;display:block;position:static">
                    </div>
                    <div aria-hidden="true" data-placeholder-image=""
                         style="opacity: 0; transition: opacity 500ms linear 0s;"></div>
                    <picture>
                      <source sizes="(min-width: 568px) 568px, 100vw"
                              srcset="https://images.ctfassets.net/zuzqvf4m2o58/2LFYqny5i36TKMJsjAA4Mh/005fda95ba4428e5ee2ef8c664c7c9a4/Frame_2085662314.png?w=360&amp;h=210&amp;q=50&amp;fm=avif 360w,https://images.ctfassets.net/zuzqvf4m2o58/2LFYqny5i36TKMJsjAA4Mh/005fda95ba4428e5ee2ef8c664c7c9a4/Frame_2085662314.png?w=600&amp;h=350&amp;q=50&amp;fm=avif 600w,https://images.ctfassets.net/zuzqvf4m2o58/2LFYqny5i36TKMJsjAA4Mh/005fda95ba4428e5ee2ef8c664c7c9a4/Frame_2085662314.png?w=900&amp;h=525&amp;q=50&amp;fm=avif 900w,https://images.ctfassets.net/zuzqvf4m2o58/2LFYqny5i36TKMJsjAA4Mh/005fda95ba4428e5ee2ef8c664c7c9a4/Frame_2085662314.png?w=942&amp;h=550&amp;q=50&amp;fm=avif 942w"
                              type="image/avif">
                      <source sizes="(min-width: 568px) 568px, 100vw"
                              srcset="https://images.ctfassets.net/zuzqvf4m2o58/2LFYqny5i36TKMJsjAA4Mh/005fda95ba4428e5ee2ef8c664c7c9a4/Frame_2085662314.png?w=360&amp;h=210&amp;q=50&amp;fm=webp 360w,https://images.ctfassets.net/zuzqvf4m2o58/2LFYqny5i36TKMJsjAA4Mh/005fda95ba4428e5ee2ef8c664c7c9a4/Frame_2085662314.png?w=600&amp;h=350&amp;q=50&amp;fm=webp 600w,https://images.ctfassets.net/zuzqvf4m2o58/2LFYqny5i36TKMJsjAA4Mh/005fda95ba4428e5ee2ef8c664c7c9a4/Frame_2085662314.png?w=900&amp;h=525&amp;q=50&amp;fm=webp 900w,https://images.ctfassets.net/zuzqvf4m2o58/2LFYqny5i36TKMJsjAA4Mh/005fda95ba4428e5ee2ef8c664c7c9a4/Frame_2085662314.png?w=942&amp;h=550&amp;q=50&amp;fm=webp 942w"
                              type="image/webp">
                      <img alt="" decoding="async"
                           loading="lazy" sizes="(min-width: 568px) 568px, 100vw"
                           src="https://images.ctfassets.net/zuzqvf4m2o58/2LFYqny5i36TKMJsjAA4Mh/005fda95ba4428e5ee2ef8c664c7c9a4/Frame_2085662314.png?w=942&amp;h=550&amp;q=50&amp;fm=png"
                           srcset="https://images.ctfassets.net/zuzqvf4m2o58/2LFYqny5i36TKMJsjAA4Mh/005fda95ba4428e5ee2ef8c664c7c9a4/Frame_2085662314.png?w=360&amp;h=210&amp;q=50&amp;fm=png 360w,https://images.ctfassets.net/zuzqvf4m2o58/2LFYqny5i36TKMJsjAA4Mh/005fda95ba4428e5ee2ef8c664c7c9a4/Frame_2085662314.png?w=600&amp;h=350&amp;q=50&amp;fm=png 600w,https://images.ctfassets.net/zuzqvf4m2o58/2LFYqny5i36TKMJsjAA4Mh/005fda95ba4428e5ee2ef8c664c7c9a4/Frame_2085662314.png?w=900&amp;h=525&amp;q=50&amp;fm=png 900w,https://images.ctfassets.net/zuzqvf4m2o58/2LFYqny5i36TKMJsjAA4Mh/005fda95ba4428e5ee2ef8c664c7c9a4/Frame_2085662314.png?w=942&amp;h=550&amp;q=50&amp;fm=png 942w"
                           style="opacity: 1;">
                    </picture>
                    <noscript>
                      <picture>
                        <source sizes="(min-width: 568px) 568px, 100vw"
                                srcSet="https://images.ctfassets.net/zuzqvf4m2o58/2LFYqny5i36TKMJsjAA4Mh/005fda95ba4428e5ee2ef8c664c7c9a4/Frame_2085662314.png?w=360&amp;h=210&amp;q=50&amp;fm=avif 360w,https://images.ctfassets.net/zuzqvf4m2o58/2LFYqny5i36TKMJsjAA4Mh/005fda95ba4428e5ee2ef8c664c7c9a4/Frame_2085662314.png?w=600&amp;h=350&amp;q=50&amp;fm=avif 600w,https://images.ctfassets.net/zuzqvf4m2o58/2LFYqny5i36TKMJsjAA4Mh/005fda95ba4428e5ee2ef8c664c7c9a4/Frame_2085662314.png?w=900&amp;h=525&amp;q=50&amp;fm=avif 900w,https://images.ctfassets.net/zuzqvf4m2o58/2LFYqny5i36TKMJsjAA4Mh/005fda95ba4428e5ee2ef8c664c7c9a4/Frame_2085662314.png?w=942&amp;h=550&amp;q=50&amp;fm=avif 942w"
                                type="image/avif"/>
                        <source sizes="(min-width: 568px) 568px, 100vw"
                                srcSet="https://images.ctfassets.net/zuzqvf4m2o58/2LFYqny5i36TKMJsjAA4Mh/005fda95ba4428e5ee2ef8c664c7c9a4/Frame_2085662314.png?w=360&amp;h=210&amp;q=50&amp;fm=webp 360w,https://images.ctfassets.net/zuzqvf4m2o58/2LFYqny5i36TKMJsjAA4Mh/005fda95ba4428e5ee2ef8c664c7c9a4/Frame_2085662314.png?w=600&amp;h=350&amp;q=50&amp;fm=webp 600w,https://images.ctfassets.net/zuzqvf4m2o58/2LFYqny5i36TKMJsjAA4Mh/005fda95ba4428e5ee2ef8c664c7c9a4/Frame_2085662314.png?w=900&amp;h=525&amp;q=50&amp;fm=webp 900w,https://images.ctfassets.net/zuzqvf4m2o58/2LFYqny5i36TKMJsjAA4Mh/005fda95ba4428e5ee2ef8c664c7c9a4/Frame_2085662314.png?w=942&amp;h=550&amp;q=50&amp;fm=webp 942w"
                                type="image/webp"/>
                        <img
                            alt="" data-gatsby-image-ssr=""
                            decoding="async" loading="lazy"
                            sizes="(min-width: 568px) 568px, 100vw"
                            src="https://images.ctfassets.net/zuzqvf4m2o58/2LFYqny5i36TKMJsjAA4Mh/005fda95ba4428e5ee2ef8c664c7c9a4/Frame_2085662314.png?w=942&amp;h=550&amp;q=50&amp;fm=png"
                            srcSet="https://images.ctfassets.net/zuzqvf4m2o58/2LFYqny5i36TKMJsjAA4Mh/005fda95ba4428e5ee2ef8c664c7c9a4/Frame_2085662314.png?w=360&amp;h=210&amp;q=50&amp;fm=png 360w,https://images.ctfassets.net/zuzqvf4m2o58/2LFYqny5i36TKMJsjAA4Mh/005fda95ba4428e5ee2ef8c664c7c9a4/Frame_2085662314.png?w=600&amp;h=350&amp;q=50&amp;fm=png 600w,https://images.ctfassets.net/zuzqvf4m2o58/2LFYqny5i36TKMJsjAA4Mh/005fda95ba4428e5ee2ef8c664c7c9a4/Frame_2085662314.png?w=900&amp;h=525&amp;q=50&amp;fm=png 900w,https://images.ctfassets.net/zuzqvf4m2o58/2LFYqny5i36TKMJsjAA4Mh/005fda95ba4428e5ee2ef8c664c7c9a4/Frame_2085662314.png?w=942&amp;h=550&amp;q=50&amp;fm=png 942w"
                            style="opacity:0"/>
                      </picture>
                    </noscript>
                    <script
                        type="module">const t = "undefined" != typeof HTMLImageElement && "loading" in HTMLImageElement.prototype;
                    if (t) {
                      const t = document.querySelectorAll("img[data-main-image]");
                      for (let e of t) {
                        e.dataset.src && (e.setAttribute("src", e.dataset.src), e.removeAttribute("data-src")), e.dataset.srcset && (e.setAttribute("srcset", e.dataset.srcset), e.removeAttribute("data-srcset"));
                        const t = e.parentNode.querySelectorAll("source[data-srcset]");
                        for (let e of t) e.setAttribute("srcset", e.dataset.srcset), e.removeAttribute("data-srcset");
                        e.complete && (e.style.opacity = 1, e.parentNode.parentNode.querySelector("[data-placeholder-image]").style.opacity = 0)
                      }
                    }</script>
                  </div>
                  <div class="sc-kfYoZR gkQoUp style__ContentStack-sc-16uiq8m-0 dHKQVL">
                    <h3 class="sc-gXfVKN itVhGI" color="#151515">{{ siteName }} Videos</h3>
                    <p class="sc-hiKfDv eCtBEf" color="#151515">Discover the weird and wonderful
                      things that make a language so fascinating.</p>
                    <div class="style__CtaWrap-sc-16uiq8m-1 gKAjpz"><a class="sc-hBMUJo bSCHIL"
                                                                       color="ghost"
                                                                       @click="showLoginDialog=true"><span
                        class="sc-iCoGMd goTNSB" color="currentColor">Watch</span></a></div>
                  </div>
                </div>
                <div class="sc-kfYoZR hrDoZu">
                  <div class="gatsby-image-wrapper gatsby-image-wrapper-constrained"
                       data-gatsby-image-wrapper="">
                    <div style="max-width:942px;display:block"><img alt="" aria-hidden="true"
                                                                    role="presentation"
                                                                    src="data:image/svg+xml;charset=utf-8,%3Csvg%20height='550'%20width='942'%20xmlns='http://www.w3.org/2000/svg'%20version='1.1'%3E%3C/svg%3E"
                                                                    style="max-width:100%;display:block;position:static">
                    </div>
                    <div aria-hidden="true" data-placeholder-image=""
                         style="opacity: 0; transition: opacity 500ms linear 0s;"></div>
                    <picture>
                      <source sizes="(min-width: 568px) 568px, 100vw"
                              srcset="https://images.ctfassets.net/zuzqvf4m2o58/kJGbySfB6XDHBywEc8iKo/579aa14ae67f19621b6bb8312947edef/Frame_2085662315.png?w=360&amp;h=210&amp;q=50&amp;fm=avif 360w,https://images.ctfassets.net/zuzqvf4m2o58/kJGbySfB6XDHBywEc8iKo/579aa14ae67f19621b6bb8312947edef/Frame_2085662315.png?w=600&amp;h=350&amp;q=50&amp;fm=avif 600w,https://images.ctfassets.net/zuzqvf4m2o58/kJGbySfB6XDHBywEc8iKo/579aa14ae67f19621b6bb8312947edef/Frame_2085662315.png?w=900&amp;h=525&amp;q=50&amp;fm=avif 900w,https://images.ctfassets.net/zuzqvf4m2o58/kJGbySfB6XDHBywEc8iKo/579aa14ae67f19621b6bb8312947edef/Frame_2085662315.png?w=942&amp;h=550&amp;q=50&amp;fm=avif 942w"
                              type="image/avif">
                      <source sizes="(min-width: 568px) 568px, 100vw"
                              srcset="https://images.ctfassets.net/zuzqvf4m2o58/kJGbySfB6XDHBywEc8iKo/579aa14ae67f19621b6bb8312947edef/Frame_2085662315.png?w=360&amp;h=210&amp;q=50&amp;fm=webp 360w,https://images.ctfassets.net/zuzqvf4m2o58/kJGbySfB6XDHBywEc8iKo/579aa14ae67f19621b6bb8312947edef/Frame_2085662315.png?w=600&amp;h=350&amp;q=50&amp;fm=webp 600w,https://images.ctfassets.net/zuzqvf4m2o58/kJGbySfB6XDHBywEc8iKo/579aa14ae67f19621b6bb8312947edef/Frame_2085662315.png?w=900&amp;h=525&amp;q=50&amp;fm=webp 900w,https://images.ctfassets.net/zuzqvf4m2o58/kJGbySfB6XDHBywEc8iKo/579aa14ae67f19621b6bb8312947edef/Frame_2085662315.png?w=942&amp;h=550&amp;q=50&amp;fm=webp 942w"
                              type="image/webp">
                      <img alt="" decoding="async"
                           loading="lazy" sizes="(min-width: 568px) 568px, 100vw"
                           src="https://images.ctfassets.net/zuzqvf4m2o58/kJGbySfB6XDHBywEc8iKo/579aa14ae67f19621b6bb8312947edef/Frame_2085662315.png?w=942&amp;h=550&amp;q=50&amp;fm=png"
                           srcset="https://images.ctfassets.net/zuzqvf4m2o58/kJGbySfB6XDHBywEc8iKo/579aa14ae67f19621b6bb8312947edef/Frame_2085662315.png?w=360&amp;h=210&amp;q=50&amp;fm=png 360w,https://images.ctfassets.net/zuzqvf4m2o58/kJGbySfB6XDHBywEc8iKo/579aa14ae67f19621b6bb8312947edef/Frame_2085662315.png?w=600&amp;h=350&amp;q=50&amp;fm=png 600w,https://images.ctfassets.net/zuzqvf4m2o58/kJGbySfB6XDHBywEc8iKo/579aa14ae67f19621b6bb8312947edef/Frame_2085662315.png?w=900&amp;h=525&amp;q=50&amp;fm=png 900w,https://images.ctfassets.net/zuzqvf4m2o58/kJGbySfB6XDHBywEc8iKo/579aa14ae67f19621b6bb8312947edef/Frame_2085662315.png?w=942&amp;h=550&amp;q=50&amp;fm=png 942w"
                           style="opacity: 1;">
                    </picture>
                    <noscript>
                      <picture>
                        <source sizes="(min-width: 568px) 568px, 100vw"
                                srcSet="https://images.ctfassets.net/zuzqvf4m2o58/kJGbySfB6XDHBywEc8iKo/579aa14ae67f19621b6bb8312947edef/Frame_2085662315.png?w=360&amp;h=210&amp;q=50&amp;fm=avif 360w,https://images.ctfassets.net/zuzqvf4m2o58/kJGbySfB6XDHBywEc8iKo/579aa14ae67f19621b6bb8312947edef/Frame_2085662315.png?w=600&amp;h=350&amp;q=50&amp;fm=avif 600w,https://images.ctfassets.net/zuzqvf4m2o58/kJGbySfB6XDHBywEc8iKo/579aa14ae67f19621b6bb8312947edef/Frame_2085662315.png?w=900&amp;h=525&amp;q=50&amp;fm=avif 900w,https://images.ctfassets.net/zuzqvf4m2o58/kJGbySfB6XDHBywEc8iKo/579aa14ae67f19621b6bb8312947edef/Frame_2085662315.png?w=942&amp;h=550&amp;q=50&amp;fm=avif 942w"
                                type="image/avif"/>
                        <source sizes="(min-width: 568px) 568px, 100vw"
                                srcSet="https://images.ctfassets.net/zuzqvf4m2o58/kJGbySfB6XDHBywEc8iKo/579aa14ae67f19621b6bb8312947edef/Frame_2085662315.png?w=360&amp;h=210&amp;q=50&amp;fm=webp 360w,https://images.ctfassets.net/zuzqvf4m2o58/kJGbySfB6XDHBywEc8iKo/579aa14ae67f19621b6bb8312947edef/Frame_2085662315.png?w=600&amp;h=350&amp;q=50&amp;fm=webp 600w,https://images.ctfassets.net/zuzqvf4m2o58/kJGbySfB6XDHBywEc8iKo/579aa14ae67f19621b6bb8312947edef/Frame_2085662315.png?w=900&amp;h=525&amp;q=50&amp;fm=webp 900w,https://images.ctfassets.net/zuzqvf4m2o58/kJGbySfB6XDHBywEc8iKo/579aa14ae67f19621b6bb8312947edef/Frame_2085662315.png?w=942&amp;h=550&amp;q=50&amp;fm=webp 942w"
                                type="image/webp"/>
                        <img
                            alt="" data-gatsby-image-ssr=""
                            decoding="async" loading="lazy"
                            sizes="(min-width: 568px) 568px, 100vw"
                            src="https://images.ctfassets.net/zuzqvf4m2o58/kJGbySfB6XDHBywEc8iKo/579aa14ae67f19621b6bb8312947edef/Frame_2085662315.png?w=942&amp;h=550&amp;q=50&amp;fm=png"
                            srcSet="https://images.ctfassets.net/zuzqvf4m2o58/kJGbySfB6XDHBywEc8iKo/579aa14ae67f19621b6bb8312947edef/Frame_2085662315.png?w=360&amp;h=210&amp;q=50&amp;fm=png 360w,https://images.ctfassets.net/zuzqvf4m2o58/kJGbySfB6XDHBywEc8iKo/579aa14ae67f19621b6bb8312947edef/Frame_2085662315.png?w=600&amp;h=350&amp;q=50&amp;fm=png 600w,https://images.ctfassets.net/zuzqvf4m2o58/kJGbySfB6XDHBywEc8iKo/579aa14ae67f19621b6bb8312947edef/Frame_2085662315.png?w=900&amp;h=525&amp;q=50&amp;fm=png 900w,https://images.ctfassets.net/zuzqvf4m2o58/kJGbySfB6XDHBywEc8iKo/579aa14ae67f19621b6bb8312947edef/Frame_2085662315.png?w=942&amp;h=550&amp;q=50&amp;fm=png 942w"
                            style="opacity:0"/>
                      </picture>
                    </noscript>
                    <script
                        type="module">const t = "undefined" != typeof HTMLImageElement && "loading" in HTMLImageElement.prototype;
                    if (t) {
                      const t = document.querySelectorAll("img[data-main-image]");
                      for (let e of t) {
                        e.dataset.src && (e.setAttribute("src", e.dataset.src), e.removeAttribute("data-src")), e.dataset.srcset && (e.setAttribute("srcset", e.dataset.srcset), e.removeAttribute("data-srcset"));
                        const t = e.parentNode.querySelectorAll("source[data-srcset]");
                        for (let e of t) e.setAttribute("srcset", e.dataset.srcset), e.removeAttribute("data-srcset");
                        e.complete && (e.style.opacity = 1, e.parentNode.parentNode.querySelector("[data-placeholder-image]").style.opacity = 0)
                      }
                    }</script>
                  </div>
                  <div class="sc-kfYoZR gkQoUp style__ContentStack-sc-16uiq8m-0 dHKQVL">
                    <h3 class="sc-gXfVKN itVhGI" color="#151515">{{ siteName }} Podcasts</h3>
                    <p class="sc-hiKfDv eCtBEf" color="#151515">Listen as {{ siteName }} experts
                      reveal
                      language secrets and give you an inside look at local culture.</p>
                    <div class="style__CtaWrap-sc-16uiq8m-1 gKAjpz"><a class="sc-hBMUJo bSCHIL"
                                                                       color="ghost"
                                                                       @click="showLoginDialog=true"><span
                        class="sc-iCoGMd goTNSB" color="currentColor">Listen</span></a>
                    </div>
                  </div>
                </div>
                <div class="sc-kfYoZR hrDoZu">
                  <div class="gatsby-image-wrapper gatsby-image-wrapper-constrained"
                       data-gatsby-image-wrapper="">
                    <div style="max-width:942px;display:block"><img alt="" aria-hidden="true"
                                                                    role="presentation"
                                                                    src="data:image/svg+xml;charset=utf-8,%3Csvg%20height='550'%20width='942'%20xmlns='http://www.w3.org/2000/svg'%20version='1.1'%3E%3C/svg%3E"
                                                                    style="max-width:100%;display:block;position:static">
                    </div>
                    <div aria-hidden="true" data-placeholder-image=""
                         style="opacity: 0; transition: opacity 500ms linear 0s;"></div>
                    <picture>
                      <source sizes="(min-width: 568px) 568px, 100vw"
                              srcset="https://images.ctfassets.net/zuzqvf4m2o58/6Jd6n7d2SixzpqqBV0jOvI/a7d17b6ff89eeea12b4c513fe1e76b69/Frame_2085662316_2.png?w=360&amp;h=210&amp;q=50&amp;fm=avif 360w,https://images.ctfassets.net/zuzqvf4m2o58/6Jd6n7d2SixzpqqBV0jOvI/a7d17b6ff89eeea12b4c513fe1e76b69/Frame_2085662316_2.png?w=600&amp;h=350&amp;q=50&amp;fm=avif 600w,https://images.ctfassets.net/zuzqvf4m2o58/6Jd6n7d2SixzpqqBV0jOvI/a7d17b6ff89eeea12b4c513fe1e76b69/Frame_2085662316_2.png?w=900&amp;h=525&amp;q=50&amp;fm=avif 900w,https://images.ctfassets.net/zuzqvf4m2o58/6Jd6n7d2SixzpqqBV0jOvI/a7d17b6ff89eeea12b4c513fe1e76b69/Frame_2085662316_2.png?w=942&amp;h=550&amp;q=50&amp;fm=avif 942w"
                              type="image/avif">
                      <source sizes="(min-width: 568px) 568px, 100vw"
                              srcset="https://images.ctfassets.net/zuzqvf4m2o58/6Jd6n7d2SixzpqqBV0jOvI/a7d17b6ff89eeea12b4c513fe1e76b69/Frame_2085662316_2.png?w=360&amp;h=210&amp;q=50&amp;fm=webp 360w,https://images.ctfassets.net/zuzqvf4m2o58/6Jd6n7d2SixzpqqBV0jOvI/a7d17b6ff89eeea12b4c513fe1e76b69/Frame_2085662316_2.png?w=600&amp;h=350&amp;q=50&amp;fm=webp 600w,https://images.ctfassets.net/zuzqvf4m2o58/6Jd6n7d2SixzpqqBV0jOvI/a7d17b6ff89eeea12b4c513fe1e76b69/Frame_2085662316_2.png?w=900&amp;h=525&amp;q=50&amp;fm=webp 900w,https://images.ctfassets.net/zuzqvf4m2o58/6Jd6n7d2SixzpqqBV0jOvI/a7d17b6ff89eeea12b4c513fe1e76b69/Frame_2085662316_2.png?w=942&amp;h=550&amp;q=50&amp;fm=webp 942w"
                              type="image/webp">
                      <img alt="" decoding="async"
                           loading="lazy" sizes="(min-width: 568px) 568px, 100vw"
                           src="https://images.ctfassets.net/zuzqvf4m2o58/6Jd6n7d2SixzpqqBV0jOvI/a7d17b6ff89eeea12b4c513fe1e76b69/Frame_2085662316_2.png?w=942&amp;h=550&amp;q=50&amp;fm=png"
                           srcset="https://images.ctfassets.net/zuzqvf4m2o58/6Jd6n7d2SixzpqqBV0jOvI/a7d17b6ff89eeea12b4c513fe1e76b69/Frame_2085662316_2.png?w=360&amp;h=210&amp;q=50&amp;fm=png 360w,https://images.ctfassets.net/zuzqvf4m2o58/6Jd6n7d2SixzpqqBV0jOvI/a7d17b6ff89eeea12b4c513fe1e76b69/Frame_2085662316_2.png?w=600&amp;h=350&amp;q=50&amp;fm=png 600w,https://images.ctfassets.net/zuzqvf4m2o58/6Jd6n7d2SixzpqqBV0jOvI/a7d17b6ff89eeea12b4c513fe1e76b69/Frame_2085662316_2.png?w=900&amp;h=525&amp;q=50&amp;fm=png 900w,https://images.ctfassets.net/zuzqvf4m2o58/6Jd6n7d2SixzpqqBV0jOvI/a7d17b6ff89eeea12b4c513fe1e76b69/Frame_2085662316_2.png?w=942&amp;h=550&amp;q=50&amp;fm=png 942w"
                           style="opacity: 1;">
                    </picture>
                    <noscript>
                      <picture>
                        <source sizes="(min-width: 568px) 568px, 100vw"
                                srcSet="https://images.ctfassets.net/zuzqvf4m2o58/6Jd6n7d2SixzpqqBV0jOvI/a7d17b6ff89eeea12b4c513fe1e76b69/Frame_2085662316_2.png?w=360&amp;h=210&amp;q=50&amp;fm=avif 360w,https://images.ctfassets.net/zuzqvf4m2o58/6Jd6n7d2SixzpqqBV0jOvI/a7d17b6ff89eeea12b4c513fe1e76b69/Frame_2085662316_2.png?w=600&amp;h=350&amp;q=50&amp;fm=avif 600w,https://images.ctfassets.net/zuzqvf4m2o58/6Jd6n7d2SixzpqqBV0jOvI/a7d17b6ff89eeea12b4c513fe1e76b69/Frame_2085662316_2.png?w=900&amp;h=525&amp;q=50&amp;fm=avif 900w,https://images.ctfassets.net/zuzqvf4m2o58/6Jd6n7d2SixzpqqBV0jOvI/a7d17b6ff89eeea12b4c513fe1e76b69/Frame_2085662316_2.png?w=942&amp;h=550&amp;q=50&amp;fm=avif 942w"
                                type="image/avif"/>
                        <source sizes="(min-width: 568px) 568px, 100vw"
                                srcSet="https://images.ctfassets.net/zuzqvf4m2o58/6Jd6n7d2SixzpqqBV0jOvI/a7d17b6ff89eeea12b4c513fe1e76b69/Frame_2085662316_2.png?w=360&amp;h=210&amp;q=50&amp;fm=webp 360w,https://images.ctfassets.net/zuzqvf4m2o58/6Jd6n7d2SixzpqqBV0jOvI/a7d17b6ff89eeea12b4c513fe1e76b69/Frame_2085662316_2.png?w=600&amp;h=350&amp;q=50&amp;fm=webp 600w,https://images.ctfassets.net/zuzqvf4m2o58/6Jd6n7d2SixzpqqBV0jOvI/a7d17b6ff89eeea12b4c513fe1e76b69/Frame_2085662316_2.png?w=900&amp;h=525&amp;q=50&amp;fm=webp 900w,https://images.ctfassets.net/zuzqvf4m2o58/6Jd6n7d2SixzpqqBV0jOvI/a7d17b6ff89eeea12b4c513fe1e76b69/Frame_2085662316_2.png?w=942&amp;h=550&amp;q=50&amp;fm=webp 942w"
                                type="image/webp"/>
                        <img
                            alt="" data-gatsby-image-ssr=""
                            decoding="async" loading="lazy"
                            sizes="(min-width: 568px) 568px, 100vw"
                            src="https://images.ctfassets.net/zuzqvf4m2o58/6Jd6n7d2SixzpqqBV0jOvI/a7d17b6ff89eeea12b4c513fe1e76b69/Frame_2085662316_2.png?w=942&amp;h=550&amp;q=50&amp;fm=png"
                            srcSet="https://images.ctfassets.net/zuzqvf4m2o58/6Jd6n7d2SixzpqqBV0jOvI/a7d17b6ff89eeea12b4c513fe1e76b69/Frame_2085662316_2.png?w=360&amp;h=210&amp;q=50&amp;fm=png 360w,https://images.ctfassets.net/zuzqvf4m2o58/6Jd6n7d2SixzpqqBV0jOvI/a7d17b6ff89eeea12b4c513fe1e76b69/Frame_2085662316_2.png?w=600&amp;h=350&amp;q=50&amp;fm=png 600w,https://images.ctfassets.net/zuzqvf4m2o58/6Jd6n7d2SixzpqqBV0jOvI/a7d17b6ff89eeea12b4c513fe1e76b69/Frame_2085662316_2.png?w=900&amp;h=525&amp;q=50&amp;fm=png 900w,https://images.ctfassets.net/zuzqvf4m2o58/6Jd6n7d2SixzpqqBV0jOvI/a7d17b6ff89eeea12b4c513fe1e76b69/Frame_2085662316_2.png?w=942&amp;h=550&amp;q=50&amp;fm=png 942w"
                            style="opacity:0"/>
                      </picture>
                    </noscript>
                    <script
                        type="module">const t = "undefined" != typeof HTMLImageElement && "loading" in HTMLImageElement.prototype;
                    if (t) {
                      const t = document.querySelectorAll("img[data-main-image]");
                      for (let e of t) {
                        e.dataset.src && (e.setAttribute("src", e.dataset.src), e.removeAttribute("data-src")), e.dataset.srcset && (e.setAttribute("srcset", e.dataset.srcset), e.removeAttribute("data-srcset"));
                        const t = e.parentNode.querySelectorAll("source[data-srcset]");
                        for (let e of t) e.setAttribute("srcset", e.dataset.srcset), e.removeAttribute("data-srcset");
                        e.complete && (e.style.opacity = 1, e.parentNode.parentNode.querySelector("[data-placeholder-image]").style.opacity = 0)
                      }
                    }</script>
                  </div>
                  <div class="sc-kfYoZR gkQoUp style__ContentStack-sc-16uiq8m-0 dHKQVL">
                    <h3 class="sc-gXfVKN itVhGI" color="#151515">{{ siteName }} Magazine</h3>
                    <p class="sc-hiKfDv eCtBEf" color="#151515">Explore stories from around the
                      world, get language learning tips and dive deeper into different cultures.
                    </p>
                    <div class="style__CtaWrap-sc-16uiq8m-1 gKAjpz"><a class="sc-hBMUJo bSCHIL"
                                                                       color="ghost"
                                                                       @click="showLoginDialog=true"><span
                        class="sc-iCoGMd goTNSB" color="currentColor">Read</span></a></div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section
              class="style__Container-sc-ttg9pt-0 fqKWJw style__StyledBackgroundImage-sc-11winof-0 dpQAxa">
            <div id="fb1b2701-9bf9-50d6-a9c7-3472677b0b82" class="style__Container-sc-11winof-1 esUSAq"
                 tabindex="-1">
              <div class="sc-kfYoZR eySVyK style__ContentWrap-sc-1cerv0a-0 dBgrDM">
                <div class="sc-kfYoZR fidEIY style__ContentStack-sc-1cerv0a-1 gWsifU">
                  <h2 class="sc-gXfVKN iUAACH style__StyledTitle-sc-1cerv0a-2 dMnzJW" color="#ffffff">
                    Join millions of {{ siteName }} learners breaking the language barrier every
                    day</h2>
                  <div class="style__CtaGroup-sc-1cerv0a-4 glJsmd">
                    <div class="style__FlagsCtaWrap-sc-1mm9dyl-2 PwXXo">
                      <div class="sc-kfYoZR dqSvs"><a
                          class="style__StyledLink-sc-1xmwttv-0 gAMfoi"
                          @click="showLoginDialog=true">
                        <div
                            class="sc-ciSkZP kcSChc style__LanguageItem-sc-1xmwttv-1 hfChhU">
                          <svg aria-hidden="true" fill="none" focusable="false" height="24"
                               viewBox="0 0 32 32" width="24">
                            <path clip-rule="evenodd"
                                  d="M11 26.9119C6.86894 25.0159 4 20.843 4 16C4 11.157 6.86894 6.98409 11 5.08807V26.9119Z"
                                  fill="#006847"
                                  fill-rule="evenodd"></path>
                            <path clip-rule="evenodd"
                                  d="M11 26.9119V5.08808C12.5221 4.38949 14.2156 4 16 4C17.7844 4 19.4779 4.38949 21 5.08808V26.9119C19.4779 27.6105 17.7844 28 16 28C14.2156 28 12.5221 27.6105 11 26.9119Z"
                                  fill="white"
                                  fill-rule="evenodd"></path>
                            <path clip-rule="evenodd"
                                  d="M21 26.9119V5.08807C25.1311 6.98409 28 11.157 28 16C28 20.843 25.1311 25.0159 21 26.9119Z"
                                  fill="#CE1126"
                                  fill-rule="evenodd"></path>
                            <path
                                d="M12 16.2C12 17.6423 12.7704 18.9512 13.9948 19.6617C14.377 19.8834 14.8665 19.7534 15.0883 19.3712C15.31 18.9891 15.18 18.4995 14.7978 18.2778C14.0619 17.8508 13.6 17.066 13.6 16.2C13.6 15.7581 13.2418 15.4 12.8 15.4C12.3582 15.4 12 15.7581 12 16.2ZM18.1529 19.5717C19.2941 18.8418 20 17.5807 20 16.2C20 15.7581 19.6418 15.4 19.2 15.4C18.7582 15.4 18.4 15.7581 18.4 16.2C18.4 17.0292 17.977 17.7849 17.2908 18.2238C16.9186 18.4618 16.8098 18.9565 17.0479 19.3288C17.2859 19.701 17.7806 19.8097 18.1529 19.5717Z"
                                fill="#006847"></path>
                            <path
                                d="M16 17.8C16.8837 17.8 17.6 16.7255 17.6 15.4C17.6 14.0745 16.8837 13 16 13C15.1164 13 14.4 14.0745 14.4 15.4C14.4 16.7255 15.1164 17.8 16 17.8Z"
                                fill="#9B7745"></path>
                            <path
                                d="M16 29C8.8203 29 3 23.1797 3 16C3 8.8203 8.8203 3 16 3C23.1797 3 29 8.8203 29 16C29 23.1797 23.1797 29 16 29Z"
                                stroke="#d7d4cf" stroke-width="2"></path>
                          </svg>
                          <span class="sc-iCoGMd eEHQUm"
                                color="#151515">Spanish</span>
                        </div>
                      </a><a class="style__StyledLink-sc-1xmwttv-0 gAMfoi"
                             @click="showLoginDialog=true">
                        <div
                            class="sc-ciSkZP kcSChc style__LanguageItem-sc-1xmwttv-1 hfChhU">
                          <svg aria-hidden="true" fill="none" focusable="false" height="24"
                               viewBox="0 0 32 32" width="24">
                            <path clip-rule="evenodd"
                                  d="M21 5.08807C25.1311 6.98409 28 11.157 28 16C28 20.843 25.1311 25.0159 21 26.9119V5.08807Z"
                                  fill="#ED2939"
                                  fill-rule="evenodd"></path>
                            <path clip-rule="evenodd"
                                  d="M11 26.9119V5.08808C12.5221 4.38949 14.2156 4 16 4C17.7844 4 19.4779 4.38949 21 5.08808V26.9119C19.4779 27.6105 17.7844 28 16 28C14.2156 28 12.5221 27.6105 11 26.9119Z"
                                  fill="white"
                                  fill-rule="evenodd"></path>
                            <path clip-rule="evenodd"
                                  d="M11 5.08807V26.9119C6.86894 25.0159 4 20.843 4 16C4 11.157 6.86894 6.98409 11 5.08807Z"
                                  fill="#002395"
                                  fill-rule="evenodd"></path>
                            <path
                                d="M16 29C8.8203 29 3 23.1797 3 16C3 8.8203 8.8203 3 16 3C23.1797 3 29 8.8203 29 16C29 23.1797 23.1797 29 16 29Z"
                                stroke="#d7d4cf" stroke-width="2"></path>
                          </svg>
                          <span class="sc-iCoGMd eEHQUm"
                                color="#151515">French</span>
                        </div>
                      </a><a class="style__StyledLink-sc-1xmwttv-0 gAMfoi"
                             @click="showLoginDialog=true">
                        <div
                            class="sc-ciSkZP kcSChc style__LanguageItem-sc-1xmwttv-1 hfChhU">
                          <svg aria-hidden="true" fill="none" focusable="false" height="24"
                               viewBox="0 0 32 32" width="24">
                            <path clip-rule="evenodd"
                                  d="M26.9119 21C25.0159 25.1311 20.843 28 16 28C11.157 28 6.9841 25.1311 5.08809 21H26.9119Z"
                                  fill="#FFCE00"
                                  fill-rule="evenodd"></path>
                            <path clip-rule="evenodd"
                                  d="M26.9119 21C27.6105 19.4779 28 17.7844 28 16C28 14.2156 27.6105 12.5221 26.9119 11H5.08808C4.38949 12.5221 4 14.2156 4 16C4 17.7844 4.38949 19.4779 5.08808 21H26.9119Z"
                                  fill="#DD0000"
                                  fill-rule="evenodd"></path>
                            <path clip-rule="evenodd"
                                  d="M5.08809 11C6.9841 6.86894 11.157 4 16 4C20.843 4 25.0159 6.86894 26.9119 11H5.08809Z"
                                  fill="black"
                                  fill-rule="evenodd"></path>
                            <path
                                d="M16 29C8.8203 29 3 23.1797 3 16C3 8.8203 8.8203 3 16 3C23.1797 3 29 8.8203 29 16C29 23.1797 23.1797 29 16 29Z"
                                stroke="#d7d4cf" stroke-width="2"></path>
                          </svg>
                          <span class="sc-iCoGMd eEHQUm"
                                color="#151515">German</span>
                        </div>
                      </a><a class="style__StyledLink-sc-1xmwttv-0 gAMfoi"
                             @click="showLoginDialog=true">
                        <div
                            class="sc-ciSkZP kcSChc style__LanguageItem-sc-1xmwttv-1 hfChhU">
                          <svg aria-hidden="true" fill="none" focusable="false" height="24"
                               viewBox="0 0 32 32" width="24">
                            <path clip-rule="evenodd"
                                  d="M21 5.08807C25.1311 6.98409 28 11.157 28 16C28 20.843 25.1311 25.0159 21 26.9119V5.08807Z"
                                  fill="#CE2B37"
                                  fill-rule="evenodd"></path>
                            <path clip-rule="evenodd"
                                  d="M11 26.9119V5.08808C12.5221 4.38949 14.2156 4 16 4C17.7844 4 19.4779 4.38949 21 5.08808V26.9119C19.4779 27.6105 17.7844 28 16 28C14.2156 28 12.5221 27.6105 11 26.9119Z"
                                  fill="white"
                                  fill-rule="evenodd"></path>
                            <path clip-rule="evenodd"
                                  d="M11 5.08807V26.9119C6.86894 25.0159 4 20.843 4 16C4 11.157 6.86894 6.98409 11 5.08807Z"
                                  fill="#009246"
                                  fill-rule="evenodd"></path>
                            <path
                                d="M16 29C8.8203 29 3 23.1797 3 16C3 8.8203 8.8203 3 16 3C23.1797 3 29 8.8203 29 16C29 23.1797 23.1797 29 16 29Z"
                                stroke="#d7d4cf" stroke-width="2"></path>
                          </svg>
                          <span class="sc-iCoGMd eEHQUm"
                                color="#151515">Italian</span>
                        </div>
                      </a><a class="style__StyledLink-sc-1xmwttv-0 gAMfoi"
                             @click="showLoginDialog=true">
                        <div
                            class="sc-ciSkZP kcSChc style__LanguageItem-sc-1xmwttv-1 hfChhU">
                          <svg fill="none" height="24" viewBox="0 0 24 24" width="24"
                               xmlns="http://www.w3.org/2000/svg">
                            <g id="Group 2085662354">
                              <circle id="Ellipse 248" cx="12" cy="12" fill="#F6F4EF"
                                      r="12"></circle>
                              <path id="Vector 447" d="M12 7V17" stroke="#151515"
                                    stroke-linecap="round" stroke-width="1.5"></path>
                              <path id="Vector 448" d="M17 12L7 12" stroke="#151515"
                                    stroke-linecap="round" stroke-width="1.5"></path>
                            </g>
                          </svg>
                          <span class="sc-iCoGMd eEHQUm" color="#151515">More</span>
                        </div>
                      </a></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <div id="0ddda132-3f3d-5137-b67e-49679be603e1"
               class="sc-ciSkZP bzlmPm style__StyledSeparator-sc-m51m41-0 kFeecE"
               tabindex="-1">
            <p class="sc-iCoGMd erEfuo style__StyledPara-sc-m51m41-1 gtGBoW" color="default">*Vesselinov, R.
              and Grego, J. The {{ siteName }} Efficacy Study. New York 2016.
              **Interviews conducted in USA
            </p>
          </div>
          <nav class="style__Section-sc-y6lmol-0 cWcsf">
            <div class="style__Container-sc-y6lmol-1 gBMQaI">
              <div class="style__Columns-sc-y6lmol-2 jittYR">
                <div class="sc-kfYoZR glIOrA style__StyledColumn-sc-y6lmol-3 hlrPlw">
                  <div>
                    <h4 class="sc-laZMeE ckdfwA style__Headline-sc-y6lmol-4 iVFVDY" color="default">
                      Courses </h4>
                    <ul class="style__List-sc-y6lmol-5 gdZsut">
                      <li class="style__ListItem-sc-y6lmol-6 fyMqjH"><a
                          class="sc-kEqXSa vVShp" color="default"
                          @click="showLoginDialog=true"><span
                          class="sc-pNWdM XJxhY">Spanish</span></a></li>
                      <li class="style__ListItem-sc-y6lmol-6 fyMqjH"><a
                          class="sc-kEqXSa vVShp" color="default"
                          @click="showLoginDialog=true"><span
                          class="sc-pNWdM XJxhY">French</span></a></li>
                      <li class="style__ListItem-sc-y6lmol-6 fyMqjH"><a
                          class="sc-kEqXSa vVShp" color="default"
                          @click="showLoginDialog=true"><span
                          class="sc-pNWdM XJxhY">German</span></a></li>
                      <li class="style__ListItem-sc-y6lmol-6 fyMqjH"><a
                          class="sc-kEqXSa vVShp" color="default"
                          @click="showLoginDialog=true"><span
                          class="sc-pNWdM XJxhY">Italian</span></a></li>
                      <li class="style__ListItem-sc-y6lmol-6 fyMqjH"><a
                          class="sc-kEqXSa vVShp" color="default"
                          @click="showLoginDialog=true"><span
                          class="sc-pNWdM XJxhY">Portuguese</span></a></li>
                      <li class="style__ListItem-sc-y6lmol-6 fyMqjH"><a
                          class="sc-kEqXSa vVShp" color="default"
                          @click="showLoginDialog=true"><span
                          class="sc-pNWdM XJxhY">Russian</span></a></li>
                      <li class="style__ListItem-sc-y6lmol-6 fyMqjH"><a
                          class="sc-kEqXSa vVShp" color="default"
                          @click="showLoginDialog=true"><span
                          class="sc-pNWdM XJxhY">Danish</span></a></li>
                      <li class="style__ListItem-sc-y6lmol-6 fyMqjH"><a
                          class="sc-kEqXSa vVShp" color="default"
                          @click="showLoginDialog=true"><span
                          class="sc-pNWdM XJxhY">Dutch</span></a></li>
                      <li class="style__ListItem-sc-y6lmol-6 fyMqjH"><a
                          class="sc-kEqXSa vVShp" color="default"
                          @click="showLoginDialog=true"><span
                          class="sc-pNWdM XJxhY">Indonesian</span></a></li>
                      <li class="style__ListItem-sc-y6lmol-6 fyMqjH"><a
                          class="sc-kEqXSa vVShp" color="default"
                          @click="showLoginDialog=true"><span
                          class="sc-pNWdM XJxhY">Norwegian</span></a></li>
                      <li class="style__ListItem-sc-y6lmol-6 fyMqjH"><a
                          class="sc-kEqXSa vVShp" color="default"
                          @click="showLoginDialog=true"><span
                          class="sc-pNWdM XJxhY">Polish</span></a></li>
                      <li class="style__ListItem-sc-y6lmol-6 fyMqjH"><a
                          class="sc-kEqXSa vVShp" color="default"
                          @click="showLoginDialog=true"><span
                          class="sc-pNWdM XJxhY">Swedish</span></a></li>
                      <li class="style__ListItem-sc-y6lmol-6 fyMqjH"><a
                          class="sc-kEqXSa vVShp" color="default"
                          @click="showLoginDialog=true"><span
                          class="sc-pNWdM XJxhY">Turkish</span></a></li>
                    </ul>
                  </div>
                </div>
                <div class="sc-kfYoZR glIOrA style__StyledColumn-sc-y6lmol-3 hlrPlw">
                  <div>
                    <h4 class="sc-laZMeE ckdfwA style__Headline-sc-y6lmol-4 iVFVDY" color="default">
                      More {{ siteName }}</h4>
                    <ul class="style__List-sc-y6lmol-5 gdZsut">
                      <li class="style__ListItem-sc-y6lmol-6 fyMqjH"><a
                          class="sc-kEqXSa vVShp" color="default"
                          @click="showLoginDialog=true"><span
                          class="sc-pNWdM XJxhY">{{ siteName }}
                                                        Magazine</span></a></li>
                      <li class="style__ListItem-sc-y6lmol-6 fyMqjH"><a
                          class="sc-kEqXSa vVShp" color="default"
                          @click="showLoginDialog=true"><span
                          class="sc-pNWdM XJxhY">{{ siteName }}
                                                        Podcasts</span></a></li>
                      <li class="style__ListItem-sc-y6lmol-6 fyMqjH"><a
                          class="sc-kEqXSa vVShp"
                          color="default" @click="showLoginDialog=true"><span
                          class="sc-pNWdM XJxhY">Tech Blog</span></a></li>
                      <li class="style__ListItem-sc-y6lmol-6 fyMqjH"><a
                          class="sc-kEqXSa vVShp"
                          color="default" @click="showLoginDialog=true"><span
                          class="sc-pNWdM XJxhY">Inside {{ siteName }}</span></a></li>
                      <li class="style__ListItem-sc-y6lmol-6 fyMqjH"><a
                          class="sc-kEqXSa vVShp" color="default"
                          rel="noreferer noopenner" @click="showLoginDialog=true"><span
                          class="sc-pNWdM XJxhY">{{ siteName }} for Business</span></a></li>
                      <li class="style__ListItem-sc-y6lmol-6 fyMqjH"><a
                          class="sc-kEqXSa vVShp"
                          color="default" rel="noreferer noopener"
                          @click="showLoginDialog=true"><span class="sc-pNWdM XJxhY">Affiliate
                                                        Program (USA)</span></a></li>
                      <li class="style__ListItem-sc-y6lmol-6 fyMqjH"><a
                          class="sc-kEqXSa vVShp" color="default"
                          @click="showLoginDialog=true"><span class="sc-pNWdM XJxhY">Affiliate
                                                        Program (Europe)</span></a></li>
                      <li class="style__ListItem-sc-y6lmol-6 fyMqjH"><a
                          class="sc-kEqXSa vVShp" color="default"
                          rel="noreferer noopener" @click="showLoginDialog=true"><span
                          class="sc-pNWdM XJxhY">{{ siteName }} as a Gift</span></a></li>
                      <li class="style__ListItem-sc-y6lmol-6 fyMqjH"><a
                          class="sc-kEqXSa vVShp"
                          color="default" @click="showLoginDialog=true"><span
                          class="sc-pNWdM XJxhY">Refer a Friend</span></a></li>
                      <li class="style__ListItem-sc-y6lmol-6 fyMqjH"><a
                          class="sc-kEqXSa vVShp"
                          color="default" @click="showLoginDialog=true"><span
                          class="sc-pNWdM XJxhY">Student Discount</span></a></li>
                      <li class="style__ListItem-sc-y6lmol-6 fyMqjH"><a
                          class="sc-kEqXSa vVShp"
                          color="default" @click="showLoginDialog=true"><span
                          class="sc-pNWdM XJxhY">Military Discount</span></a></li>
                      <li class="style__ListItem-sc-y6lmol-6 fyMqjH"><a
                          class="sc-kEqXSa vVShp"
                          color="default" @click="showLoginDialog=true"><span
                          class="sc-pNWdM XJxhY">Healthcare Workers Discount</span></a>
                      </li>
                      <li class="style__ListItem-sc-y6lmol-6 fyMqjH"><a
                          class="sc-kEqXSa vVShp"
                          color="default" @click="showLoginDialog=true"><span
                          class="sc-pNWdM XJxhY">Educators Discount</span></a></li>
                      <li class="style__ListItem-sc-y6lmol-6 fyMqjH"><a
                          class="sc-kEqXSa vVShp" color="default"
                          @click="showLoginDialog=true"><span
                          class="sc-pNWdM XJxhY">Investors</span></a></li>
                    </ul>
                  </div>
                </div>
                <div class="sc-kfYoZR glIOrA style__StyledColumn-sc-y6lmol-3 hlrPlw">
                  <div>
                    <h4 class="sc-laZMeE ckdfwA style__Headline-sc-y6lmol-4 iVFVDY" color="default">
                      Company</h4>
                    <ul class="style__List-sc-y6lmol-5 gdZsut">
                      <li class="style__ListItem-sc-y6lmol-6 fyMqjH"><a
                          class="sc-kEqXSa vVShp" color="default"
                          @click="showLoginDialog=true"><span class="sc-pNWdM XJxhY">About
                                                        Us</span></a></li>
                      <li class="style__ListItem-sc-y6lmol-6 fyMqjH"><a
                          class="sc-kEqXSa vVShp" color="default"
                          @click="showLoginDialog=true"><span class="sc-pNWdM XJxhY">Meet the
                                                        Exec</span></a></li>
                      <li class="style__ListItem-sc-y6lmol-6 fyMqjH"><a
                          class="sc-kEqXSa vVShp" color="default"
                          @click="showLoginDialog=true"><span
                          class="sc-pNWdM XJxhY">The {{ siteName }}
                                                        App</span></a></li>
                      <li class="style__ListItem-sc-y6lmol-6 fyMqjH"><a
                          class="sc-kEqXSa vVShp" color="default"
                          @click="showLoginDialog=true"><span
                          class="sc-pNWdM XJxhY">{{ siteName }}
                                                        Live</span></a></li>
                      <li class="style__ListItem-sc-y6lmol-6 fyMqjH"><a
                          class="sc-kEqXSa vVShp" color="default"
                          @click="showLoginDialog=true"><span
                          class="sc-pNWdM XJxhY">Prices</span></a></li>
                      <li class="style__ListItem-sc-y6lmol-6 fyMqjH"><a
                          class="sc-kEqXSa vVShp" color="default"
                          @click="showLoginDialog=true"><span
                          class="sc-pNWdM XJxhY">Press</span></a></li>
                      <li class="style__ListItem-sc-y6lmol-6 fyMqjH"><a
                          class="sc-kEqXSa vVShp" color="default"
                          @click="showLoginDialog=true"><span
                          class="sc-pNWdM XJxhY">Careers</span></a></li>
                      <li class="style__ListItem-sc-y6lmol-6 fyMqjH"><a
                          class="sc-kEqXSa vVShp"
                          color="default" @click="showLoginDialog=true"><span
                          class="sc-pNWdM XJxhY">Help / FAQ</span></a></li>
                      <li class="style__ListItem-sc-y6lmol-6 fyMqjH"><a
                          class="sc-kEqXSa vVShp" color="default"
                          rel="noreferer noopener" @click="showLoginDialog=true"><span
                          class="sc-pNWdM XJxhY">Customer Service</span></a></li>
                      <li class="style__ListItem-sc-y6lmol-6 fyMqjH"><a
                          class="sc-kEqXSa vVShp" color="default"
                          @click="showLoginDialog=true"><span class="sc-pNWdM XJxhY">Accessibility
                                                        Compliance</span></a></li>
                      <li class="style__ListItem-sc-y6lmol-6 fyMqjH"><a
                          class="sc-kEqXSa vVShp" color="default"
                          @click="showLoginDialog=true"><span class="sc-pNWdM XJxhY">Mobile
                                                        Terms</span></a></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </nav>
        </main>
        <main class="langMain">
          <p class="langTitle">Why are you learning {{ langText }}?</p>
          <div class="sc-ciSkZP kcSChc style__LanguageItem-sc-1xmwttv-1 hfChhU langItem"
               @click="register">
                        <span class="sc-iCoGMd eEHQUm"
                              color="#151515">To connect with family / friends</span>
          </div>
          <div class="sc-ciSkZP kcSChc style__LanguageItem-sc-1xmwttv-1 hfChhU langItem"
               @click="register">
                        <span class="sc-iCoGMd eEHQUm"
                              color="#151515">I want lo do it as a brain exercise</span>
          </div>
          <div class="sc-ciSkZP kcSChc style__LanguageItem-sc-1xmwttv-1 hfChhU langItem"
               @click="register">
                        <span class="sc-iCoGMd eEHQUm"
                              color="#151515">I need it for school</span>
          </div>
          <div class="sc-ciSkZP kcSChc style__LanguageItem-sc-1xmwttv-1 hfChhU langItem"
               @click="register">
                        <span class="sc-iCoGMd eEHQUm"
                              color="#151515">I need it for an upcoming trip</span>
          </div>
          <div class="sc-ciSkZP kcSChc style__LanguageItem-sc-1xmwttv-1 hfChhU langItem"
               @click="register">
                        <span class="sc-iCoGMd eEHQUm"
                              color="#151515">I just enjoy learning languages</span>
          </div>
          <div class="sc-ciSkZP kcSChc style__LanguageItem-sc-1xmwttv-1 hfChhU langItem"
               @click="register">
                        <span class="sc-iCoGMd eEHQUm"
                              color="#151515">I need it for my career</span>
          </div>
          <div class="sc-ciSkZP kcSChc style__LanguageItem-sc-1xmwttv-1 hfChhU langItem"
               @click="register">
                        <span class="sc-iCoGMd eEHQUm"
                              color="#151515">Other</span>
          </div>
        </main>
        <footer class="sc-gtsrHT kMbjvJ" color="default">
          <div class="sc-dlnjwi jEVmsW">
            <div class="sc-eCApnc iylGhi" data-testid="secondary">
              <div class="sc-gKAaRy hydYaP FooterItem"><a id="footer-copyright"
                                                          class="sc-kEqXSa cdMKIg sc-crzoAE DykGo"
                                                          color="subdued"
                                                          target="_blank"
                                                          @click="showLoginDialog=true"><span
                  class="sc-pNWdM XJxhY">© 2024 {{ siteName }}
                                        GmbH</span></a></div>
              <div class="sc-gKAaRy hydYaP FooterItem"><a id="footer-imprint"
                                                          class="sc-kEqXSa cdMKIg sc-crzoAE DykGo"
                                                          color="subdued"
                                                          target="_blank"
                                                          @click="showLoginDialog=true"><span
                  class="sc-pNWdM XJxhY">Imprint</span></a></div>
              <div class="sc-gKAaRy hydYaP FooterItem"><a id="footer-terms"
                                                          class="sc-kEqXSa cdMKIg sc-crzoAE DykGo"
                                                          color="subdued"
                                                          target="_blank"
                                                          @click="showLoginDialog=true"><span
                  class="sc-pNWdM XJxhY">Terms &amp;
                                        Conditions</span></a></div>
              <div class="sc-gKAaRy hydYaP FooterItem"><a id="footer-privacy"
                                                          class="sc-kEqXSa cdMKIg sc-crzoAE DykGo"
                                                          color="subdued"
                                                          target="_blank"
                                                          @click="showLoginDialog=true"><span
                  class="sc-pNWdM XJxhY">Privacy
                                        Statement</span></a></div>
              <div class="sc-gKAaRy hydYaP FooterItem"><a
                  id="footer-do_not_sell" class="sc-kEqXSa cdMKIg sc-crzoAE DykGo"
                  color="subdued" target="_blank"
                  @click="showLoginDialog=true"><span class="sc-pNWdM XJxhY">Do Not Sell or
                                        Share My Personal Information</span></a></div>
            </div>
            <div class="sc-jSFjdj jcTaHb" data-testid="icon">
              <div class="sc-gKAaRy hydYaP FooterItem"><a id="footer-facebook" aria-label="facebook"
                                                          class="sc-hBMUJo jUQvWh" color="ghost"
                                                          rel="noopener"
                                                          target="_blank" title="facebook"
                                                          @click="showLoginDialog=true"><span
                  class="sc-fFSPTT eEJWPz"><svg aria-hidden="true"
                                                class="sc-bdnxRM flLGmz" fill="currentColor"
                                                focusable="false"
                                                viewBox="0 0 32 32">
                                            <g clip-path="url(#clip0_3814_707)">
                                                <path
                                                    d="M16 3C23.1797 3 29 8.85586 29 16.0794C29 22.6079 24.2461 28.0188 18.0312 29V28.8421V19.8602H21.0604L21.6367 16.0794H21.6245L21.6367 16H18.0312V13.626C18.0312 12.5917 18.535 11.5834 20.1498 11.5834H21.7891V11.5312V8.36462V8.33203C21.7891 8.33203 20.3014 8.07812 18.879 8.07812C15.9096 8.07812 13.9688 9.87781 13.9688 13.1359V13.1979V16H10.668V16.0794V19.7578V19.8602H13.9688V28.8421V29C7.75389 28.0188 3 22.6077 3 16.0794C3 8.85586 8.82029 3 16 3Z">
                                                </path>
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_3814_707">
                                                    <rect fill="white" height="26" transform="translate(3 3)"
                                                          width="26"></rect>
                                                </clipPath>
                                            </defs>
                                        </svg></span></a></div>
              <div class="sc-gKAaRy hydYaP FooterItem"><a id="footer-twitter" aria-label="twitter"
                                                          class="sc-hBMUJo jUQvWh" color="ghost"
                                                          rel="noopener"
                                                          target="_blank" title="twitter"
                                                          @click="showLoginDialog=true"><span
                  class="sc-fFSPTT eEJWPz"><svg aria-hidden="true" class="sc-bdnxRM flLGmz"
                                                fill="currentColor" focusable="false"
                                                viewBox="0 0 32 32">
                                            <path
                                                d="M5 3C3.89543 3 3 3.89543 3 5V27C3 28.1046 3.89543 29 5 29H27C28.1046 29 29 28.1046 29 27V5C29 3.89543 28.1046 3 27 3H5ZM23.4785 8L17.5222 14.9238H17.5218L24 24.3516H19.2356L14.8732 18.0029L9.41155 24.3516H8L14.2466 17.0909L8 8H12.7644L16.8952 14.0118L22.0671 8H23.4785ZM14.956 16.2658L15.5889 17.171V17.1714L19.8997 23.3373H22.0677L16.7851 15.7811L16.1522 14.8758L12.0882 9.06259H9.92015L14.956 16.2658Z">
                                            </path>
                                        </svg></span></a></div>
              <div class="sc-gKAaRy hydYaP FooterItem"><a id="footer-youtube" aria-label="youtube"
                                                          class="sc-hBMUJo jUQvWh" color="ghost"
                                                          rel="noopener"
                                                          target="_blank" title="youtube"
                                                          @click="showLoginDialog=true"><span
                  class="sc-fFSPTT eEJWPz"><svg aria-hidden="true" class="sc-bdnxRM flLGmz"
                                                fill="currentColor" focusable="false"
                                                viewBox="0 0 32 32">
                                            <g clip-path="url(#clip0_3814_710)">
                                                <path
                                                    d="M26.9414 6.58545C28.1469 6.90813 29.0942 7.85545 29.4169 9.06092H29.4146C30 11.2437 30 15.8005 30 15.8005C30 15.8005 30 20.3573 29.4146 22.54C29.0919 23.7455 28.1445 24.6928 26.9391 25.0155C24.7563 25.6009 16 25.6009 16 25.6009C16 25.6009 7.24366 25.6009 5.06092 25.0155C3.85545 24.6928 2.90813 23.7455 2.58545 22.54C2 20.3573 2 15.8005 2 15.8005C2 15.8005 2 11.2437 2.58545 9.06092C2.90813 7.85545 3.85545 6.90813 5.06092 6.58545C7.24366 6 16 6 16 6C16 6 24.7563 6 26.9414 6.58545ZM20.4761 15.8005L13.1995 11.6009V20L20.4761 15.8005Z">
                                                </path>
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_3814_710">
                                                    <rect fill="white" height="19.6009" transform="translate(2 6)"
                                                          width="28"></rect>
                                                </clipPath>
                                            </defs>
                                        </svg></span></a></div>
              <div class="sc-gKAaRy hydYaP FooterItem"><a id="footer-instagram" aria-label="instagram"
                                                          class="sc-hBMUJo jUQvWh" color="ghost"
                                                          rel="noopener"
                                                          target="_blank" title="instagram"
                                                          @click="showLoginDialog=true"><span
                  class="sc-fFSPTT eEJWPz"><svg aria-hidden="true"
                                                class="sc-bdnxRM flLGmz" fill="currentColor"
                                                focusable="false"
                                                viewBox="0 0 32 32">
                                            <g clip-path="url(#clip0_3814_706)">
                                                <path
                                                    d="M10.6159 3.09101C9.23271 3.15627 8.28813 3.37701 7.46237 3.70149C6.60775 4.03455 5.88339 4.48149 5.16267 5.20481C4.44195 5.92813 3.99813 6.65301 3.66741 7.50893C3.34735 8.33651 3.13051 9.28187 3.06941 10.6659C3.00831 12.0498 2.99479 12.4947 3.00155 16.025C3.00831 19.5553 3.02391 19.9978 3.09099 21.3846C3.15703 22.7675 3.37699 23.7119 3.70147 24.5379C4.03505 25.3925 4.48147 26.1166 5.20505 26.8376C5.92863 27.5586 6.65299 28.0014 7.51099 28.3326C8.33779 28.6521 9.28341 28.87 10.6671 28.9306C12.0509 28.9912 12.4962 29.0052 16.0255 28.9984C19.5547 28.9917 19.9991 28.9761 21.3856 28.9103C22.7722 28.8445 23.7116 28.623 24.5379 28.3001C25.3925 27.9657 26.1171 27.5201 26.8376 26.7962C27.558 26.0724 28.0016 25.347 28.3321 24.4906C28.6524 23.6638 28.87 22.7182 28.93 21.3355C28.9906 19.9479 29.0049 19.5048 28.9982 15.975C28.9914 12.4453 28.9756 12.0028 28.9098 10.6165C28.844 9.23013 28.6238 8.28867 28.2996 7.46213C27.9655 6.60751 27.5196 5.88393 26.7962 5.16243C26.0729 4.44093 25.347 3.99763 24.4908 3.66795C23.6635 3.34789 22.7184 3.12975 21.3347 3.06995C19.951 3.01015 19.5056 2.99481 15.975 3.00157C12.4445 3.00833 12.0025 3.02341 10.6159 3.09101ZM10.7678 26.5919C9.50025 26.5368 8.81203 26.3262 8.35339 26.1499C7.74603 25.9159 7.31339 25.633 6.85631 25.1803C6.39923 24.7277 6.11843 24.2935 5.88131 23.6874C5.70321 23.2288 5.48871 22.5413 5.42943 21.2738C5.36495 19.9039 5.35143 19.4926 5.34389 16.0218C5.33635 12.5511 5.34961 12.1403 5.40967 10.7699C5.46375 9.50339 5.67565 8.81439 5.85167 8.35601C6.08567 7.74787 6.36751 7.31601 6.82121 6.85919C7.27491 6.40237 7.70781 6.12105 8.31439 5.88393C8.77251 5.70505 9.45995 5.49237 10.7269 5.43205C12.0979 5.36705 12.5087 5.35405 15.9789 5.34651C19.4492 5.33897 19.861 5.35197 21.2325 5.41229C22.499 5.46741 23.1882 5.67723 23.6461 5.85429C24.2537 6.08829 24.6861 6.36935 25.1429 6.82383C25.5997 7.27831 25.8813 7.70965 26.1184 8.31753C26.2976 8.77435 26.5102 9.46153 26.57 10.7293C26.6353 12.1003 26.6501 12.5113 26.6564 15.9813C26.6626 19.4513 26.6504 19.8633 26.5903 21.2333C26.5349 22.5008 26.3249 23.1893 26.1483 23.6484C25.9143 24.2555 25.6322 24.6884 25.1783 25.145C24.7243 25.6015 24.2919 25.8829 23.6851 26.12C23.2275 26.2986 22.5393 26.5118 21.2733 26.5721C19.9023 26.6366 19.4915 26.6501 16.02 26.6577C12.5485 26.6652 12.139 26.6512 10.768 26.5919M21.3656 9.05203C21.3661 9.36059 21.4581 9.66207 21.63 9.91833C21.8019 10.1746 22.0459 10.3741 22.3311 10.4917C22.6164 10.6093 22.9302 10.6396 23.2327 10.5789C23.5352 10.5182 23.8129 10.3691 24.0307 10.1505C24.2485 9.9319 24.3966 9.65364 24.4562 9.3509C24.5158 9.04815 24.4843 8.73453 24.3657 8.44968C24.2471 8.16483 24.0467 7.92157 23.7898 7.75064C23.5329 7.57972 23.2311 7.48881 22.9225 7.48943C22.5088 7.49026 22.1125 7.65534 21.8205 7.94837C21.5285 8.24139 21.3649 8.63838 21.3656 9.05203ZM9.32501 16.013C9.33229 19.6998 12.3265 22.6817 16.0125 22.6747C19.6985 22.6677 22.6825 19.6738 22.6755 15.987C22.6685 12.3002 19.6735 9.31749 15.987 9.32477C12.3005 9.33205 9.31799 12.3267 9.32501 16.013ZM11.6666 16.0083C11.6649 15.1513 11.9174 14.3129 12.3921 13.5994C12.8669 12.8858 13.5426 12.329 14.3337 11.9995C15.1249 11.6699 15.996 11.5824 16.837 11.7479C17.6779 11.9135 18.4509 12.3247 19.0581 12.9295C19.6653 13.5343 20.0796 14.3057 20.2485 15.1459C20.4173 15.9862 20.3332 16.8577 20.0068 17.6502C19.6804 18.4426 19.1263 19.1205 18.4146 19.5981C17.703 20.0757 16.8656 20.3315 16.0086 20.3332C15.4395 20.3344 14.8757 20.2234 14.3495 20.0067C13.8233 19.79 13.3449 19.4718 12.9417 19.0702C12.5385 18.6686 12.2184 18.1914 11.9996 17.6661C11.7808 17.1407 11.6676 16.5774 11.6666 16.0083Z">
                                                </path>
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_3814_706">
                                                    <rect fill="white" height="26" transform="translate(3 3)"
                                                          width="26"></rect>
                                                </clipPath>
                                            </defs>
                                        </svg></span></a></div>
              <div class="sc-gKAaRy hydYaP FooterItem"><a id="footer-linkedin" aria-label="linkedin"
                                                          class="sc-hBMUJo jUQvWh" color="ghost"
                                                          rel="noopener"
                                                          target="_blank" title="linkedin"
                                                          @click="showLoginDialog=true"><span
                  class="sc-fFSPTT eEJWPz"><svg aria-hidden="true"
                                                class="sc-bdnxRM flLGmz" fill="currentColor"
                                                focusable="false"
                                                viewBox="0 0 32 32">
                                            <path
                                                d="M4.91918 3H27.0751C28.1371 3 29.0008 3.83934 29.0008 4.87287V27.1231C29.0008 28.159 28.1371 29 27.0768 29H4.91918C3.86128 29 3 28.159 3 27.1231V4.87287C3 3.83934 3.86128 3 4.91918 3ZM10.719 12.7471H6.85543V25.1543H10.719V12.7471ZM11.0188 8.8063C11.0188 7.5737 10.017 6.57186 8.78437 6.57186C8.49073 6.57154 8.19991 6.6291 7.92853 6.74125C7.65716 6.85339 7.41054 7.01793 7.2028 7.22545C6.99505 7.43297 6.83025 7.6794 6.7178 7.95066C6.60536 8.22191 6.54748 8.51267 6.54748 8.8063C6.54899 9.39924 6.78525 9.96745 7.2046 10.3866C7.62395 10.8058 8.19224 11.0419 8.78518 11.0432C10.017 11.0432 11.0188 10.0389 11.0188 8.8063ZM13.1371 12.7471H13.1314L13.1371 12.7446V12.7471ZM13.1371 12.7471V25.1519H16.9901V19.0141C16.9901 17.3971 17.2988 15.829 19.3058 15.829C21.2834 15.829 21.3094 17.6815 21.3094 19.1197V25.1551H25.1633V18.3494C25.1633 15.0091 24.4425 12.4391 20.5375 12.4391C18.6541 12.4391 17.3963 13.4678 16.8812 14.4428H16.83V12.7471H13.1371Z">
                                            </path>
                                        </svg></span></a></div>
            </div>
          </div>
        </footer>
        <div id="fb-root"></div>
      </div>
    </div>
    <template v-if="showLoginDialog">
      <login-view></login-view>
    </template>
  </div>
</template>

<script>
import LoginView from './components/index/LoginView.vue'
import {mapGetters, mapState} from "vuex";

export default {
  components: {LoginView},
  data() {
    return {
      logo: '/assets/img/logo.png',
      showLoginDialog: false,
      showLang: false,
      langText: "",
      siteName: ""
    }
  },
  computed: {

    ...mapGetters({
      systemVersion: 'getSystemVersion',
    })
  },
  methods: {
    closeLoginDialog() {
      this.showLoginDialog = false
    },
    changLang(lang) {
      this.showLang = true;
      this.langText = lang;
    },
    register() {
      this.showLoginDialog = true
    }
  },
  created() {
    if (this.systemVersion === "B") {
      this.siteName = "Linkmeetion"
    }
    if (this.systemVersion === "C") {
      this.siteName = "Permeeting"
    }
  }
}
</script>

<style scoped>
.dKTwmI {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  min-height: 100vh;
}

.langMain {
  text-align: center;
}

.langTitle {
  font-size: 36px;
  margin: 30px 0;
}

.langItem {
  width: 60%;
  margin: 10px auto;
  cursor: pointer;
}

.langItem span {
  font-size: 12px;
  color: #434343;
}

/*!sc*/
.dKTwmI > footer {
  margin-top: auto;
}

/*!sc*/
data-styled.g1[id="style__StyledPageWrapper-sc-h9o74u-0"] {
  content: "dKTwmI,"
}

/*!sc*/
*,
*::before,
*::after {
  box-sizing: border-box;
}

/*!sc*/
* {
  margin: 0;
  overflow-wrap: anywhere;
}

/*!sc*/
data-styled.g2[id="sc-global-haHaQj1"] {
  content: "sc-global-haHaQj1,"
}

/*!sc*/
body {
  background-color: #f6f4ef;
}

/*!sc*/
@media only percy {
  .hide-in-percy {
    visibility: hidden !important;
  }

  .remove-in-percy,
  #onetrust-consent-sdk {
    display: none !important;
  }
}

/*!sc*/
data-styled.g3[id="sc-global-bPduyE1"] {
  content: "sc-global-bPduyE1,"
}

/*!sc*/
.dRIyKz {
  height: 1.5rem;
  width: 1.5rem;
}

/*!sc*/
.fMErFn {
  height: 1rem;
  width: 1rem;
}

/*!sc*/
.flLGmz {
  height: 1.25rem;
  width: 1.25rem;
}

/*!sc*/
data-styled.g4[id="sc-bdnxRM"] {
  content: "dRIyKz,fMErFn,flLGmz,"
}

/*!sc*/
.kMbjvJ {
  display: grid;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  background-color: #ffffff;
  border-top: solid 1px #e7e5e2;
}

/*!sc*/
@media (min-width: 1032px) {
  .kMbjvJ {
    padding: 0 2.5rem;
    -webkit-box-pack: stretch;
    -webkit-justify-content: stretch;
    -ms-flex-pack: stretch;
    justify-content: stretch;
  }
}

/*!sc*/
data-styled.g5[id="sc-gtsrHT"] {
  content: "kMbjvJ,"
}

/*!sc*/
.jEVmsW {
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  grid-template-areas: 'a a a a a a a a' 'b b b b b b b b' 'c c c c c c c c';
  grid-auto-rows: auto;
  margin: 0 1rem;
  max-width: 75rem;
  text-align: center;
  padding: 2rem 0px;
}

/*!sc*/
@media (min-width: 1032px) {
  .jEVmsW {
    grid-template-columns: repeat(12, auto);
    grid-template-rows: repeat(2, auto);
    grid-template-areas: 'a a a a a a a a a a a a a' 'b b b b b b b b c c c c c';
    margin: 0 auto;
    padding: 2.5rem 0;
    text-align: left;
    width: 100%;
  }
}

/*!sc*/
data-styled.g6[id="sc-dlnjwi"] {
  content: "jEVmsW,"
}

/*!sc*/
.iylGhi {
  grid-area: b;
  -webkit-align-self: center;
  -ms-flex-item-align: center;
  align-self: center;
  margin-bottom: 1rem;
}

/*!sc*/
@media (min-width: 1032px) {
  .iylGhi {
    margin-bottom: 0;
  }
}

/*!sc*/
data-styled.g8[id="sc-eCApnc"] {
  content: "iylGhi,"
}

/*!sc*/
.jcTaHb {
  grid-area: c;
}

/*!sc*/
@media (min-width: 1032px) {
  .jcTaHb {
    justify-self: end;
  }
}

/*!sc*/
data-styled.g9[id="sc-jSFjdj"] {
  content: "jcTaHb,"
}

/*!sc*/
.hydYaP {
  display: -webkit-inline-box;
  display: -webkit-inline-flex;
  display: -ms-inline-flexbox;
  display: inline-flex;
}

/*!sc*/
.hydYaP:last-child a::before {
  display: none;
}

/*!sc*/
data-styled.g10[id="sc-gKAaRy"] {
  content: "hydYaP,"
}

/*!sc*/
.goTNSB {
  font-family: Graphik Linkmeetion LCG, sans-serif;
  font-weight: 600;
  color: currentColor;
  font-size: 1rem;
  line-height: 1.25rem;
}

/*!sc*/
.eEHQUm {
  font-family: Graphik Linkmeetion LCG, sans-serif;
  font-weight: 600;
  color: #151515;
  font-size: 0.75rem;
  line-height: 1rem;
}

/*!sc*/
@media (min-width: 0px) {
  .eEHQUm {
    font-size: 0.75rem;
    line-height: 1rem;
  }
}

/*!sc*/
@media (min-width: 1032px) {
  .eEHQUm {
    font-size: 0.875rem;
    line-height: 1rem;
  }
}

/*!sc*/
.cgIVRG {
  font-family: Graphik Linkmeetion LCG, sans-serif;
  font-weight: 600;
  color: #ffffff;
  font-size: 1rem;
  line-height: 1.25rem;
}

/*!sc*/
.jsBGdm {
  font-family: Graphik Linkmeetion LCG, sans-serif;
  font-weight: 600;
  color: #151515;
  font-size: 1rem;
  line-height: 1.25rem;
}

/*!sc*/
.erEfuo {
  font-family: Graphik Linkmeetion LCG, sans-serif;
  font-weight: 400;
  color: #151515;
  font-size: 0.75rem;
  line-height: 1rem;
}

/*!sc*/
data-styled.g11[id="sc-iCoGMd"] {
  content: "goTNSB,eEHQUm,cgIVRG,jsBGdm,erEfuo,"
}

/*!sc*/
.XJxhY {
  color: inherit;
  font-size: inherit;
  font-weight: inherit;
}

/*!sc*/
data-styled.g13[id="sc-pNWdM"] {
  content: "XJxhY,"
}

/*!sc*/
.chWJcF {
  display: -webkit-inline-box;
  display: -webkit-inline-flex;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  box-sizing: border-box;
  border: 0;
  padding: 0;
  margin: 0;
  -webkit-text-decoration: underline;
  text-decoration: underline;
  -webkit-text-decoration-thickness: from-font;
  text-decoration-thickness: from-font;
  -webkit-transition: color 0.1s ease-in-out 0s;
  transition: color 0.1s ease-in-out 0s;
  background: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  white-space: normal;
  text-align: left;
  cursor: pointer;
  opacity: 1;
  vertical-align: bottom;
  font-family: Graphik Linkmeetion LCG;
  font-size: 1rem;
  line-height: 1.25rem;
  font-weight: 400;
  color: #151515;
}

/*!sc*/
.chWJcF:hover {
  color: #e54501;
}

/*!sc*/
.chWJcF:active {
  color: #cb3e01;
}

/*!sc*/
.chWJcF:focus {
  position: relative;
}

/*!sc*/
.chWJcF:focus:focus {
  outline: none;
}

/*!sc*/
.chWJcF:focus:focus:after {
  position: absolute;
  content: "";
  border-radius: 4px;
  top: -1px;
  right: -1px;
  bottom: -1px;
  left: -1px;
  box-shadow: 0 0 0 2px var(--focus-color, #151515);
}

/*!sc*/
.chWJcF:focus:focus:not(:focus-visible):after {
  display: none;
}

/*!sc*/
.chWJcF:focus::-moz-focus-inner {
  border: 0;
  padding: 0;
}

/*!sc*/
.vVShp {
  display: -webkit-inline-box;
  display: -webkit-inline-flex;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  box-sizing: border-box;
  border: 0;
  padding: 0;
  margin: 0;
  -webkit-text-decoration: none;
  text-decoration: none;
  -webkit-text-decoration-thickness: from-font;
  text-decoration-thickness: from-font;
  -webkit-transition: color 0.1s ease-in-out 0s;
  transition: color 0.1s ease-in-out 0s;
  background: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  white-space: normal;
  text-align: left;
  cursor: pointer;
  opacity: 1;
  vertical-align: bottom;
  font-family: Graphik Linkmeetion LCG;
  font-size: 1rem;
  line-height: 1.25rem;
  font-weight: 400;
  color: #151515;
}

/*!sc*/
.vVShp:hover {
  color: #e54501;
}

/*!sc*/
.vVShp:active {
  color: #cb3e01;
}

/*!sc*/
.vVShp:focus {
  position: relative;
}

/*!sc*/
.vVShp:focus:focus {
  outline: none;
}

/*!sc*/
.vVShp:focus:focus:after {
  position: absolute;
  content: "";
  border-radius: 4px;
  top: -1px;
  right: -1px;
  bottom: -1px;
  left: -1px;
  box-shadow: 0 0 0 2px var(--focus-color, #151515);
}

/*!sc*/
.vVShp:focus:focus:not(:focus-visible):after {
  display: none;
}

/*!sc*/
.vVShp:focus::-moz-focus-inner {
  border: 0;
  padding: 0;
}

/*!sc*/
.cdMKIg {
  display: -webkit-inline-box;
  display: -webkit-inline-flex;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  box-sizing: border-box;
  border: 0;
  padding: 0;
  margin: 0;
  -webkit-text-decoration: none;
  text-decoration: none;
  -webkit-text-decoration-thickness: from-font;
  text-decoration-thickness: from-font;
  -webkit-transition: color 0.1s ease-in-out 0s;
  transition: color 0.1s ease-in-out 0s;
  background: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  white-space: normal;
  text-align: left;
  cursor: pointer;
  opacity: 1;
  vertical-align: bottom;
  font-family: Graphik Linkmeetion LCG;
  font-size: 0.75rem;
  line-height: 1rem;
  font-weight: 600;
  color: #46443f;
}

/*!sc*/
.cdMKIg:hover {
  color: #e54501;
}

/*!sc*/
.cdMKIg:active {
  color: #cb3e01;
}

/*!sc*/
.cdMKIg:focus {
  position: relative;
}

/*!sc*/
.cdMKIg:focus:focus {
  outline: none;
}

/*!sc*/
.cdMKIg:focus:focus:after {
  position: absolute;
  content: "";
  border-radius: 4px;
  top: -1px;
  right: -1px;
  bottom: -1px;
  left: -1px;
  box-shadow: 0 0 0 2px var(--focus-color, #151515);
}

/*!sc*/
.cdMKIg:focus:focus:not(:focus-visible):after {
  display: none;
}

/*!sc*/
.cdMKIg:focus::-moz-focus-inner {
  border: 0;
  padding: 0;
}

/*!sc*/
data-styled.g15[id="sc-kEqXSa"] {
  content: "chWJcF,vVShp,cdMKIg,"
}

/*!sc*/
.DykGo {
  margin: 0.25rem 0.75rem 0.25rem 0.5rem;
  position: relative;
}

/*!sc*/
.DykGo::before {
  content: '·';
  position: absolute;
  right: -0.75rem;
}

/*!sc*/
data-styled.g17[id="sc-crzoAE"] {
  content: "DykGo,"
}

/*!sc*/
.iPexDg {
  display: inline-block;
  border: none;
  margin: 0;
  padding: 0;
  width: auto;
  overflow: visible;
  background: transparent;
  color: inherit;
  font: inherit;
  text-align: inherit;
  text-transform: inherit;
  box-sizing: border-box;
  -webkit-font-smoothing: inherit;
  -moz-osx-font-smoothing: inherit;
  -webkit-appearance: none;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
  font-family: Graphik Linkmeetion LCG, sans-serif;
  white-space: nowrap;
}

/*!sc*/
.iPexDg:disabled {
  cursor: default;
}

/*!sc*/
data-styled.g20[id="sc-bqGGPW"] {
  content: "iPexDg,"
}

/*!sc*/
.jZVOKR {
  position: relative;
}

/*!sc*/
.jZVOKR:focus {
  outline: none;
}

/*!sc*/
.jZVOKR:focus:after {
  position: absolute;
  content: "";
  border-radius: 7px;
  top: -3px;
  right: -3px;
  bottom: -3px;
  left: -3px;
  box-shadow: 0 0 0 2px var(--focus-color, #151515);
}

/*!sc*/
.jZVOKR:focus:not(:focus-visible):after {
  display: none;
}

/*!sc*/
.jZVOKR::-moz-focus-inner {
  border: 0;
  padding: 0;
}

/*!sc*/
data-styled.g21[id="sc-ksluID"] {
  content: "jZVOKR,"
}

/*!sc*/
.cCkJIK {
  box-sizing: border-box;
  position: relative;
  border-radius: 4000px;
  cursor: pointer;
  display: -webkit-inline-box;
  display: -webkit-inline-flex;
  display: -ms-inline-flexbox;
  display: inline-flex;
  min-height: 44px;
  height: 0%;
  padding: calc(12px - 2px) 24px;
  min-width: 3rem;
  width: 100%;
  -webkit-flex-shrink: 0;
  -ms-flex-negative: 0;
  flex-shrink: 0;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  outline: none;
  -webkit-text-decoration: none;
  text-decoration: none;
  margin: 0px;
  -webkit-transition: all 100ms ease-out;
  transition: all 100ms ease-out;
  background-color: #fe4d01;
  color: #ffffff;
  border: 1px solid #fe4d01;
}

/*!sc*/
.cCkJIK svg {
  margin-right: 8px;
}

/*!sc*/
@media (min-width: 0px) {
  .cCkJIK {
    width: 100%;
  }
}

/*!sc*/
@media (min-width: 720px) {
  .cCkJIK {
    width: auto;
  }
}

/*!sc*/
.cCkJIK:hover {
  background-color: #e54501;
  color: #ffffff;
  border: 1px solid #e54501;
}

/*!sc*/
.cCkJIK:enabled:active {
  background-color: #cb3e01;
  color: #ffffff;
  border: 1px solid #cb3e01;
}

/*!sc*/
.cCkJIK:disabled {
  cursor: not-allowed;
}

/*!sc*/
.cCkJIK:focus {
  outline: none;
}

/*!sc*/
.cCkJIK:focus:after {
  position: absolute;
  content: "";
  border-radius: 4003px;
  top: -3px;
  right: -3px;
  bottom: -3px;
  left: -3px;
  box-shadow: 0 0 0 2px var(--focus-color, #151515);
}

/*!sc*/
.cCkJIK:focus:not(:focus-visible):after {
  display: none;
}

/*!sc*/
.cCkJIK::-moz-focus-inner {
  border: 0;
  padding: 0;
}

/*!sc*/
.eYQjJA {
  box-sizing: border-box;
  position: relative;
  border-radius: 4000px;
  cursor: pointer;
  display: -webkit-inline-box;
  display: -webkit-inline-flex;
  display: -ms-inline-flexbox;
  display: inline-flex;
  min-height: 44px;
  height: 0%;
  padding: calc(12px - 2px) 24px;
  min-width: 3rem;
  width: 100%;
  -webkit-flex-shrink: 0;
  -ms-flex-negative: 0;
  flex-shrink: 0;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  outline: none;
  -webkit-text-decoration: none;
  text-decoration: none;
  margin: 0px;
  -webkit-transition: all 100ms ease-out;
  transition: all 100ms ease-out;
  background-color: #ffffff;
  color: #151515;
  border: 1px solid #151515;
}

/*!sc*/
.eYQjJA svg {
  margin-right: 8px;
}

/*!sc*/
@media (min-width: 0px) {
  .eYQjJA {
    width: 100%;
  }
}

/*!sc*/
@media (min-width: 720px) {
  .eYQjJA {
    width: auto;
  }
}

/*!sc*/
.eYQjJA:hover {
  background-color: #efeeeb;
  color: #151515;
  border: 1px solid #151515;
}

/*!sc*/
.eYQjJA:enabled:active {
  background-color: #dfddd8;
  color: #151515;
  border: 1px solid #151515;
}

/*!sc*/
.eYQjJA:disabled {
  cursor: not-allowed;
}

/*!sc*/
.eYQjJA:focus {
  outline: none;
}

/*!sc*/
.eYQjJA:focus:after {
  position: absolute;
  content: "";
  border-radius: 4003px;
  top: -3px;
  right: -3px;
  bottom: -3px;
  left: -3px;
  box-shadow: 0 0 0 2px var(--focus-color, #151515);
}

/*!sc*/
.eYQjJA:focus:not(:focus-visible):after {
  display: none;
}

/*!sc*/
.eYQjJA::-moz-focus-inner {
  border: 0;
  padding: 0;
}

/*!sc*/
.fkiDuQ {
  box-sizing: border-box;
  position: relative;
  border-radius: 4000px;
  cursor: pointer;
  display: -webkit-inline-box;
  display: -webkit-inline-flex;
  display: -ms-inline-flexbox;
  display: inline-flex;
  min-height: 36px;
  height: 0%;
  padding: calc(8px - 2px) 16px;
  min-width: 3rem;
  width: auto;
  -webkit-flex-shrink: 0;
  -ms-flex-negative: 0;
  flex-shrink: 0;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  outline: none;
  -webkit-text-decoration: none;
  text-decoration: none;
  margin: 0px;
  -webkit-transition: all 100ms ease-out;
  transition: all 100ms ease-out;
  background-color: #fe4d01;
  color: #ffffff;
  border: 1px solid #fe4d01;
}

/*!sc*/
.fkiDuQ svg {
  margin-right: 4px;
}

/*!sc*/
.fkiDuQ:hover {
  background-color: #e54501;
  color: #ffffff;
  border: 1px solid #e54501;
}

/*!sc*/
.fkiDuQ:enabled:active {
  background-color: #cb3e01;
  color: #ffffff;
  border: 1px solid #cb3e01;
}

/*!sc*/
.fkiDuQ:disabled {
  cursor: not-allowed;
}

/*!sc*/
.fkiDuQ:focus {
  outline: none;
}

/*!sc*/
.fkiDuQ:focus:after {
  position: absolute;
  content: "";
  border-radius: 4003px;
  top: -3px;
  right: -3px;
  bottom: -3px;
  left: -3px;
  box-shadow: 0 0 0 2px var(--focus-color, #151515);
}

/*!sc*/
.fkiDuQ:focus:not(:focus-visible):after {
  display: none;
}

/*!sc*/
.fkiDuQ::-moz-focus-inner {
  border: 0;
  padding: 0;
}

/*!sc*/
.dzZuYr {
  box-sizing: border-box;
  position: relative;
  border-radius: 4000px;
  cursor: pointer;
  display: -webkit-inline-box;
  display: -webkit-inline-flex;
  display: -ms-inline-flexbox;
  display: inline-flex;
  min-height: 44px;
  height: 0%;
  padding: calc(12px - 2px) 24px;
  min-width: 3rem;
  width: auto;
  -webkit-flex-shrink: 0;
  -ms-flex-negative: 0;
  flex-shrink: 0;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  outline: none;
  -webkit-text-decoration: none;
  text-decoration: none;
  margin: 0px;
  -webkit-transition: all 100ms ease-out;
  transition: all 100ms ease-out;
  background-color: #151515;
  color: #ffffff;
  border: 1px solid #151515;
}

/*!sc*/
.dzZuYr svg {
  margin-right: 8px;
}

/*!sc*/
.dzZuYr:hover {
  background-color: #34332f;
  color: #ffffff;
  border: 1px solid #34332f;
}

/*!sc*/
.dzZuYr:enabled:active {
  background-color: #57554f;
  color: #ffffff;
  border: 1px solid #57554f;
}

/*!sc*/
.dzZuYr:disabled {
  cursor: not-allowed;
}

/*!sc*/
.dzZuYr:focus {
  outline: none;
}

/*!sc*/
.dzZuYr:focus:after {
  position: absolute;
  content: "";
  border-radius: 4003px;
  top: -3px;
  right: -3px;
  bottom: -3px;
  left: -3px;
  box-shadow: 0 0 0 2px var(--focus-color, #151515);
}

/*!sc*/
.dzZuYr:focus:not(:focus-visible):after {
  display: none;
}

/*!sc*/
.dzZuYr::-moz-focus-inner {
  border: 0;
  padding: 0;
}

/*!sc*/
.bSCHIL {
  box-sizing: border-box;
  position: relative;
  border-radius: 4000px;
  cursor: pointer;
  display: -webkit-inline-box;
  display: -webkit-inline-flex;
  display: -ms-inline-flexbox;
  display: inline-flex;
  min-height: 44px;
  height: 0%;
  padding: calc(12px - 2px) 24px;
  min-width: 3rem;
  width: auto;
  -webkit-flex-shrink: 0;
  -ms-flex-negative: 0;
  flex-shrink: 0;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  outline: none;
  -webkit-text-decoration: none;
  text-decoration: none;
  margin: 0px;
  -webkit-transition: all 100ms ease-out;
  transition: all 100ms ease-out;
  background-color: rgba(255, 255, 255, 0);
  color: #151515;
  border: 1px solid rgba(255, 255, 255, 0);
}

/*!sc*/
.bSCHIL svg {
  margin-right: 8px;
}

/*!sc*/
.bSCHIL:hover {
  background-color: #efeeeb;
  color: #151515;
  border: 1px solid #efeeeb;
}

/*!sc*/
.bSCHIL:enabled:active {
  background-color: #dfddd8;
  color: #151515;
  border: 1px solid #dfddd8;
}

/*!sc*/
.bSCHIL:disabled {
  cursor: not-allowed;
}

/*!sc*/
.bSCHIL:focus {
  outline: none;
}

/*!sc*/
.bSCHIL:focus:after {
  position: absolute;
  content: "";
  border-radius: 4003px;
  top: -3px;
  right: -3px;
  bottom: -3px;
  left: -3px;
  box-shadow: 0 0 0 2px var(--focus-color, #151515);
}

/*!sc*/
.bSCHIL:focus:not(:focus-visible):after {
  display: none;
}

/*!sc*/
.bSCHIL::-moz-focus-inner {
  border: 0;
  padding: 0;
}

/*!sc*/
.jUQvWh {
  box-sizing: border-box;
  position: relative;
  border-radius: 4000px;
  cursor: pointer;
  display: -webkit-inline-box;
  display: -webkit-inline-flex;
  display: -ms-inline-flexbox;
  display: inline-flex;
  height: 36px;
  width: 36px;
  padding: 8px;
  -webkit-flex-shrink: 0;
  -ms-flex-negative: 0;
  flex-shrink: 0;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  outline: none;
  -webkit-text-decoration: none;
  text-decoration: none;
  margin: 0px;
  -webkit-transition: all 100ms ease-out;
  transition: all 100ms ease-out;
  background-color: rgba(255, 255, 255, 0);
  color: #151515;
  border: 1px solid rgba(255, 255, 255, 0);
}

/*!sc*/
.jUQvWh:hover {
  background-color: #efeeeb;
  color: #151515;
  border: 1px solid #efeeeb;
}

/*!sc*/
.jUQvWh:enabled:active {
  background-color: #dfddd8;
  color: #151515;
  border: 1px solid #dfddd8;
}

/*!sc*/
.jUQvWh:disabled {
  cursor: not-allowed;
}

/*!sc*/
.jUQvWh:focus {
  outline: none;
}

/*!sc*/
.jUQvWh:focus:after {
  position: absolute;
  content: "";
  border-radius: 4003px;
  top: -3px;
  right: -3px;
  bottom: -3px;
  left: -3px;
  box-shadow: 0 0 0 2px var(--focus-color, #151515);
}

/*!sc*/
.jUQvWh:focus:not(:focus-visible):after {
  display: none;
}

/*!sc*/
.jUQvWh::-moz-focus-inner {
  border: 0;
  padding: 0;
}

/*!sc*/
data-styled.g22[id="sc-hBMUJo"] {
  content: "cCkJIK,eYQjJA,fkiDuQ,dzZuYr,bSCHIL,jUQvWh,"
}

/*!sc*/
.cOzvaY {
  box-sizing: border-box;
  position: relative;
  border-radius: 4000px;
  cursor: pointer;
  display: -webkit-inline-box;
  display: -webkit-inline-flex;
  display: -ms-inline-flexbox;
  display: inline-flex;
  height: 44px;
  width: 44px;
  padding: 12px;
  -webkit-flex-shrink: 0;
  -ms-flex-negative: 0;
  flex-shrink: 0;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  outline: none;
  -webkit-text-decoration: none;
  text-decoration: none;
  margin: 0px;
  -webkit-transition: all 100ms ease-out;
  transition: all 100ms ease-out;
  background-color: #151515;
  color: #ffffff;
  border: 1px solid #151515;
}

/*!sc*/
.cOzvaY:enabled:active {
  background-color: #57554f;
  color: #ffffff;
  border: 1px solid #57554f;
}

/*!sc*/
.cOzvaY:disabled {
  background-color: #dfddd8;
  color: #9d998e;
  border: 1px solid #efeeeb;
  cursor: not-allowed;
}

/*!sc*/
.cOzvaY:focus {
  outline: none;
}

/*!sc*/
.cOzvaY:focus:after {
  position: absolute;
  content: "";
  border-radius: 4003px;
  top: -3px;
  right: -3px;
  bottom: -3px;
  left: -3px;
  box-shadow: 0 0 0 2px var(--focus-color, #151515);
}

/*!sc*/
.cOzvaY:focus:not(:focus-visible):after {
  display: none;
}

/*!sc*/
.cOzvaY::-moz-focus-inner {
  border: 0;
  padding: 0;
}

/*!sc*/
.cdFCro {
  box-sizing: border-box;
  position: relative;
  border-radius: 4000px;
  cursor: pointer;
  display: -webkit-inline-box;
  display: -webkit-inline-flex;
  display: -ms-inline-flexbox;
  display: inline-flex;
  height: 44px;
  width: 44px;
  padding: 12px;
  -webkit-flex-shrink: 0;
  -ms-flex-negative: 0;
  flex-shrink: 0;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  outline: none;
  -webkit-text-decoration: none;
  text-decoration: none;
  margin: 0px;
  -webkit-transition: all 100ms ease-out;
  transition: all 100ms ease-out;
  background-color: #151515;
  color: #ffffff;
  border: 1px solid #151515;
}

/*!sc*/
.cdFCro:hover {
  background-color: #34332f;
  color: #ffffff;
  border: 1px solid #34332f;
}

/*!sc*/
.cdFCro:enabled:active {
  background-color: #57554f;
  color: #ffffff;
  border: 1px solid #57554f;
}

/*!sc*/
.cdFCro:disabled {
  cursor: not-allowed;
}

/*!sc*/
.cdFCro:focus {
  outline: none;
}

/*!sc*/
.cdFCro:focus:after {
  position: absolute;
  content: "";
  border-radius: 4003px;
  top: -3px;
  right: -3px;
  bottom: -3px;
  left: -3px;
  box-shadow: 0 0 0 2px var(--focus-color, #151515);
}

/*!sc*/
.cdFCro:focus:not(:focus-visible):after {
  display: none;
}

/*!sc*/
.cdFCro::-moz-focus-inner {
  border: 0;
  padding: 0;
}

/*!sc*/
data-styled.g23[id="sc-fnVZcZ"] {
  content: "cOzvaY,cdFCro,"
}

/*!sc*/
.eEJWPz {
  display: -webkit-inline-box;
  display: -webkit-inline-flex;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

/*!sc*/
data-styled.g24[id="sc-fFSPTT"] {
  content: "eEJWPz,"
}

/*!sc*/
.bzdhQC > svg:nth-child(1) {
  display: none;
}

/*!sc*/
.bzdhQC > svg:nth-child(2) {
  display: block;
}

/*!sc*/
@media (min-width: 0px) {
  .bzdhQC > svg:nth-child(1) {
    display: none;
  }

  .bzdhQC > svg:nth-child(2) {
    display: block;
  }
}

/*!sc*/
@media (min-width: 720px) {
  .bzdhQC > svg:nth-child(1) {
    display: block;
  }

  .bzdhQC > svg:nth-child(2) {
    display: none;
  }
}

/*!sc*/
data-styled.g26[id="sc-iemWCZ"] {
  content: "bzdhQC,"
}

/*!sc*/


/*!sc*/
@media (min-width: 0px) {
  .caTDpS {
    display: -webkit-inline-box;
    display: -webkit-inline-flex;
    display: -ms-inline-flexbox;
    display: inline-flex;
  }
}

/*!sc*/
@media (min-width: 1032px) {
  .caTDpS {
    display: none;
  }
}

/*!sc*/
data-styled.g27[id="sc-dIvrsQ"] {
  content: "caTDpS,"
}

/*!sc*/
.iyDqRv {
  box-sizing: border-box;
  width: 100%;
  position: static;
}

/*!sc*/
@media (min-width: 1032px) {
  .iyDqRv {
    position: static;
    height: auto;
    display: block;
  }
}

/*!sc*/
.iyDqRv *,
.iyDqRv *:before,
.iyDqRv *:after {
  box-sizing: inherit;
}

/*!sc*/
data-styled.g29[id="sc-hHEiqL"] {
  content: "iyDqRv,"
}

/*!sc*/
.hVERnw {
  background: #ffffff;
  position: relative;
}

/*!sc*/
@media (min-width: 1032px) {
  .hVERnw {
    height: 4rem;
    overflow: visible;
  }
}

/*!sc*/
data-styled.g30[id="sc-dlMDgC"] {
  content: "hVERnw,"
}

/*!sc*/
.cAqmaJ {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 0px 16px;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  gap: 0;
}

/*!sc*/
.rQVrw {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  gap: 24px;
}

/*!sc*/
.gwFRLa {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  gap: 0;
}

/*!sc*/
@media (min-width: 0px) {
  .gwFRLa {
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
  }
}

/*!sc*/
@media (min-width: 1032px) {
  .gwFRLa {
    -webkit-flex-direction: row;
    -ms-flex-direction: row;
    flex-direction: row;
  }
}

/*!sc*/
.AMXKy {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  gap: 0;
}

/*!sc*/
.eySVyK {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  gap: 0;
}

/*!sc*/
.fidEIY {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  gap: 16px;
}

/*!sc*/
@media (min-width: 0px) {
  .fidEIY {
    gap: 16px;
  }
}

/*!sc*/
@media (min-width: 1032px) {
  .fidEIY {
    gap: 24px;
  }
}

/*!sc*/
.eNJToF {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-pack: start;
  -webkit-justify-content: flex-start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  gap: 16px;
}

/*!sc*/
.fuPtPe {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  gap: 0;
}

/*!sc*/
.llREnb {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  gap: 0;
}

/*!sc*/
.cNabcs {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  gap: 24px;
}

/*!sc*/
.fQlzpe {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-align-items: flex-start;
  -webkit-box-align: flex-start;
  -ms-flex-align: flex-start;
  align-items: flex-start;
  padding: 1.5rem;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  gap: 0;
}

/*!sc*/
@media (min-width: 0px) {
  .fQlzpe {
    padding: 1.5rem;
  }
}

/*!sc*/
@media (min-width: 1440px) {
  .fQlzpe {
    padding: 2rem;
  }
}

/*!sc*/
.jmUfzQ {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  padding: 0px 0px 1rem 0px;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  gap: 16px;
}

/*!sc*/
@media (min-width: 0px) {
  .jmUfzQ {
    padding: 0px 0px 1rem 0px;
  }
}

/*!sc*/
@media (min-width: 720px) {
  .jmUfzQ {
    padding: 0px 0px 2rem 0px;
  }
}

/*!sc*/
.kOAlcr {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-align-items: flex-start;
  -webkit-box-align: flex-start;
  -ms-flex-align: flex-start;
  align-items: flex-start;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  gap: 1.5rem;
}

/*!sc*/
.iNqYiX {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  gap: 48px;
}

/*!sc*/
@media (min-width: 0px) {
  .iNqYiX {
    gap: 48px;
  }
}

/*!sc*/
@media (min-width: 1032px) {
  .iNqYiX {
    gap: 32px;
  }
}

/*!sc*/
.jLufbg {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  gap: 32px;
}

/*!sc*/
@media (min-width: 0px) {
  .jLufbg {
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    gap: 32px;
  }
}

/*!sc*/
@media (min-width: 1032px) {
  .jLufbg {
    -webkit-flex-direction: row;
    -ms-flex-direction: row;
    flex-direction: row;
    gap: 16px;
  }
}

/*!sc*/
@media (min-width: 1440px) {
  .jLufbg {
    gap: 30px;
  }
}

/*!sc*/
.hrDoZu {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-box-pack: start;
  -webkit-justify-content: flex-start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  gap: 32px;
}

/*!sc*/
.gkQoUp {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  gap: 16px;
}

/*!sc*/
.bFRrHW {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  gap: 1.5rem;
}

/*!sc*/
.dCKHNs {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 3rem 0px;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  gap: 2rem;
}

/*!sc*/
@media (min-width: 0px) {
  .dCKHNs {
    padding: 3rem 0px;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    gap: 2rem;
  }
}

/*!sc*/
@media (min-width: 720px) {
  .dCKHNs {
    padding: 4rem 0px;
    gap: 3rem;
  }
}

/*!sc*/
@media (min-width: 1032px) {
  .dCKHNs {
    -webkit-flex-direction: row;
    -ms-flex-direction: row;
    flex-direction: row;
  }
}

/*!sc*/
.dnBnCe {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  gap: 1rem;
}

/*!sc*/
@media (min-width: 0px) {
  .dnBnCe {
    gap: 1rem;
  }
}

/*!sc*/
@media (min-width: 1032px) {
  .dnBnCe {
    gap: 1.5rem;
  }
}

/*!sc*/
.eyeIOI {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  gap: 0.75rem;
}

/*!sc*/
.kJKzWc {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  gap: 12px;
}

/*!sc*/
.isFalJ {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  gap: 0;
}

/*!sc*/
@media (min-width: 0px) {
  .isFalJ {
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
  }
}

/*!sc*/
@media (min-width: 1600px) {
  .isFalJ {
    -webkit-flex-direction: row;
    -ms-flex-direction: row;
    flex-direction: row;
  }
}

/*!sc*/
.jvUiWp {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  gap: 12px;
}

/*!sc*/
.cvOsxe {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  padding: 24px 0px 0px;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  gap: 12px;
}

/*!sc*/
@media (min-width: 0px) {
  .cvOsxe {
    padding: 24px 0px 0px;
  }
}

/*!sc*/
@media (min-width: 1600px) {
  .cvOsxe {
    padding: 48px 0px 0px;
  }
}

/*!sc*/
.fRGFoW {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  gap: 0;
}

/*!sc*/
@media (min-width: 0px) {
  .fRGFoW {
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
  }
}

/*!sc*/
@media (min-width: 1032px) {
  .fRGFoW {
    -webkit-flex-direction: row;
    -ms-flex-direction: row;
    flex-direction: row;
  }
}

/*!sc*/
.dqSvs {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  gap: 16px;
}

/*!sc*/
.glIOrA {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  gap: 20px;
}

/*!sc*/
data-styled.g31[id="sc-kfYoZR"] {
  content: "cAqmaJ,rQVrw,gwFRLa,AMXKy,eySVyK,fidEIY,eNJToF,fuPtPe,llREnb,cNabcs,fQlzpe,jmUfzQ,kOAlcr,iNqYiX,jLufbg,hrDoZu,gkQoUp,bFRrHW,dCKHNs,dnBnCe,eyeIOI,kJKzWc,isFalJ,jvUiWp,cvOsxe,fRGFoW,dqSvs,glIOrA,"
}

/*!sc*/
.cxbltl {
  margin: 0 auto;
  max-width: 1200px;
  min-height: 4rem;
}

/*!sc*/
@media (min-width: 1032px) {
  .cxbltl {
    height: 4rem;
  }
}

/*!sc*/
data-styled.g32[id="sc-fKgJPI"] {
  content: "cxbltl,"
}

/*!sc*/
.iXQYYt {
  display: none;
}

/*!sc*/
@media (min-width: 0px) {
  .iXQYYt {
    display: none;
  }
}

/*!sc*/
@media (min-width: 1032px) {
  .iXQYYt {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
  }
}

/*!sc*/
@media (min-width: 1032px) {
  .iXQYYt {
    position: static;
    overflow: visible;
    height: auto;
    min-height: auto;
    padding: 0;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    -ms-flex-pack: justify;
    justify-content: space-between;
  }
}

/*!sc*/
.icfOOg {
  display: none;
}

/*!sc*/
@media (min-width: 0px) {
  .icfOOg {
    display: none;
  }
}

/*!sc*/
@media (min-width: 1032px) {
  .icfOOg {
    display: none;
  }
}

/*!sc*/
@media (min-width: 1032px) {
  .icfOOg {
    position: static;
    overflow: visible;
    height: auto;
    min-height: auto;
    padding: 0;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    -ms-flex-pack: justify;
    justify-content: space-between;
  }
}

/*!sc*/
data-styled.g33[id="sc-bCwfaz"] {
  content: "iXQYYt,icfOOg,"
}

/*!sc*/
.hmxyOL {
  display: block;
}

/*!sc*/
data-styled.g34[id="sc-iwajpm"] {
  content: "hmxyOL,"
}

/*!sc*/
.fHUQtx {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: start;
  -webkit-justify-content: flex-start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-flex: 1 1 0;
  -ms-flex: 1 1 0;
  flex: 1 1 0;
}

/*!sc*/
.fHUQtx > *:nth-child(2) {
  margin-left: 32px;
}

/*!sc*/
@media (min-width: 720px) {
  .fHUQtx {
    -webkit-flex: 1 1 auto;
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
  }
}

/*!sc*/
data-styled.g35[id="sc-cxNHIi"] {
  content: "fHUQtx,"
}

/*!sc*/
.hpRDUw {
  -webkit-box-pack: end;
  -webkit-justify-content: flex-end;
  -ms-flex-pack: end;
  justify-content: flex-end;
  -webkit-flex: 1 1 auto;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
}

/*!sc*/
data-styled.g36[id="sc-lmgQwP"] {
  content: "hpRDUw,"
}

/*!sc*/
@media (min-width: 1032px) {
  .hPERJB {
    gap: 1.5rem;
  }
}

/*!sc*/
data-styled.g40[id="sc-bYwzuL"] {
  content: "hPERJB,"
}

/*!sc*/
.ijRzoh {
  width: 100%;
  display: -webkit-inline-box;
  display: -webkit-inline-flex;
  display: -ms-inline-flexbox;
  display: inline-flex;
}

/*!sc*/
@media (min-width: 1032px) {
  .ijRzoh {
    width: auto;
  }
}

/*!sc*/
.faTBaw {
  width: 100%;
  display: -webkit-inline-box;
  display: -webkit-inline-flex;
  display: -ms-inline-flexbox;
  display: inline-flex;
}

/*!sc*/
@media (min-width: 1032px) {
  .faTBaw {
    width: auto;
  }
}

/*!sc*/
@media (min-width: 0px) {
  .faTBaw {
    display: -webkit-inline-box;
    display: -webkit-inline-flex;
    display: -ms-inline-flexbox;
    display: inline-flex;
  }
}

/*!sc*/
@media (min-width: 1032px) {
  .faTBaw {
    display: none;
  }
}

/*!sc*/
.giIhGp {
  width: 100%;
  display: none;
}

/*!sc*/
@media (min-width: 1032px) {
  .giIhGp {
    width: auto;
  }
}

/*!sc*/
@media (min-width: 0px) {
  .giIhGp {
    display: none;
  }
}

/*!sc*/
@media (min-width: 1032px) {
  .giIhGp {
    display: -webkit-inline-box;
    display: -webkit-inline-flex;
    display: -ms-inline-flexbox;
    display: inline-flex;
  }
}

/*!sc*/
data-styled.g41[id="sc-kLojOw"] {
  content: "ijRzoh,faTBaw,giIhGp,"
}

/*!sc*/
.hbusih {
  -webkit-text-decoration: none;
  text-decoration: none;
  cursor: pointer;
  width: 100%;
  white-space: nowrap;
  padding: 12px 0;
}

/*!sc*/
@media (min-width: 1032px) {
  .hbusih {
    padding: 0;
    justfy-content: flex-start;
  }
}

/*!sc*/
data-styled.g42[id="sc-iklJeh"] {
  content: "hbusih,"
}

/*!sc*/
.laKGqb {
  position: absolute;
  margin: -1px;
  padding: 0;
  height: 1px;
  width: 1px;
  border: 0;
  -webkit-clip: rect(0 0 0 0);
  clip: rect(0 0 0 0);
  overflow: hidden;
  white-space: nowrap;
  word-wrap: normal;
}

/*!sc*/
data-styled.g43[id="sc-jJMGnK"] {
  content: "laKGqb,"
}

/*!sc*/
.fQBbke {
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  border: none;
  border-radius: 0;
  color: #151515;
  cursor: pointer;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  font-family: Graphik Linkmeetion LCG;
  font-size: inherit;
  gap: 4px;
  height: auto;
  padding: 0.75rem 0;
}

/*!sc*/
data-styled.g44[id="style__ButtonMenu-sc-19d5cj-0"] {
  content: "fQBbke,"
}

/*!sc*/
.iUOrPP {
  position: relative;
  padding: 0;
  list-style: none;
}

/*!sc*/
data-styled.g45[id="style__DisclosureMenuContent-sc-19d5cj-1"] {
  content: "iUOrPP,"
}

/*!sc*/
.gUojGE {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

/*!sc*/
data-styled.g48[id="style__Label-sc-1dh24tn-0"] {
  content: "gUojGE,"
}

/*!sc*/
.hNsYGX {
  margin-right: 4px;
}

/*!sc*/
data-styled.g49[id="style__StyledIcon-sc-1dh24tn-1"] {
  content: "hNsYGX,"
}

/*!sc*/
@media (min-width: 1032px) {
  .cnhmTn {
    display: none;
  }
}

/*!sc*/
data-styled.g50[id="style__LabelTextMobile-sc-1dh24tn-2"] {
  content: "cnhmTn,"
}

/*!sc*/
.elbCac {
  display: none;
}

/*!sc*/
@media (min-width: 1032px) {
  .elbCac {
    display: inline;
  }
}

/*!sc*/
data-styled.g51[id="style__LabelTextDesktop-sc-1dh24tn-3"] {
  content: "elbCac,"
}

/*!sc*/
.zLqvh {
  border-top: 1px solid #d7d4cf;
  width: 100%;
  margin: 12px 0;
}

/*!sc*/
data-styled.g52[id="style__SeparatorMobile-sc-1ceufpk-0"] {
  content: "zLqvh,"
}

/*!sc*/
.idRyFS {
  border-left: 1px solid #d7d4cf;
  height: 28px;
}

/*!sc*/
data-styled.g53[id="style__SeparatorDesktop-sc-1ceufpk-1"] {
  content: "idRyFS,"
}

/*!sc*/
@media (min-width: 720px) {
  .hgXHcj {
    min-width: 24ch;
  }
}

/*!sc*/
@media (min-width: 1032px) {
  .hgXHcj {
    min-width: auto;
  }
}

/*!sc*/
data-styled.g54[id="style__LoginButton-sc-1ceufpk-2"] {
  content: "hgXHcj,"
}

/*!sc*/
.jKQNoI {
  margin: 64px 0 16px;
}

/*!sc*/
@media (min-width: 720px) {
  .jKQNoI {
    min-width: 24ch;
  }
}

/*!sc*/
@media (min-width: 1032px) {
  .jKQNoI {
    min-width: auto;
  }
}

/*!sc*/
@media (min-width: 1032px) {
  .jKQNoI {
    margin: 0;
  }
}

/*!sc*/
data-styled.g55[id="style__RegisterButton-sc-1ceufpk-3"] {
  content: "jKQNoI,"
}

/*!sc*/
.kkpxKb {
  position: relative;
  min-height: 100%;
  isolation: isolate;
  background-color: #f6f4ef;
}

/*!sc*/
.fqKWJw {
  position: relative;
  min-height: 100%;
  isolation: isolate;
  background-color: #fe4d01;
}

/*!sc*/
data-styled.g56[id="style__Container-sc-ttg9pt-0"] {
  content: "kkpxKb,fqKWJw,"
}

/*!sc*/
.dpQAxa {
  position: relative;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
}

/*!sc*/
@media (min-width: 1032px) {
  .dpQAxa {
    display: block;
  }
}

/*!sc*/
data-styled.g58[id="style__StyledBackgroundImage-sc-11winof-0"] {
  content: "dpQAxa,"
}

/*!sc*/
.hfoHHA {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  margin: 0 auto;
  padding: 48px 16px;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  gap: 64px;
  max-width: 100%;
}

/*!sc*/
@media (min-width: 720px) {
  .hfoHHA {
    padding: 64px 16px;
  }
}

/*!sc*/
@media (min-width: 1032px) {
  .hfoHHA {
    padding: 64px 32px;
    gap: 32px;
  }
}

/*!sc*/
@media (min-width: 1600px) {
  .hfoHHA {
    max-width: 1600px;
    padding: 96px 48px;
  }
}

/*!sc*/
@media (min-width: 1032px) {
  .hfoHHA {
    -webkit-flex-direction: row;
    -ms-flex-direction: row;
    flex-direction: row;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    -ms-flex-pack: justify;
    justify-content: space-between;
  }
}

/*!sc*/
.esUSAq {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  margin: 0 auto;
  padding: 48px 16px;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  gap: 64px;
  max-width: 100%;
}

/*!sc*/
@media (min-width: 720px) {
  .esUSAq {
    padding: 64px 16px;
  }
}

/*!sc*/
@media (min-width: 1032px) {
  .esUSAq {
    padding: 64px 32px;
    gap: 32px;
  }
}

/*!sc*/
@media (min-width: 1600px) {
  .esUSAq {
    max-width: 1600px;
    padding: 96px 48px;
  }
}

/*!sc*/
data-styled.g59[id="style__Container-sc-11winof-1"] {
  content: "hfoHHA,esUSAq,"
}

/*!sc*/
.cCcLUY {
  width: 100%;
  height: 100%;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
}

/*!sc*/
@media (min-width: 1032px) {
  .cCcLUY {
    width: calc(50% - 16px);
  }
}

/*!sc*/
data-styled.g60[id="style__LeftRightImageWrap-sc-11winof-2"] {
  content: "cCcLUY,"
}

/*!sc*/
.fKEYFE {
  font-family: Graphik Linkmeetion LCG, sans-serif;
  font-weight: 400;
  color: #151515;
  font-size: 0.875rem;
  line-height: 1.25rem;
}

/*!sc*/
.eCtBEf {
  font-family: Graphik Linkmeetion LCG, sans-serif;
  font-weight: 400;
  color: #151515;
  font-size: 1rem;
  line-height: 1.5rem;
}

/*!sc*/
.PuhuC {
  font-family: Graphik Linkmeetion LCG, sans-serif;
  font-weight: 600;
  color: #46443f;
  font-size: 1rem;
  line-height: 1.5rem;
}

/*!sc*/
data-styled.g61[id="sc-hiKfDv"] {
  content: "fKEYFE,eCtBEf,PuhuC,"
}

/*!sc*/
.kvQnlj {
  font-family: Feature Text LC, serif;
  font-weight: 400;
  color: #151515;
  font-size: 2rem;
  line-height: 2.5rem;
}

/*!sc*/
@media (min-width: 0px) {
  .kvQnlj {
    font-size: 2rem;
    line-height: 2.5rem;
  }
}

/*!sc*/
@media (min-width: 720px) {
  .kvQnlj {
    font-size: 2.5rem;
    line-height: 2.75rem;
  }
}

/*!sc*/
@media (min-width: 1440px) {
  .kvQnlj {
    font-size: 3rem;
    line-height: 3.5rem;
  }
}

/*!sc*/
.caSaty {
  font-family: Feature Text LC, serif;
  font-weight: 400;
  color: #151515;
  font-size: 2.5rem;
  line-height: 2.75rem;
}

/*!sc*/
@media (min-width: 0px) {
  .caSaty {
    font-size: 2.5rem;
    line-height: 2.75rem;
  }
}

/*!sc*/
@media (min-width: 720px) {
  .caSaty {
    font-size: 3rem;
    line-height: 3.5rem;
  }
}

/*!sc*/
.hVFdAj {
  font-family: Feature Text LC, serif;
  font-weight: 400;
  color: #151515;
  font-size: 1.5rem;
  line-height: 2rem;
}

/*!sc*/
@media (min-width: 0px) {
  .hVFdAj {
    font-size: 1.5rem;
    line-height: 2rem;
  }
}

/*!sc*/
@media (min-width: 1032px) {
  .hVFdAj {
    font-size: 2rem;
    line-height: 2.5rem;
  }
}

/*!sc*/
.hWAWcS {
  font-family: Feature Text LC, serif;
  font-weight: 400;
  color: #151515;
  font-size: 2rem;
  line-height: 2.5rem;
}

/*!sc*/
@media (min-width: 0px) {
  .hWAWcS {
    font-size: 2rem;
    line-height: 2.5rem;
  }
}

/*!sc*/
@media (min-width: 720px) {
  .hWAWcS {
    font-size: 3rem;
    line-height: 3.5rem;
  }
}

/*!sc*/
.itVhGI {
  font-family: Feature Text LC, serif;
  font-weight: 400;
  color: #151515;
  font-size: 1.5rem;
  line-height: 2rem;
}

/*!sc*/
.eNgEXm {
  font-family: Feature Text LC, serif;
  font-weight: 400;
  color: #151515;
  font-size: 2rem;
  line-height: 2.5rem;
}

/*!sc*/
@media (min-width: 0px) {
  .eNgEXm {
    font-size: 2rem;
    line-height: 2.5rem;
  }
}

/*!sc*/
@media (min-width: 1032px) {
  .eNgEXm {
    font-size: 2.5rem;
    line-height: 2.75rem;
  }
}

/*!sc*/
@media (min-width: 1440px) {
  .eNgEXm {
    font-size: 3rem;
    line-height: 3.5rem;
  }
}

/*!sc*/
.jtKwaN {
  font-family: Feature Text LC, serif;
  font-weight: 400;
  color: #151515;
  font-size: 2rem;
  line-height: 2.5rem;
}

/*!sc*/
@media (min-width: 0px) {
  .jtKwaN {
    font-size: 2rem;
    line-height: 2.5rem;
  }
}

/*!sc*/
@media (min-width: 1440px) {
  .jtKwaN {
    font-size: 2.5rem;
    line-height: 2.75rem;
  }
}

/*!sc*/
@media (min-width: 1600px) {
  .jtKwaN {
    font-size: 3rem;
    line-height: 3.5rem;
  }
}

/*!sc*/
.iUAACH {
  font-family: Feature Text LC, serif;
  font-weight: 400;
  color: #ffffff;
  font-size: 2rem;
  line-height: 2.5rem;
}

/*!sc*/
@media (min-width: 0px) {
  .iUAACH {
    font-size: 2rem;
    line-height: 2.5rem;
  }
}

/*!sc*/
@media (min-width: 720px) {
  .iUAACH {
    font-size: 2.5rem;
    line-height: 2.75rem;
  }
}

/*!sc*/
@media (min-width: 1440px) {
  .iUAACH {
    font-size: 3rem;
    line-height: 3.5rem;
  }
}

/*!sc*/
data-styled.g62[id="sc-gXfVKN"] {
  content: "kvQnlj,caSaty,hVFdAj,hWAWcS,itVhGI,eNgEXm,jtKwaN,iUAACH,"
}

/*!sc*/
.ewlJBf > *:first-child {
  margin-top: 0;
}

/*!sc*/
@media (min-width: 1032px) {
  .ewlJBf > *:first-child {
    margin-top: 0;
  }
}

/*!sc*/
.ewlJBf > *:last-child {
  margin-bottom: 0;
}

/*!sc*/
@media (min-width: 1032px) {
  .ewlJBf > *:last-child {
    margin-bottom: 0;
  }
}

/*!sc*/
data-styled.g65[id="style__StyledText-sc-eykdt1-0"] {
  content: "ewlJBf,"
}

/*!sc*/
.fUyLx {
  color: inherit;
  margin-bottom: 0;
}

/*!sc*/
.fUyLx + p {
  margin-top: 8px;
}

/*!sc*/
data-styled.g66[id="style__StyledParagraph-sc-eykdt1-1"] {
  content: "fUyLx,"
}

/*!sc*/
.fVwJBM {
  color: inherit;
}

/*!sc*/
data-styled.g69[id="style__StyledItalic-sc-eykdt1-4"] {
  content: "fVwJBM,"
}

/*!sc*/
.XRDym {
  padding: 0;
  margin: 8px 0;
}

/*!sc*/
.XRDym > li + li {
  margin-top: 8px;
}

/*!sc*/
.XRDym ul,
.XRDym ol {
  margin: 8px 0 0;
}

/*!sc*/
@media (min-width: 1032px) {

  .XRDym ul,
  .XRDym ol {
    margin: 8px 0 0;
  }
}

/*!sc*/
.XRDym > li {
  display: block;
  padding-left: 20px;
  position: relative;
}

/*!sc*/
.XRDym > li::before {
  content: '';
  display: block;
  width: 12px;
  height: 12px;
  background-color: currentcolor;
  border-radius: 50%;
  position: absolute;
  left: 0;
  top: 6px;
}

/*!sc*/
data-styled.g72[id="style__StyledUl-sc-eykdt1-7"] {
  content: "XRDym,"
}

/*!sc*/
.kcSChc {
  padding: 0px;
}

/*!sc*/
.cXOOJw {
  padding: 4px 0px;
}

/*!sc*/
.yQObT {
  background-color: #f6f4ef;
  padding: 64px 0px 0px;
}

/*!sc*/
.hVfNzt {
  background-color: #f6f4ef;
  padding: 64px 16px 48px;
}

/*!sc*/
@media (min-width: 0px) {
  .hVfNzt {
    padding: 64px 16px 48px;
  }
}

/*!sc*/
@media (min-width: 720px) {
  .hVfNzt {
    padding: 64px 96px 48px;
  }
}

/*!sc*/
@media (min-width: 1032px) {
  .hVfNzt {
    padding: 128px 32px 48px;
  }
}

/*!sc*/
@media (min-width: 1440px) {
  .hVfNzt {
    padding: 128px 0px 48px;
  }
}

/*!sc*/
.bzlmPm {
  padding: 24px 0px;
}

/*!sc*/
data-styled.g90[id="sc-ciSkZP"] {
  content: "kcSChc,cXOOJw,yQObT,hVfNzt,bzlmPm,"
}

/*!sc*/
.cqQAFN {
  -webkit-text-decoration: none;
  text-decoration: none;
  min-width: 148px;
  width: calc(50% - 0.5rem);
}

/*!sc*/
@media (min-width: 720px) {
  .cqQAFN {
    width: calc(100% / 3 - 0.75rem);
  }
}

/*!sc*/
@media (min-width: 1032px) {
  .cqQAFN {
    width: calc(50% - 0.75rem);
  }
}

/*!sc*/
@media (min-width: 720px) {
  .cqQAFN {
    min-width: 146px;
  }
}

/*!sc*/
@media (min-width: 1440px) {
  .cqQAFN {
    width: calc(45% - 0.75rem);
  }
}

/*!sc*/
.gAMfoi {
  -webkit-text-decoration: none;
  text-decoration: none;
  min-width: 148px;
  width: calc(50% - 0.5rem);
}

/*!sc*/
@media (min-width: 720px) {
  .gAMfoi {
    width: calc(100% / 3 - 0.75rem);
  }
}

/*!sc*/
@media (min-width: 720px) {
  .gAMfoi {
    min-width: 166px;
  }
}

/*!sc*/
@media (min-width: 1440px) {
  .gAMfoi {
    min-width: 172px;
    width: calc(100% / 5 - 1rem);
  }
}

/*!sc*/
data-styled.g91[id="style__StyledLink-sc-1xmwttv-0"] {
  content: "cqQAFN,gAMfoi,"
}

/*!sc*/
.hfChhU {
  background: #ffffff;
  border: 1px solid #e7e5e2;
  border-radius: 12px;
  padding: 0.75rem 0.5rem 0.75rem 0.75rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  gap: 4px;
}

/*!sc*/
.hfChhU:hover {
  border: 1px solid #d7d4cf;
}

/*!sc*/
.hfChhU:active {
  border: 1px solid #b6b2a8;
}

/*!sc*/
@media (min-width: 1032px) {
  .hfChhU {
    gap: 8px;
  }
}

/*!sc*/
@media (min-width: 1440px) {
  .hfChhU {
    padding: 1rem;
  }
}

/*!sc*/
data-styled.g92[id="style__LanguageItem-sc-1xmwttv-1"] {
  content: "hfChhU,"
}

/*!sc*/
@media (min-width: 720px) {
  .PwXXo {
    margin: 0 -29px;
  }
}

/*!sc*/
@media (min-width: 1032px) {
  .PwXXo {
    margin: 0 -101px;
  }
}

/*!sc*/
@media (min-width: 1440px) {
  .PwXXo {
    margin: 0 -227px;
  }
}

/*!sc*/
@media (min-width: 1600px) {
  .PwXXo {
    margin: 0 -233px;
  }
}

/*!sc*/
data-styled.g111[id="style__FlagsCtaWrap-sc-1mm9dyl-2"] {
  content: "foYaKp,PwXXo,"
}

/*!sc*/
.csCCsR {
  width: 100%;
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

/*!sc*/
@media (min-width: 720px) {
  .csCCsR {
    max-width: 472px;
  }
}

/*!sc*/
@media (min-width: 1032px) {
  .csCCsR {
    max-width: none;
    width: calc(50% - 16px);
    padding: 0 68px 0 0;
  }
}

/*!sc*/
@media (min-width: 1032px) {
  .csCCsR {
    padding-right: 94px;
  }
}

/*!sc*/
@media (min-width: 1600px) {
  .csCCsR {
    padding: 0;
  }
}

/*!sc*/
.dBgrDM {
  width: 100%;
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

/*!sc*/
@media (min-width: 720px) {
  .dBgrDM {
    max-width: 472px;
  }
}

/*!sc*/
@media (min-width: 1032px) {
  .dBgrDM {
    max-width: 538px;
  }
}

/*!sc*/
@media (min-width: 1440px) {
  .dBgrDM {
    max-width: 544px;
  }
}

/*!sc*/
@media (min-width: 1600px) {
  .dBgrDM {
    max-width: 732px;
  }
}

/*!sc*/
data-styled.g112[id="style__ContentWrap-sc-1cerv0a-0"] {
  content: "csCCsR,dBgrDM,"
}

/*!sc*/
.jraLUj {
  max-width: 100%;
}

/*!sc*/
@media (min-width: 1032px) {
  .jraLUj {
    -webkit-align-items: flex-start;
    -webkit-box-align: flex-start;
    -ms-flex-align: flex-start;
    align-items: flex-start;
    width: 335px;
  }
}

/*!sc*/
@media (min-width: 1440px) {
  .jraLUj {
    width: 449px;
  }
}

/*!sc*/
@media (min-width: 1600px) {
  .jraLUj {
    width: 480px;
  }
}

/*!sc*/
.gWsifU {
  max-width: 100%;
}

/*!sc*/
@media (min-width: 1032px) {
  .gWsifU {
    max-width: 538px;
  }
}

/*!sc*/
@media (min-width: 1440px) {
  .gWsifU {
    max-width: 544px;
  }
}

/*!sc*/
@media (min-width: 1600px) {
  .gWsifU {
    max-width: 732px;
  }
}

/*!sc*/
data-styled.g113[id="style__ContentStack-sc-1cerv0a-1"] {
  content: "jraLUj,gWsifU,"
}

/*!sc*/
.ckdlSz {
  text-align: center;
}

/*!sc*/
@media (min-width: 1032px) {
  .ckdlSz {
    text-align: left;
  }
}

/*!sc*/
.ckdlSz em {
  color: #fe4d01;
}

/*!sc*/
.dMnzJW {
  text-align: center;
}

/*!sc*/
.dMnzJW em {
  color: #ffffff;
}

/*!sc*/
data-styled.g114[id="style__StyledTitle-sc-1cerv0a-2"] {
  content: "ckdlSz,dMnzJW,"
}

/*!sc*/
.cVqDFM {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-align-self: stretch;
  -ms-flex-item-align: stretch;
  align-self: stretch;
  gap: 12px;
}

/*!sc*/
@media (min-width: 1032px) {
  .cVqDFM {
    -webkit-box-pack: start;
    -webkit-justify-content: flex-start;
    -ms-flex-pack: start;
    justify-content: flex-start;
  }
}

/*!sc*/
.glJsmd {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-align-self: stretch;
  -ms-flex-item-align: stretch;
  align-self: stretch;
  gap: 12px;
}

/*!sc*/
@media (min-width: 1032px) {
}

/*!sc*/
data-styled.g116[id="style__CtaGroup-sc-1cerv0a-4"] {
  content: "cVqDFM,glJsmd,"
}

/*!sc*/
.hOTwLl {
  background-color: #fe4d01;
  overflow: hidden;
  display: block;
}

/*!sc*/
.hOTwLl.fade-in {
  -webkit-animation-name: fade-in;
  animation-name: fade-in;
  -webkit-animation-duration: 2s;
  animation-duration: 2s;
  -webkit-transition-timing-function: ease-in;
  transition-timing-function: ease-in;
}

/*!sc*/
@-webkit-keyframes fade-in {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

/*!sc*/
@keyframes fade-in {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

/*!sc*/
data-styled.g117[id="style__StyledBanner-sc-ewimuq-0"] {
  content: "hOTwLl,"
}

/*!sc*/
.dfmKUc {
  max-width: 1200px;
  margin: 0 auto;
  padding: 4px 16px;
}

/*!sc*/
data-styled.g118[id="style__StyledWrapper-sc-ewimuq-1"] {
  content: "dfmKUc,"
}

/*!sc*/
.krXIeu {
  margin: 0 -32px;
  min-height: 58px;
}

/*!sc*/
data-styled.g119[id="style__StyledContentContainer-sc-ewimuq-2"] {
  content: "krXIeu,"
}

/*!sc*/
.etpjCD {
  margin: 0 -12px;
  padding: 0 32px;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

/*!sc*/
data-styled.g120[id="style__StyledContentGroup-sc-ewimuq-3"] {
  content: "etpjCD,"
}

/*!sc*/
.dRVrLC {
  padding: 4px 12px;
  text-align: center;
}

/*!sc*/
data-styled.g121[id="style__StyledContentItem-sc-ewimuq-4"] {
  content: "dRVrLC,"
}

/*!sc*/
.eWOCqZ {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-flex-shrink: 0;
  -ms-flex-negative: 0;
  flex-shrink: 0;
  box-sizing: border-box;
  overflow: hidden;
  background: #ffffff;
  border-radius: 12px;
  outline: none;
  padding: 16px;
}

/*!sc*/
data-styled.g126[id="sc-jgPyTC"] {
  content: "eWOCqZ,"
}

/*!sc*/
.ckdfwA {
  font-family: Graphik Linkmeetion LCG, sans-serif;
  font-weight: 600;
  color: #151515;
  font-size: 1.25rem;
  line-height: 1.5rem;
}

/*!sc*/
data-styled.g128[id="sc-laZMeE"] {
  content: "ckdfwA,"
}

/*!sc*/
.hYLqAP {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-align-items: stretch;
  -webkit-box-align: stretch;
  -ms-flex-align: stretch;
  align-items: stretch;
  border-radius: 4px;
  max-width: 480px;
  padding: 0;
}

/*!sc*/
data-styled.g129[id="style__StyledInfoCard-sc-7xtyb1-0"] {
  content: "hYLqAP,"
}

/*!sc*/
.euyJux {
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}

/*!sc*/
data-styled.g130[id="style__ContentContainer-sc-7xtyb1-1"] {
  content: "euyJux,"
}

/*!sc*/
.eJOqZF {
  padding: 0.5rem;
  border-radius: 8px;
  background-color: #ffd6c4;
  margin-bottom: 1.5rem;
}

/*!sc*/
.bUqnIH {
  padding: 0.5rem;
  border-radius: 8px;
  background-color: #e0c3fd;
  margin-bottom: 1.5rem;
}

/*!sc*/
data-styled.g131[id="style__Tag-sc-7xtyb1-2"] {
  content: "eJOqZF,bUqnIH,"
}

/*!sc*/
.eXFwRQ {
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
}

/*!sc*/
data-styled.g132[id="style__StyledStack-sc-7xtyb1-3"] {
  content: "eXFwRQ,"
}

/*!sc*/
.kNYlsR ul {
  list-style: none;
}

/*!sc*/
.kNYlsR ul li {
  list-style: none;
  position: relative;
  padding-left: 32px;
}

/*!sc*/
.kNYlsR ul li::before {
  content: none;
}

/*!sc*/
.kNYlsR ul li > .icon-checkmark {
  position: absolute;
  top: 0;
  left: 0;
}

/*!sc*/
data-styled.g134[id="style__StyledRichText-sc-7xtyb1-5"] {
  content: "kNYlsR,"
}

/*!sc*/
.jIMvGy {
  margin: 0 auto;
  text-align: center;
  padding: 0 16px;
  max-width: 512px;
}

/*!sc*/
@media (min-width: 720px) {
  .jIMvGy {
    padding: 0;
    max-width: 471px;
  }
}

/*!sc*/
@media (min-width: 1032px) {
  .jIMvGy {
    max-width: 551px;
  }
}

/*!sc*/
@media (min-width: 1440px) {
  .jIMvGy {
    max-width: 545px;
  }
}

/*!sc*/
@media (min-width: 1600px) {
  .jIMvGy {
    max-width: 480px;
  }
}

/*!sc*/
data-styled.g135[id="style__RootContentWrapper-sc-ivk0j3-0"] {
  content: "jIMvGy,"
}

/*!sc*/
.jXuDmg em {
  color: #fe4d01;
}

/*!sc*/
data-styled.g136[id="style__StyledTitle-sc-ivk0j3-1"] {
  content: "jXuDmg,"
}

/*!sc*/
.cAwmgW {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  padding: 32px 0;
  margin: 0 auto;
}

/*!sc*/
@media (min-width: 720px) {
  .cAwmgW {
    padding: 48px 0;
  }
}

/*!sc*/
@media (min-width: 1032px) {
  .cAwmgW {
    padding: 32px 0;
    margin: 0 auto;
    max-width: 1600px;
  }
}

/*!sc*/
@media (min-width: 1440px) {
  .cAwmgW {
    padding: 48px 0;
  }
}

/*!sc*/
data-styled.g137[id="style__SliderItemsContainer-sc-ivk0j3-2"] {
  content: "cAwmgW,"
}

/*!sc*/
.fDpTMZ {
  height: 100%;
}

/*!sc*/
@media (min-width: 1032px) {
  .fDpTMZ {
    width: 408px;
  }
}

/*!sc*/
@media (min-width: 1440px) {
  .fDpTMZ {
    width: 448px;
  }
}

/*!sc*/
@media (min-width: 1600px) {
  .fDpTMZ {
    width: 480px;
  }
}

/*!sc*/
.fDpTMZ > * {
  height: 100%;
}

/*!sc*/
data-styled.g138[id="style__StyledSliderItemInner-sc-ivk0j3-3"] {
  content: "fDpTMZ,"
}

/*!sc*/
.krsGCC {
  padding: 12px 16px;
  width: 512px;
}

/*!sc*/
@media (min-width: 720px) {
  .krsGCC {
    padding: 12px 64px;
    width: 608px;
  }
}

/*!sc*/
@media (min-width: 1032px) {
  .krsGCC {
    padding: 12px;
    width: auto;
  }
}

/*!sc*/
@media (min-width: 1440px) {
  .krsGCC {
    padding: 16px;
  }
}

/*!sc*/
.krsGCC:first-child {
  padding-top: 0;
}

/*!sc*/
@media (min-width: 1032px) {
  .krsGCC:first-child {
    padding-top: 12px;
  }
}

/*!sc*/
@media (min-width: 1440px) {
  .krsGCC:first-child {
    padding-top: 16px;
  }
}

/*!sc*/
@media (min-width: 1032px) {
  .krsGCC:first-child {
    padding-left: 12px;
  }
}

/*!sc*/
@media (min-width: 1440px) {
  .krsGCC:first-child {
    padding-left: 16px;
  }
}

/*!sc*/
.krsGCC:last-child {
  padding-bottom: 0;
}

/*!sc*/
@media (min-width: 1032px) {
  .krsGCC:last-child {
    padding-bottom: 12px;
  }
}

/*!sc*/
@media (min-width: 1440px) {
  .krsGCC:last-child {
    padding-bottom: 16px;
  }
}

/*!sc*/
@media (min-width: 1032px) {
  .krsGCC:last-child {
    padding-right: 12px;
  }
}

/*!sc*/
@media (min-width: 1440px) {
  .krsGCC:last-child {
    padding-right: 16px;
  }
}

/*!sc*/
data-styled.g139[id="style__StyledSliderItem-sc-ivk0j3-4"] {
  content: "krsGCC,"
}

/*!sc*/
.crjqVb {
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
}

/*!sc*/
@media (min-width: 1032px) {
  .crjqVb {
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    -ms-flex-pack: justify;
    justify-content: space-between;
    max-width: 900px;
    margin: 0 auto;
  }
}

/*!sc*/
@media (min-width: 1440px) {
  .crjqVb {
    max-width: 932px;
  }
}

/*!sc*/
@media (min-width: 1600px) {
  .crjqVb {
    max-width: 1252px;
  }
}

/*!sc*/
.cJEUxi {
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
}

/*!sc*/
@media (min-width: 1032px) {
  .cJEUxi {
    -webkit-flex-direction: row-reverse;
    -ms-flex-direction: row-reverse;
    flex-direction: row-reverse;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    -ms-flex-pack: justify;
    justify-content: space-between;
    max-width: 900px;
    margin: 0 auto;
  }
}

/*!sc*/
@media (min-width: 1440px) {
  .cJEUxi {
    max-width: 932px;
  }
}

/*!sc*/
@media (min-width: 1600px) {
  .cJEUxi {
    max-width: 1252px;
  }
}

/*!sc*/
data-styled.g142[id="style__StyledLayout-sc-1qtvo0c-0"] {
  content: "crjqVb,cJEUxi,"
}

/*!sc*/
.dszIqw {
  max-width: 100%;
}

/*!sc*/
@media (min-width: 720px) {
  .dszIqw {
    -webkit-order: 2;
    -ms-flex-order: 2;
    order: 2;
  }
}

/*!sc*/
@media (min-width: 1032px) {
  .dszIqw {
    -webkit-order: inherit;
    -ms-flex-order: inherit;
    order: inherit;
    max-width: 404px;
  }
}

/*!sc*/
@media (min-width: 1440px) {
  .dszIqw {
    max-width: 450px;
  }
}

/*!sc*/
@media (min-width: 1600px) {
  .dszIqw {
    max-width: 610px;
  }
}

/*!sc*/
data-styled.g143[id="style__InfoBlockImage-sc-1qtvo0c-1"] {
  content: "dszIqw,"
}

/*!sc*/
@media (min-width: 1032px) {
  .iUTHsV {
    -webkit-align-items: flex-start;
    -webkit-box-align: flex-start;
    -ms-flex-align: flex-start;
    align-items: flex-start;
    width: 334px;
  }
}

/*!sc*/
@media (min-width: 1440px) {
  .iUTHsV {
    width: 351px;
  }
}

/*!sc*/
@media (min-width: 1600px) {
  .iUTHsV {
    width: 482px;
  }
}

/*!sc*/
data-styled.g145[id="style__ContentLayout-sc-1qtvo0c-3"] {
  content: "iUTHsV,"
}

/*!sc*/
.iHKGjX {
  text-align: center;
}

/*!sc*/
@media (min-width: 1032px) {
  .iHKGjX {
    margin: 0 auto;
    width: 692px;
  }
}

/*!sc*/
@media (min-width: 1440px) {
  .iHKGjX {
    width: 736px;
  }
}

/*!sc*/
data-styled.g146[id="style__RootContentWrapper-sc-nk2gyy-0"] {
  content: "iHKGjX,"
}

/*!sc*/
.kuOEDh em {
  color: #fe4d01;
}

/*!sc*/
data-styled.g147[id="style__StyledTitle-sc-nk2gyy-1"] {
  content: "kuOEDh,"
}

/*!sc*/
.iiTVnb {
  text-align: center;
  max-width: 512px;
  padding: 64px 16px 24px;
  margin: 0 auto;
}

/*!sc*/
@media (min-width: 1032px) {
  .iiTVnb {
    padding-top: 0;
    padding-bottom: 64px;
  }
}

/*!sc*/
data-styled.g148[id="style__HeadingWrapper-sc-qlia4f-0"] {
  content: "iiTVnb,"
}

/*!sc*/
.kGzbrM em {
  color: #151515;
}

/*!sc*/
.bcQXMu em {
  color: #fe4d01;
}

/*!sc*/
data-styled.g149[id="style__StyledTitle-sc-qlia4f-1"] {
  content: "kGzbrM,bcQXMu,"
}

/*!sc*/
.laSVXZ {
  background-color: #ffd966;
  text-align: center;
  margin: 0 auto;
  padding: 0 24px 64px;
  max-width: 1216px;
}

/*!sc*/
@media (min-width: 1032px) {
  .laSVXZ {
    padding: 0 24px;
  }
}

/*!sc*/
.hmrTel {
  background-color: #f6f4ef;
  text-align: center;
  margin: 0 auto;
  padding: 0 24px 64px;
  max-width: 1216px;
}

/*!sc*/
@media (min-width: 1032px) {
  .hmrTel {
    padding: 0 24px;
  }
}

/*!sc*/
data-styled.g150[id="style__RoundedColoredContainer-sc-qlia4f-2"] {
  content: "laSVXZ,hmrTel,"
}

/*!sc*/
.jHFrmi > div {
  max-width: 472px;
}

/*!sc*/
@media (min-width: 1032px) {
  .jHFrmi {
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    -ms-flex-pack: justify;
    justify-content: space-between;
  }

  .jHFrmi > div {
    width: 33%;
    max-width: none;
  }
}

/*!sc*/
data-styled.g151[id="style__ItemsContainer-sc-qlia4f-3"] {
  content: "jHFrmi,"
}

/*!sc*/
.dnFXqV {
  background-color: #ffd966;
}

/*!sc*/
@media (min-width: 1032px) {
  .dnFXqV {
    padding: 64px 0;
  }
}

/*!sc*/
.kNstvp {
  background-color: #f6f4ef;
}

/*!sc*/
@media (min-width: 1032px) {
  .kNstvp {
    padding: 64px 0;
  }
}

/*!sc*/
data-styled.g152[id="style__StyledSection-sc-qlia4f-4"] {
  content: "dnFXqV,kNstvp,"
}

/*!sc*/
.dHKQVL {
  -webkit-flex: 1 0 auto;
  -ms-flex: 1 0 auto;
  flex: 1 0 auto;
}

/*!sc*/
data-styled.g153[id="style__ContentStack-sc-16uiq8m-0"] {
  content: "dHKQVL,"
}

/*!sc*/
.gKAjpz {
  margin-top: auto;
}

/*!sc*/
data-styled.g154[id="style__CtaWrap-sc-16uiq8m-1"] {
  content: "gKAjpz,"
}

/*!sc*/
.kFeecE {
  border-top: 1px solid #d7d4cf;
}

/*!sc*/
data-styled.g158[id="style__StyledSeparator-sc-m51m41-0"] {
  content: "kFeecE,"
}

/*!sc*/
.gtGBoW {
  text-align: center;
  width: calc(100% - 2rem);
  max-width: 1168px;
  margin: 0 auto;
  white-space: pre-wrap;
}

/*!sc*/
data-styled.g159[id="style__StyledPara-sc-m51m41-1"] {
  content: "gtGBoW,"
}

/*!sc*/
.fxfLkq {
  background: #ffd966;
  padding: 48px 16px;
}

/*!sc*/
@media (min-width: 1032px) {
  .fxfLkq {
    padding: 96px 0;
  }
}

/*!sc*/
@media (min-width: 1600px) {
  .fxfLkq {
    padding: 128px 0;
  }
}

/*!sc*/
data-styled.g217[id="style__Section-sc-174o5v9-0"] {
  content: "fxfLkq,"
}

/*!sc*/
.kA-dppG {
  max-width: 840px;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  gap: 48px;
}

/*!sc*/
@media (min-width: 720px) {
  .kA-dppG {
    gap: 64px;
  }
}

/*!sc*/
@media (min-width: 1032px) {
  .kA-dppG {
    gap: 32px;
  }
}

/*!sc*/
@media (min-width: 1600px) {
  .kA-dppG {
    max-width: none;
    width: 1377px;
    margin-right: -127px;
  }
}

/*!sc*/
data-styled.g218[id="style__Container-sc-174o5v9-1"] {
  content: "kA-dppG,"
}

/*!sc*/
.eSdPCh {
  -webkit-flex: 0 0 auto;
  -ms-flex: 0 0 auto;
  flex: 0 0 auto;
}

/*!sc*/
@media (min-width: 1600px) {
  .eSdPCh {
    width: 353px;
  }
}

/*!sc*/
data-styled.g219[id="style__StyledHeadingsAndControls-sc-174o5v9-2"] {
  content: "eSdPCh,"
}

/*!sc*/
.dtiOOA {
  overflow-x: scroll;
  -webkit-scroll-behavior: smooth;
  -moz-scroll-behavior: smooth;
  -ms-scroll-behavior: smooth;
  scroll-behavior: smooth;
  -webkit-scroll-snap-type: x mandatory;
  -moz-scroll-snap-type: x mandatory;
  -ms-scroll-snap-type: x mandatory;
  scroll-snap-type: x mandatory;
  -webkit-scrollbar-width: none;
  -moz-scrollbar-width: none;
  -ms-scrollbar-width: none;
  scrollbar-width: none;
}

/*!sc*/
@media (min-width: 1600px) {
  .dtiOOA {
    width: 990px;
  }
}

/*!sc*/
.dtiOOA::-webkit-scrollbar {
  display: none;
}

/*!sc*/
data-styled.g221[id="style__SlidesWrap-sc-174o5v9-4"] {
  content: "dtiOOA,"
}

/*!sc*/
.kHVnUE {
  gap: 32px;
  width: calc(300% + 2 * 32px);
}

/*!sc*/
data-styled.g222[id="style__Slides-sc-174o5v9-5"] {
  content: "kHVnUE,"
}

/*!sc*/
.ePHhhW {
  -webkit-flex: 1 0 1%;
  -ms-flex: 1 0 1%;
  flex: 1 0 1%;
  -webkit-scroll-snap-align: start;
  -moz-scroll-snap-align: start;
  -ms-scroll-snap-align: start;
  scroll-snap-align: start;
}

/*!sc*/
data-styled.g223[id="style__StyledSlide-sc-174o5v9-6"] {
  content: "ePHhhW,"
}

/*!sc*/
.fIfHTS {
  gap: 48px;
}

/*!sc*/
@media (min-width: 720px) {
  .fIfHTS {
    gap: 64px;
  }
}

/*!sc*/
@media (min-width: 1032px) {
  .fIfHTS {
    gap: 32px;
  }
}

/*!sc*/
data-styled.g224[id="style__SlideInner-sc-174o5v9-7"] {
  content: "fIfHTS,"
}

/*!sc*/
@media (min-width: 1032px) {
  .lnWiVb {
    -webkit-flex: 0 0 calc(50% - 16px);
    -ms-flex: 0 0 calc(50% - 16px);
    flex: 0 0 calc(50% - 16px);
  }
}

/*!sc*/
data-styled.g225[id="style__Blockquote-sc-174o5v9-8"] {
  content: "lnWiVb,"
}

/*!sc*/
.jIBvNH {
  padding-top: 12px;
  font-family: Feature Text LC;
  font-size: 1.5rem;
  line-height: 2rem;
}

/*!sc*/
data-styled.g226[id="style__Quote-sc-174o5v9-9"] {
  content: "jIBvNH,"
}

/*!sc*/
.cWcsf {
  background: #ffffff;
}

/*!sc*/
data-styled.g227[id="style__Section-sc-y6lmol-0"] {
  content: "cWcsf,"
}

/*!sc*/
.gBMQaI {
  margin: 0 auto;
  max-width: 1200px;
  padding: 64px 16px 40px;
}

/*!sc*/
@media (min-width: 720px) {
  .gBMQaI {
    padding-bottom: 16px;
  }
}

/*!sc*/
data-styled.g228[id="style__Container-sc-y6lmol-1"] {
  content: "gBMQaI,"
}

/*!sc*/
.jittYR {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin: 0 -12px;
}

/*!sc*/
@media (min-width: 1032px) {
  .jittYR {
    -webkit-flex-wrap: nowrap;
    -ms-flex-wrap: nowrap;
    flex-wrap: nowrap;
  }
}

/*!sc*/
@media (min-width: 1600px) {
  .jittYR {
    margin: 0 -24px;
  }
}

/*!sc*/
data-styled.g229[id="style__Columns-sc-y6lmol-2"] {
  content: "jittYR,"
}

/*!sc*/
.hlrPlw {
  -webkit-flex: 0 0 100%;
  -ms-flex: 0 0 100%;
  flex: 0 0 100%;
  padding: 0 12px 20px;
}

/*!sc*/
@media (min-width: 720px) {
  .hlrPlw {
    -webkit-flex-basis: 50%;
    -ms-flex-preferred-size: 50%;
    flex-basis: 50%;
    padding-bottom: 44px;
  }
}

/*!sc*/
@media (min-width: 1032px) {
  .hlrPlw {
    -webkit-flex-basis: 25%;
    -ms-flex-preferred-size: 25%;
    flex-basis: 25%;
  }
}

/*!sc*/
@media (min-width: 1600px) {
  .hlrPlw {
    padding-left: 24px;
    padding-right: 24px;
  }
}

/*!sc*/
data-styled.g230[id="style__StyledColumn-sc-y6lmol-3"] {
  content: "hlrPlw,"
}

/*!sc*/
.iVFVDY {
  padding: 4px 0 16px;
}

/*!sc*/
data-styled.g231[id="style__Headline-sc-y6lmol-4"] {
  content: "iVFVDY,"
}

/*!sc*/
.gdZsut {
  margin: 0;
  padding-left: 0;
  list-style: none;
}

/*!sc*/
data-styled.g232[id="style__List-sc-y6lmol-5"] {
  content: "gdZsut,"
}

/*!sc*/
.fyMqjH {
  list-style: none;
  padding-bottom: 8px;
}

/*!sc*/
data-styled.g233[id="style__ListItem-sc-y6lmol-6"] {
  content: "fyMqjH,"
}

/*!sc*/
</style>
<style>
.gatsby-image-wrapper {
  position: relative;
  overflow: hidden
}

.gatsby-image-wrapper picture.object-fit-polyfill {
  position: static !important
}

.gatsby-image-wrapper img {
  bottom: 0;
  height: 100%;
  left: 0;
  margin: 0;
  max-width: none;
  padding: 0;
  position: absolute;
  right: 0;
  top: 0;
  width: 100%;
  object-fit: cover
}

.gatsby-image-wrapper {
  /* opacity: 0; */
  transform: translateZ(0);
  transition: opacity .25s linear;
  will-change: opacity
}

.gatsby-image-wrapper-constrained {
  display: inline-block;
  vertical-align: top
}
</style>